import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Time: { input: any; output: any; }
};

export type Agreement = {
  __typename?: 'Agreement';
  /** Attached files to the agreement */
  attachments: Array<UploadedFileV2>;
  companyContactEmail: Scalars['String']['output'];
  companyContactName: Scalars['String']['output'];
  companyContactPhone: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  /** The date when the agreement was created */
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notes: Array<AgreementNote>;
  title: Scalars['String']['output'];
  /** The date when the agreement expires */
  validUntil: Scalars['Time']['output'];
};

export type AgreementCreateInput = {
  companyContactEmail?: InputMaybe<Scalars['String']['input']>;
  companyContactName?: InputMaybe<Scalars['String']['input']>;
  companyContactPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  expiresAt: Scalars['Time']['input'];
  title: Scalars['String']['input'];
};

export type AgreementNote = {
  __typename?: 'AgreementNote';
  /** The date when the note was created */
  createdAt: Scalars['Time']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  /** The note message */
  message: Scalars['String']['output'];
};

export type AgreementResult = {
  __typename?: 'AgreementResult';
  agreement?: Maybe<Agreement>;
  error?: Maybe<Scalars['String']['output']>;
};

export type AgreementUpdateInput = {
  companyContactEmail?: InputMaybe<Scalars['String']['input']>;
  companyContactName?: InputMaybe<Scalars['String']['input']>;
  companyContactPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Association = {
  __typename?: 'Association';
  city: Scalars['String']['output'];
  numberOfApartments: Scalars['String']['output'];
  orgAddress: Scalars['String']['output'];
  orgName: Scalars['String']['output'];
  orgNumber: Scalars['String']['output'];
  postal: Scalars['String']['output'];
  registrationYear: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type BannerBlock = BaseBlock & {
  __typename?: 'BannerBlock';
  backgroundColor: Scalars['String']['output'];
  body: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  textColor: Scalars['String']['output'];
};

export type BaseBlock = {
  /** The display name used in control panel */
  displayName: Scalars['String']['output'];
  /** The block ID */
  id: Scalars['ID']['output'];
  /** The target sort order for the block */
  sortOrder: Scalars['Int']['output'];
};

export type Block = BannerBlock | BoardMembersBlock | HeadlineBlock | HeadlineImageBlock | ImageCollectionBlock | TwoColumnBlock;

export enum BlockType {
  BannerBlock = 'BannerBlock',
  BoardMembersBlock = 'BoardMembersBlock',
  HeadlineBlock = 'HeadlineBlock',
  HeadlineImageBlock = 'HeadlineImageBlock',
  ImageCollectionBlock = 'ImageCollectionBlock',
  TwoColumnBlock = 'TwoColumnBlock'
}

export type BoardMemberEntry = {
  __typename?: 'BoardMemberEntry';
  /** General description of the board member */
  description?: Maybe<Scalars['String']['output']>;
  /** The email address of the board member */
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The image URL of the board member */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The full name of the board member */
  name: Scalars['String']['output'];
  /** The phone number of the board member */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The title of the board member */
  title: Scalars['String']['output'];
};

export type BoardMembersBlock = BaseBlock & {
  __typename?: 'BoardMembersBlock';
  boardMembers: Array<BoardMemberEntry>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type BookingCategory = {
  __typename?: 'BookingCategory';
  /** Retrieve all booking entries for a given date range */
  allEntries: Array<BookingEntry>;
  /** Retrieve booking entries for a given date, for the user who requests it */
  entries: Array<BookingEntry>;
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  name: Scalars['String']['output'];
  settings: BookingCategorySettings;
  /** Retrieve available booking slots for a date range */
  slots: Array<BookingSlot>;
};


export type BookingCategoryAllEntriesArgs = {
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};


export type BookingCategoryEntriesArgs = {
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};


export type BookingCategorySlotsArgs = {
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};

export type BookingCategoryCreateOutput = {
  __typename?: 'BookingCategoryCreateOutput';
  bookingCategory?: Maybe<BookingCategory>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BookingCategoryDeleteOutput = {
  __typename?: 'BookingCategoryDeleteOutput';
  error?: Maybe<Scalars['String']['output']>;
};

export type BookingCategorySettings = {
  __typename?: 'BookingCategorySettings';
  /** How many bookings a user can have at the same time, null means no limit */
  maxBookingsPerUser?: Maybe<Scalars['Int']['output']>;
  /** Whether names are visible for other members */
  showNamesOnBookings: Scalars['Boolean']['output'];
};

export type BookingCategoryUpdateInput = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showNamesOnBookings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingCategoryUpdateOutput = {
  __typename?: 'BookingCategoryUpdateOutput';
  bookingCategory?: Maybe<BookingCategory>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BookingEntriesCreateOutput = {
  __typename?: 'BookingEntriesCreateOutput';
  bookingEntries: Array<BookingEntry>;
  error?: Maybe<Scalars['String']['output']>;
  numberOfErrors: Scalars['Int']['output'];
};

export type BookingEntry = {
  __typename?: 'BookingEntry';
  category: BookingCategory;
  end: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['Time']['output'];
  user: User;
};

export type BookingEntryCreateInput = {
  /** The end time of the booking entry */
  end: Scalars['Time']['input'];
  /** The start time of the booking entry */
  start: Scalars['Time']['input'];
};

export type BookingEntryCreateOutput = {
  __typename?: 'BookingEntryCreateOutput';
  bookingEntry?: Maybe<BookingEntry>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BookingSlot = {
  __typename?: 'BookingSlot';
  /** The user who booked this slot, if showNamesOnBookings is true for the category */
  bookedByName: Scalars['String']['output'];
  end: Scalars['Time']['output'];
  start: Scalars['Time']['output'];
  state: BookingSlotState;
  /** The ID of the booking template entry that this slot is based on */
  templateId: Scalars['ID']['output'];
};

export enum BookingSlotState {
  /** Whether the slot is available right now */
  Available = 'AVAILABLE',
  /** Whether the slot was available in the past */
  AvailableInPast = 'AVAILABLE_IN_PAST',
  /** Whether the slot is overlapping with an existing booking entry */
  Overlapping = 'OVERLAPPING'
}

export type BookingSlotsFilter = {
  date?: InputMaybe<Scalars['Time']['input']>;
};

export type BookingTemplateEntry = {
  __typename?: 'BookingTemplateEntry';
  category: BookingCategory;
  day: Scalars['Int']['output'];
  endHour: Scalars['Int']['output'];
  endMinute: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startHour: Scalars['Int']['output'];
  startMinute: Scalars['Int']['output'];
};

export type BookingTemplateEntryCreateInput = {
  categoryId: Scalars['ID']['input'];
  day: Scalars['Int']['input'];
  endHour: Scalars['Int']['input'];
  endMinute: Scalars['Int']['input'];
  startHour: Scalars['Int']['input'];
  startMinute: Scalars['Int']['input'];
};

export type BookingTemplateEntryCreateOutput = {
  __typename?: 'BookingTemplateEntryCreateOutput';
  bookingTemplateEntry?: Maybe<BookingTemplateEntry>;
  error?: Maybe<Scalars['String']['output']>;
};

/**
 * A booking template schedule is a set of entries that will replace the current template entries for a given category.
 * For example, a schedule could be entries from: "every Weekday, from 9:00 to 12:00, and from 13:00 to 17:00".
 */
export type BookingTemplateSchedule = {
  __typename?: 'BookingTemplateSchedule';
  description: Scalars['String']['output'];
  /** The time interval for which the schedule is valid */
  entries: Array<BookingTemplateScheduleEntry>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BookingTemplateScheduleEntry = {
  __typename?: 'BookingTemplateScheduleEntry';
  day: Scalars['Int']['output'];
  endHour: Scalars['Int']['output'];
  endMinute: Scalars['Int']['output'];
  startHour: Scalars['Int']['output'];
  startMinute: Scalars['Int']['output'];
};

export type DemoBookInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DirectoryDeleteOutput = {
  __typename?: 'DirectoryDeleteOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DirectoryRenameOutput = {
  __typename?: 'DirectoryRenameOutput';
  error?: Maybe<Scalars['String']['output']>;
  /** The affected files with new names */
  files?: Maybe<Array<UploadedFileV2>>;
};

export type EmailMessage = {
  __typename?: 'EmailMessage';
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deliveries: Array<MessageDelivery>;
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
};

export type EmailSendMessageInput = {
  body: Scalars['String']['input'];
  receivingUserIds: Array<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
};

export type EmailSendMessageOutput = {
  __typename?: 'EmailSendMessageOutput';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<EmailMessage>;
};

export type Errand = {
  __typename?: 'Errand';
  apartmentNumber: Scalars['String']['output'];
  /** The person assigned this errand, if applicable */
  assignedTo?: Maybe<User>;
  /** The main body of the errand */
  body: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** Whether someone is working on this errand */
  isPending: Scalars['Boolean']['output'];
  /** The person who filed the errand */
  originator: ErrandOriginator;
  /** The current status of the errand */
  status: ErrandStatus;
  /** The errand type */
  type: ErrandType;
};

export type ErrandCreateInput = {
  apartmentNumber: Scalars['String']['input'];
  body: Scalars['String']['input'];
  email: Scalars['String']['input'];
  errandTypeId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  websiteId: Scalars['ID']['input'];
};

export type ErrandCreateOutput = {
  __typename?: 'ErrandCreateOutput';
  error?: Maybe<Scalars['String']['output']>;
};

export type ErrandOriginator = {
  __typename?: 'ErrandOriginator';
  email: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export enum ErrandStatus {
  Active = 'Active',
  Completed = 'Completed'
}

export type ErrandType = {
  __typename?: 'ErrandType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ErrandTypeCreateOutput = {
  __typename?: 'ErrandTypeCreateOutput';
  errandType?: Maybe<ErrandType>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ErrandTypeDeleteOutput = {
  __typename?: 'ErrandTypeDeleteOutput';
  error?: Maybe<Scalars['String']['output']>;
};

export type ErrandTypeUpdateInput = {
  displayName: Scalars['String']['input'];
  errandTypeId: Scalars['String']['input'];
};

export type ErrandTypeUpdateOutput = {
  __typename?: 'ErrandTypeUpdateOutput';
  errandType?: Maybe<ErrandType>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ErrandsFilter = {
  status?: InputMaybe<ErrandStatus>;
};

export type FileCreateUnsortedCopy = {
  __typename?: 'FileCreateUnsortedCopy';
  error?: Maybe<Scalars['String']['output']>;
  file?: Maybe<UploadedFileV2>;
};

export type FileCreateUploadUrlOutput = {
  __typename?: 'FileCreateUploadUrlOutput';
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FileDeleteOutput = {
  __typename?: 'FileDeleteOutput';
  error?: Maybe<Scalars['String']['output']>;
};

export type FileMakePublicCopyOutput = {
  __typename?: 'FileMakePublicCopyOutput';
  error?: Maybe<Scalars['String']['output']>;
  file?: Maybe<UploadedFileV2>;
};

export enum FileNamespace {
  Agreement = 'Agreement',
  General = 'General',
  Public = 'Public'
}

export type FileUpdateInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type FileUpdateOutput = {
  __typename?: 'FileUpdateOutput';
  error?: Maybe<Scalars['String']['output']>;
  file?: Maybe<UploadedFileV2>;
};

export type HeadlineBlock = BaseBlock & {
  __typename?: 'HeadlineBlock';
  displayName: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
};

export type HeadlineImageBlock = BaseBlock & {
  __typename?: 'HeadlineImageBlock';
  displayName: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageLink: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
};

export type ImageCollectionBlock = BaseBlock & {
  __typename?: 'ImageCollectionBlock';
  displayName: Scalars['String']['output'];
  firstCaption: Scalars['String']['output'];
  firstImageLink: Scalars['String']['output'];
  firstImageUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  secondCaption: Scalars['String']['output'];
  secondImageLink: Scalars['String']['output'];
  secondImageUrl: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  thirdCaption: Scalars['String']['output'];
  thirdImageLink: Scalars['String']['output'];
  thirdImageUrl: Scalars['String']['output'];
};

export type InfoPage = {
  __typename?: 'InfoPage';
  blocks: Array<Block>;
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  group?: Maybe<Scalars['String']['output']>;
  groupSlug?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type InfoPageChangeSortOrderInput = {
  infoPageId: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type InfoPageCreateInput = {
  body: Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type InfoPageGroupChangeSortOrderInput = {
  /** The group to change the sort order for */
  infoPageGroup: Scalars['String']['input'];
  /** Member group or info group */
  restricted: Scalars['Boolean']['input'];
  /** The target sort order for the group */
  sortOrder: Scalars['Int']['input'];
};

export type InfoPageUpdateInput = {
  body: Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  infoPageId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type InfoPageUpdateVisibilityOutput = {
  __typename?: 'InfoPageUpdateVisibilityOutput';
  error?: Maybe<Scalars['String']['output']>;
  infoPage?: Maybe<InfoPage>;
};

export type InfoPagesUpdateGroupInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  infoPageIds: Array<Scalars['ID']['input']>;
};

export type Me = {
  __typename?: 'Me';
  /** Retrieve active booking entries for the user who requests it */
  bookingEntries: Array<BookingEntry>;
  notificationSettings: NotificationSettings;
  /** The organization that the signed in user belongs to */
  organization: Organization;
  /** The user currently signed in */
  user: User;
  /** The website that the signed in user belongs to */
  website: Website;
};

export type MeetingParticipant = {
  __typename?: 'MeetingParticipant';
  /** The email of the participant. If user exists, this is populated from the user's email */
  email: Scalars['String']['output'];
  /** If the participant has opened their form */
  hasOpened: Scalars['Boolean']['output'];
  /** If at least one of the timeslots work for the participant. */
  hasVoted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The name of the participant. If user exists, this is populated from the user's name */
  name: Scalars['String']['output'];
  /** If the participant has marked that they can't make it to any of the timeslots. */
  noVote: Scalars['Boolean']['output'];
  /** The user, if the participant is a user. If not, this is null. */
  user?: Maybe<User>;
};

export type MeetingProposal = {
  __typename?: 'MeetingProposal';
  /** The meeting proposal is considered completed */
  completed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  everyoneHasVoted: Scalars['Boolean']['output'];
  /** The message that was sent to the participants when the timeslot was picked. */
  finalMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  participants: Array<MeetingParticipant>;
  /** The timeslot that was picked */
  pickedTimeslot?: Maybe<MeetingTimeslot>;
  timeslots: Array<MeetingTimeslot>;
  title: Scalars['String']['output'];
  /** All votes for all timeslots */
  votes: Array<MeetingProposalVote>;
};

export type MeetingProposalCreateInput = {
  description: Scalars['String']['input'];
  participants: Array<MeetingProposalParticipantInput>;
  timeslots: Array<MeetingProposalTimeslotCreateInput>;
  title: Scalars['String']['input'];
};

export type MeetingProposalParticipantInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MeetingProposalPickTimeslotInput = {
  /** Optional message to the participants. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The target timeslot to pick. */
  timeslotId: Scalars['ID']['input'];
};

export type MeetingProposalResult = {
  __typename?: 'MeetingProposalResult';
  error?: Maybe<Scalars['String']['output']>;
  meetingProposal?: Maybe<MeetingProposal>;
};

export type MeetingProposalTimeslotCreateInput = {
  end: Scalars['Time']['input'];
  start: Scalars['Time']['input'];
};

export type MeetingProposalVote = {
  __typename?: 'MeetingProposalVote';
  id: Scalars['ID']['output'];
  participant: MeetingParticipant;
  timeslot: MeetingTimeslot;
};

export type MeetingTimeslot = {
  __typename?: 'MeetingTimeslot';
  end: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['Time']['output'];
  votes: Array<MeetingProposalVote>;
};

export type MessageDelivery = {
  __typename?: 'MessageDelivery';
  error?: Maybe<Scalars['String']['output']>;
  status: MessageDeliveryStatus;
  user: User;
};

export enum MessageDeliveryStatus {
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Sending = 'SENDING'
}

export type Mutation = {
  __typename?: 'Mutation';
  agreementAddAttachment: Agreement;
  agreementCreate: AgreementResult;
  agreementDelete: Scalars['Boolean']['output'];
  agreementNoteCreate: Agreement;
  agreementNoteDelete: Agreement;
  agreementRemoveAttachment: Agreement;
  agreementUpdate: AgreementResult;
  bookingCategoryCreate: BookingCategoryCreateOutput;
  bookingCategoryDelete: BookingCategoryDeleteOutput;
  bookingCategoryUpdate: BookingCategoryUpdateOutput;
  bookingCategoryUpdateMaxBookingsPerUser: BookingCategory;
  bookingEntriesCreate: BookingEntriesCreateOutput;
  bookingEntryCreate: BookingEntryCreateOutput;
  bookingEntryDelete: Scalars['Boolean']['output'];
  bookingTemplateEntryCreate: BookingTemplateEntryCreateOutput;
  bookingTemplateEntryDelete: Scalars['Boolean']['output'];
  /** Will apply a predetermined schedule to the booking template entries for the given category */
  bookingTemplateScheduleApply: BookingCategory;
  demoBook: Scalars['Boolean']['output'];
  directoryCreate: Scalars['Boolean']['output'];
  directoryDelete: DirectoryDeleteOutput;
  directoryRename: DirectoryRenameOutput;
  emailSendMessage: EmailSendMessageOutput;
  errandAssignToUser: Errand;
  errandClose: Errand;
  errandCreate: ErrandCreateOutput;
  errandInfoUpdate: Organization;
  errandSetPending: Errand;
  errandTypeCreate: ErrandTypeCreateOutput;
  errandTypeDelete: ErrandTypeDeleteOutput;
  errandTypeUpdate: ErrandTypeUpdateOutput;
  errandsExpiryUpdate: Organization;
  featureActivate: Organization;
  featureDisable: Organization;
  fileCreatePublicCopy: FileMakePublicCopyOutput;
  fileCreateUnsortedCopy: FileCreateUnsortedCopy;
  fileCreateUploadUrl: FileCreateUploadUrlOutput;
  fileDelete: FileDeleteOutput;
  fileUpdate: FileUpdateOutput;
  infoPageChangeSortOrder: Array<InfoPage>;
  infoPageCreate: InfoPage;
  infoPageDelete: Scalars['Boolean']['output'];
  infoPageGroupChangeSortOrder: Array<InfoPage>;
  infoPageUpdate: InfoPage;
  infoPageUpdateVisibility: InfoPageUpdateVisibilityOutput;
  infoPagesUpdateGroup: Array<InfoPage>;
  inviteLinkCreate: Organization;
  meetingProposalAddParticipant: MeetingProposalResult;
  meetingProposalAddTimeslot: MeetingProposalResult;
  meetingProposalCreate: MeetingProposalResult;
  meetingProposalDelete: Scalars['Boolean']['output'];
  /** Marks the participant as having opened their form. */
  meetingProposalMarkOpened: MeetingProposal;
  /** No vote means that no of the proposed timeslots work for the participant. */
  meetingProposalNoVote: MeetingProposal;
  meetingProposalPickTimeslot: MeetingProposal;
  meetingProposalRemoveParticipant: MeetingProposal;
  meetingProposalRemoveTimeslot: MeetingProposal;
  meetingProposalUnNoVote: MeetingProposal;
  meetingProposalUnVote: MeetingProposal;
  meetingProposalUpdate: MeetingProposalResult;
  meetingProposalVote: MeetingProposalResult;
  newsEntryCreate: NewsEntry;
  newsEntryDelete: Scalars['Boolean']['output'];
  newsEntryUpdate: NewsEntry;
  notificationSettingsUpdate: Me;
  onboardCodeSend: OnboardCodeSendOutput;
  onboardCodeVerify: OnboardCodeVerifyOutput;
  onboardPushPartial: Scalars['Boolean']['output'];
  organizationUpdate: Organization;
  signIn: SignInOutput;
  signInVerify: SignInVerifyOutput;
  smsSendMessage: SmsSendMessageOutput;
  supportTicketCreate: Scalars['Boolean']['output'];
  userApprove: User;
  userCreate: UserCreateOutput;
  userDelete: Scalars['Boolean']['output'];
  userGroupAddUser: UserGroup;
  userGroupAddUsers: UserGroup;
  userGroupCreate: UserGroupCreateOutput;
  userGroupDelete: Scalars['Boolean']['output'];
  userGroupRemoveUser: UserGroup;
  userGroupRemoveUsers: UserGroup;
  userGroupUpdateName: UserGroupUpdateNameOutput;
  userRegister: UserRegisterOutput;
  userRegisterVerify: UserRegisterVerifyOutput;
  userUpdate: User;
  userUpdateSelf: User;
  /** Change the sort order of a block within a container, and return all blocks in the container */
  websiteBlockChangeSortOrder: WebsiteBlockChangeSortOrderOutput;
  /** Create a new block within a container, and return all blocks in the container */
  websiteBlockCreate: WebsiteBlockCreateOutput;
  websiteBlockDelete: Scalars['Boolean']['output'];
  websiteBlockUpdate: Block;
  websitePublish: Website;
  websiteUnpublish: Website;
  websiteUpdateCustomDomain: WebsiteUpdateCustomDomainOutput;
  websiteUpdateSlug: WebsiteUpdateSlugOutput;
  websiteUpdateStartPage: Website;
  websiteValidateRecords: WebsiteValidateRecordsOutput;
};


export type MutationAgreementAddAttachmentArgs = {
  agreementId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  namespace: FileNamespace;
};


export type MutationAgreementCreateArgs = {
  input: AgreementCreateInput;
};


export type MutationAgreementDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAgreementNoteCreateArgs = {
  agreementId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationAgreementNoteDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAgreementRemoveAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationAgreementUpdateArgs = {
  input: AgreementUpdateInput;
};


export type MutationBookingCategoryCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationBookingCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBookingCategoryUpdateArgs = {
  input: BookingCategoryUpdateInput;
};


export type MutationBookingCategoryUpdateMaxBookingsPerUserArgs = {
  id: Scalars['ID']['input'];
  maxBookingsPerUser?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBookingEntriesCreateArgs = {
  categoryId: Scalars['ID']['input'];
  times: Array<BookingEntryCreateInput>;
};


export type MutationBookingEntryCreateArgs = {
  categoryId: Scalars['ID']['input'];
  input: BookingEntryCreateInput;
};


export type MutationBookingEntryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBookingTemplateEntryCreateArgs = {
  input: BookingTemplateEntryCreateInput;
};


export type MutationBookingTemplateEntryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBookingTemplateScheduleApplyArgs = {
  bookingCategoryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};


export type MutationDemoBookArgs = {
  input: DemoBookInput;
};


export type MutationDirectoryCreateArgs = {
  name: Scalars['String']['input'];
  namespace: FileNamespace;
  path: Scalars['String']['input'];
};


export type MutationDirectoryDeleteArgs = {
  namespace: FileNamespace;
  path: Scalars['String']['input'];
};


export type MutationDirectoryRenameArgs = {
  namespace: FileNamespace;
  newName: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type MutationEmailSendMessageArgs = {
  input: EmailSendMessageInput;
};


export type MutationErrandAssignToUserArgs = {
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationErrandCloseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationErrandCreateArgs = {
  input: ErrandCreateInput;
};


export type MutationErrandInfoUpdateArgs = {
  info: Scalars['String']['input'];
};


export type MutationErrandSetPendingArgs = {
  id: Scalars['ID']['input'];
  isPending: Scalars['Boolean']['input'];
};


export type MutationErrandTypeCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationErrandTypeDeleteArgs = {
  errandTypeId: Scalars['String']['input'];
};


export type MutationErrandTypeUpdateArgs = {
  input: ErrandTypeUpdateInput;
};


export type MutationErrandsExpiryUpdateArgs = {
  expiryInDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFeatureActivateArgs = {
  feature: OrganizationFeature;
};


export type MutationFeatureDisableArgs = {
  feature: OrganizationFeature;
};


export type MutationFileCreatePublicCopyArgs = {
  key: Scalars['String']['input'];
};


export type MutationFileCreateUnsortedCopyArgs = {
  key: Scalars['String']['input'];
};


export type MutationFileCreateUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  namespace: FileNamespace;
  path: Scalars['String']['input'];
};


export type MutationFileDeleteArgs = {
  key: Scalars['String']['input'];
  namespace: FileNamespace;
};


export type MutationFileUpdateArgs = {
  input: FileUpdateInput;
  key: Scalars['String']['input'];
  namespace: FileNamespace;
};


export type MutationInfoPageChangeSortOrderArgs = {
  input: InfoPageChangeSortOrderInput;
};


export type MutationInfoPageCreateArgs = {
  input: InfoPageCreateInput;
};


export type MutationInfoPageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInfoPageGroupChangeSortOrderArgs = {
  input: InfoPageGroupChangeSortOrderInput;
};


export type MutationInfoPageUpdateArgs = {
  input: InfoPageUpdateInput;
};


export type MutationInfoPageUpdateVisibilityArgs = {
  id: Scalars['ID']['input'];
  restricted: Scalars['Boolean']['input'];
};


export type MutationInfoPagesUpdateGroupArgs = {
  input: InfoPagesUpdateGroupInput;
};


export type MutationMeetingProposalAddParticipantArgs = {
  meetingProposalId: Scalars['ID']['input'];
  participant: MeetingProposalParticipantInput;
};


export type MutationMeetingProposalAddTimeslotArgs = {
  end: Scalars['Time']['input'];
  meetingProposalId: Scalars['ID']['input'];
  start: Scalars['Time']['input'];
};


export type MutationMeetingProposalCreateArgs = {
  input: MeetingProposalCreateInput;
};


export type MutationMeetingProposalDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMeetingProposalMarkOpenedArgs = {
  participantId: Scalars['ID']['input'];
};


export type MutationMeetingProposalNoVoteArgs = {
  participantId: Scalars['ID']['input'];
};


export type MutationMeetingProposalPickTimeslotArgs = {
  input: MeetingProposalPickTimeslotInput;
};


export type MutationMeetingProposalRemoveParticipantArgs = {
  participantId: Scalars['ID']['input'];
};


export type MutationMeetingProposalRemoveTimeslotArgs = {
  timeslotId: Scalars['ID']['input'];
};


export type MutationMeetingProposalUnNoVoteArgs = {
  participantId: Scalars['ID']['input'];
};


export type MutationMeetingProposalUnVoteArgs = {
  voteId: Scalars['ID']['input'];
};


export type MutationMeetingProposalUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMeetingProposalVoteArgs = {
  participantId: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
};


export type MutationNewsEntryCreateArgs = {
  input: NewsEntryCreateInput;
};


export type MutationNewsEntryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNewsEntryUpdateArgs = {
  input: NewsEntryUpdateInput;
};


export type MutationNotificationSettingsUpdateArgs = {
  input: NotificationSettingsUpdateInput;
};


export type MutationOnboardCodeSendArgs = {
  input: OnboardCodeSendInput;
};


export type MutationOnboardCodeVerifyArgs = {
  input: OnboardCodeVerifyInput;
};


export type MutationOnboardPushPartialArgs = {
  input: OnboardPushPartialInput;
};


export type MutationOrganizationUpdateArgs = {
  input: OrganizationUpdateInput;
};


export type MutationSignInArgs = {
  input: SignInInput;
};


export type MutationSignInVerifyArgs = {
  input: SignInVerifyInput;
};


export type MutationSmsSendMessageArgs = {
  input: SmsSendMessageInput;
};


export type MutationSupportTicketCreateArgs = {
  input: SupportTicketCreateInput;
};


export type MutationUserApproveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserGroupAddUserArgs = {
  input: UserGroupAddUserInput;
};


export type MutationUserGroupAddUsersArgs = {
  input: UserGroupAddUsersInput;
};


export type MutationUserGroupCreateArgs = {
  input: UserGroupCreateInput;
};


export type MutationUserGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserGroupRemoveUserArgs = {
  input: UserGroupRemoveUserInput;
};


export type MutationUserGroupRemoveUsersArgs = {
  input: UserGroupRemoveUsersInput;
};


export type MutationUserGroupUpdateNameArgs = {
  input: UserGroupUpdateNameInput;
};


export type MutationUserRegisterArgs = {
  input: UserRegisterInput;
};


export type MutationUserRegisterVerifyArgs = {
  input: UserRegisterVerifyInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationUserUpdateSelfArgs = {
  input: UserUpdateSelfInput;
};


export type MutationWebsiteBlockChangeSortOrderArgs = {
  input: WebsiteBlockChangeSortOrderInput;
};


export type MutationWebsiteBlockCreateArgs = {
  input: WebsiteBlockCreateInput;
};


export type MutationWebsiteBlockDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWebsiteBlockUpdateArgs = {
  input: WebsiteBlockUpdateInput;
};


export type MutationWebsitePublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWebsiteUnpublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWebsiteUpdateCustomDomainArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWebsiteUpdateSlugArgs = {
  slug: Scalars['String']['input'];
};


export type MutationWebsiteUpdateStartPageArgs = {
  input: WebsiteUpdateStartPageInput;
};

export type NewsEntry = {
  __typename?: 'NewsEntry';
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type NewsEntryCreateInput = {
  body: Scalars['String']['input'];
  title: Scalars['String']['input'];
  websiteId: Scalars['ID']['input'];
};

export type NewsEntryUpdateInput = {
  body: Scalars['String']['input'];
  newsEntryId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** Receive notifications when a new errand is created */
  receiveErrandNotifications: Scalars['Boolean']['output'];
  /** Receive notifications when a new user is registered */
  receiveUserRegistrationNotifications: Scalars['Boolean']['output'];
};

export type NotificationSettingsUpdateInput = {
  /** Receive notifications when a new errand is created, omit for no change */
  receiveErrandNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** Receive notifications when a new user is registered, omit for no change */
  receiveUserRegistrationNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardCodeSendInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type OnboardCodeSendOutput = {
  __typename?: 'OnboardCodeSendOutput';
  error?: Maybe<Scalars['String']['output']>;
  retryInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type OnboardCodeVerifyInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type OnboardCodeVerifyOutput = {
  __typename?: 'OnboardCodeVerifyOutput';
  accessToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type OnboardPushPartialInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  agreements: Array<Agreement>;
  /** Retrieve available booking categories for the organization */
  bookingCategories: Array<BookingCategory>;
  createdAt: Scalars['Time']['output'];
  /** If the organization has a custom booking system, they can link to it */
  customBookingLink?: Maybe<Scalars['String']['output']>;
  /** The display name for the custom booking */
  customBookingText?: Maybe<Scalars['String']['output']>;
  /** The text to display to the user when they view the errand page */
  errandInfoText: Scalars['String']['output'];
  /** The number of days before a completed errand expires */
  errandsExpireInDays?: Maybe<Scalars['Int']['output']>;
  features: OrganizationFeatures;
  files: Array<UploadedFileV2>;
  id: Scalars['ID']['output'];
  information: OrganizationInformation;
  inviteLinkId: Scalars['String']['output'];
  /** Whether the organization is considered paying or not */
  isPaying: Scalars['Boolean']['output'];
  meetingProposals: Array<MeetingProposal>;
  members: Array<User>;
  name: Scalars['String']['output'];
  website: Website;
};


export type OrganizationFilesArgs = {
  namespace: FileNamespace;
};

export enum OrganizationFeature {
  Blocks = 'Blocks',
  Bookings = 'Bookings',
  Errands = 'Errands'
}

export type OrganizationFeatures = {
  __typename?: 'OrganizationFeatures';
  agreements: Scalars['Boolean']['output'];
  blocks: Scalars['Boolean']['output'];
  bookings: Scalars['Boolean']['output'];
  errands: Scalars['Boolean']['output'];
  meetings: Scalars['Boolean']['output'];
};

export type OrganizationInformation = {
  __typename?: 'OrganizationInformation';
  address?: Maybe<Scalars['String']['output']>;
  billingDetails?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  orgNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  webmailLink?: Maybe<Scalars['String']['output']>;
};

export type OrganizationUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  billingDetails?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  webmailLink?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  agreement: Agreement;
  association: Association;
  associations: Array<Association>;
  /** Retrieve a booking category by ID */
  bookingCategory: BookingCategory;
  bookingEntry: BookingEntry;
  bookingTemplateSchedules: Array<BookingTemplateSchedule>;
  emailMessage: EmailMessage;
  emailSentMessages: Array<EmailMessage>;
  errand: Errand;
  errandType: ErrandType;
  errandTypes: Array<ErrandType>;
  errands: Array<Errand>;
  file: UploadedFileV2;
  infoPage: InfoPage;
  /** The existing top-level groups for info pages */
  infoPageGroups: Array<Scalars['String']['output']>;
  inviteLinkValidate: Scalars['Boolean']['output'];
  me: Me;
  meetingProposal: MeetingProposal;
  meetingProposalByParticipant: MeetingProposal;
  /** The existing top-level groups for member pages */
  memberPageGroups: Array<Scalars['String']['output']>;
  newsEntry: NewsEntry;
  smsMessage: SmsMessage;
  smsSentMessages: Array<SmsMessage>;
  staticInfoPageBySlug: StaticInfoPage;
  staticWebsite: StaticWebsite;
  user: User;
  userGroup: UserGroup;
  userGroups: Array<UserGroup>;
  users: Array<User>;
  website: WebsiteOutput;
};


export type QueryAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssociationArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryBookingCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErrandTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErrandsArgs = {
  filter?: InputMaybe<ErrandsFilter>;
};


export type QueryFileArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  namespace: FileNamespace;
};


export type QueryInfoPageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInviteLinkValidateArgs = {
  linkId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryMeetingProposalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeetingProposalByParticipantArgs = {
  participantId: Scalars['ID']['input'];
};


export type QueryNewsEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmsMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStaticInfoPageBySlugArgs = {
  slug: Scalars['String']['input'];
  websiteSlug: Scalars['String']['input'];
};


export type QueryStaticWebsiteArgs = {
  slug: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryWebsiteArgs = {
  slug: Scalars['String']['input'];
};

export enum Role {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type SignInInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SignInOutput = {
  __typename?: 'SignInOutput';
  error?: Maybe<Scalars['String']['output']>;
  retryInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type SignInVerifyInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mainSite?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type SignInVerifyOutput = {
  __typename?: 'SignInVerifyOutput';
  accessToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type SmsMessage = {
  __typename?: 'SmsMessage';
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deliveries: Array<MessageDelivery>;
  id: Scalars['ID']['output'];
};

export type SmsSendMessageInput = {
  body: Scalars['String']['input'];
  receivingUserIds: Array<Scalars['ID']['input']>;
};

export type SmsSendMessageOutput = {
  __typename?: 'SmsSendMessageOutput';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<SmsMessage>;
};

export type StartPage = {
  __typename?: 'StartPage';
  blocks: Array<Block>;
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum StaticBlockContainer {
  StartPage = 'StartPage'
}

export type StaticErrandType = {
  __typename?: 'StaticErrandType';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StaticFeatures = {
  __typename?: 'StaticFeatures';
  errands: Scalars['Boolean']['output'];
};

export type StaticInfoPage = {
  __typename?: 'StaticInfoPage';
  blocks: Array<Block>;
  body?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  groupSlug?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  restricted: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StaticNewsEntry = {
  __typename?: 'StaticNewsEntry';
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StaticStartPage = {
  __typename?: 'StaticStartPage';
  blocks: Array<Block>;
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StaticWebsite = {
  __typename?: 'StaticWebsite';
  address: StaticWebsiteAddress;
  errandInfo: Scalars['String']['output'];
  errandTypes: Array<StaticErrandType>;
  features: StaticFeatures;
  id: Scalars['ID']['output'];
  indexable: Scalars['Boolean']['output'];
  infoPages: Array<StaticInfoPage>;
  memberInfoPages: Array<StaticInfoPage>;
  name: Scalars['String']['output'];
  news: Array<StaticNewsEntry>;
  orgNumber: Scalars['String']['output'];
  startPage: StaticStartPage;
  user?: Maybe<User>;
};

export type StaticWebsiteAddress = {
  __typename?: 'StaticWebsiteAddress';
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type SupportTicketCreateInput = {
  body: Scalars['String']['input'];
};

export type TimeInterval = {
  __typename?: 'TimeInterval';
  end: Scalars['Time']['output'];
  start: Scalars['Time']['output'];
};

export type TwoColumnBlock = BaseBlock & {
  __typename?: 'TwoColumnBlock';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leftColumnBody: Scalars['String']['output'];
  leftColumnTitle: Scalars['String']['output'];
  rightColumnBody: Scalars['String']['output'];
  rightColumnTitle: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type UploadedFileV2 = {
  __typename?: 'UploadedFileV2';
  contentType?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  isDirectory: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  namespace: FileNamespace;
  signedUrl: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  apartmentNumber?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** The groups this user is a member of */
  groups: Array<UserGroup>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  role: Role;
  verified: Scalars['Boolean']['output'];
  verifiedByAdmin: Scalars['Boolean']['output'];
};

export type UserCreateInput = {
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role: Role;
};

export type UserCreateOutput = {
  __typename?: 'UserCreateOutput';
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfUsers: Scalars['Int']['output'];
  users: Array<User>;
};

export type UserGroupAddUserInput = {
  userGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UserGroupAddUsersInput = {
  userGroupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UserGroupCreateInput = {
  name: Scalars['String']['input'];
};

export type UserGroupCreateOutput = {
  __typename?: 'UserGroupCreateOutput';
  error?: Maybe<Scalars['String']['output']>;
  userGroup?: Maybe<UserGroup>;
};

export type UserGroupRemoveUserInput = {
  userGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UserGroupRemoveUsersInput = {
  userGroupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UserGroupUpdateNameInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UserGroupUpdateNameOutput = {
  __typename?: 'UserGroupUpdateNameOutput';
  error?: Maybe<Scalars['String']['output']>;
  userGroup?: Maybe<UserGroup>;
};

export type UserRegisterInput = {
  apartmentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type UserRegisterOutput = {
  __typename?: 'UserRegisterOutput';
  error?: Maybe<Scalars['String']['output']>;
  retryInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type UserRegisterVerifyInput = {
  apartmentNumber: Scalars['String']['input'];
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  linkId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type UserRegisterVerifyOutput = {
  __typename?: 'UserRegisterVerifyOutput';
  error?: Maybe<Scalars['String']['output']>;
};

export type UserUpdateInput = {
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  userId: Scalars['ID']['input'];
};

export type UserUpdateOutput = {
  __typename?: 'UserUpdateOutput';
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserUpdateSelfInput = {
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type Website = {
  __typename?: 'Website';
  adress: Scalars['String']['output'];
  /** Retrieve blocks based on container name */
  blocks: Array<Block>;
  /** The custom domain for the website */
  domain?: Maybe<Scalars['String']['output']>;
  /** Latest time the domain DNS records were validated */
  domainValidatedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Public information pages */
  infoPages: Array<InfoPage>;
  /** Restricted information pages */
  memberInfoPages: Array<InfoPage>;
  name: Scalars['String']['output'];
  news: Array<NewsEntry>;
  published: Scalars['Boolean']['output'];
  /** The free sub-domain under booet.se */
  slug: Scalars['String']['output'];
  startPage?: Maybe<StartPage>;
};


export type WebsiteBlocksArgs = {
  container: Scalars['String']['input'];
};

export type WebsiteBlockChangeSortOrderInput = {
  /** The block to change the sort order for */
  blockId: Scalars['ID']['input'];
  /** The target sort order for the block */
  sortOrder: Scalars['Int']['input'];
};

export type WebsiteBlockChangeSortOrderOutput = {
  __typename?: 'WebsiteBlockChangeSortOrderOutput';
  /** The block that was moved */
  block: Block;
  /** All blocks in the container, potentially with new sort orders */
  containerBlocks: Array<Block>;
};

export type WebsiteBlockCreateInput = {
  blockType: BlockType;
  container: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type WebsiteBlockCreateOutput = {
  __typename?: 'WebsiteBlockCreateOutput';
  /** The newly created block */
  block: Block;
  /** All blocks in the container, potentially with new sort orders */
  containerBlocks: Array<Block>;
};

export type WebsiteBlockUpdateInput = {
  blockId: Scalars['ID']['input'];
  /** The payload of the block, as a JSON string */
  payload: Scalars['String']['input'];
};

export type WebsiteOutput = {
  __typename?: 'WebsiteOutput';
  error?: Maybe<Scalars['String']['output']>;
  preview: Scalars['Boolean']['output'];
  website?: Maybe<Website>;
};

export type WebsiteUpdateCustomDomainOutput = {
  __typename?: 'WebsiteUpdateCustomDomainOutput';
  error?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Website>;
};

export type WebsiteUpdateSlugOutput = {
  __typename?: 'WebsiteUpdateSlugOutput';
  error?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Website>;
};

export type WebsiteUpdateStartPageInput = {
  body: Scalars['String']['input'];
  title: Scalars['String']['input'];
  websiteId: Scalars['ID']['input'];
};

export type WebsiteValidateRecordsOutput = {
  __typename?: 'WebsiteValidateRecordsOutput';
  error?: Maybe<Scalars['String']['output']>;
  firstRecordFound: Scalars['Boolean']['output'];
  secondRecordFound: Scalars['Boolean']['output'];
  thirdRecordFound: Scalars['Boolean']['output'];
  website: Website;
};

export type CreatePublicCopyMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type CreatePublicCopyMutation = { __typename?: 'Mutation', fileCreatePublicCopy: { __typename?: 'FileMakePublicCopyOutput', error?: string | null, file?: { __typename?: 'UploadedFileV2', key: string, url: string } | null } };

export type CreateUnsortedCopyMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type CreateUnsortedCopyMutation = { __typename?: 'Mutation', fileCreateUnsortedCopy: { __typename?: 'FileCreateUnsortedCopy', error?: string | null, file?: { __typename?: 'UploadedFileV2', key: string, url: string } | null } };

export type WebsiteBlocksQueryVariables = Exact<{
  container: Scalars['String']['input'];
}>;


export type WebsiteBlocksQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', website: { __typename?: 'Website', id: string, blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> }, features: { __typename?: 'OrganizationFeatures', blocks: boolean } } } };

export type CreateBlockMutationVariables = Exact<{
  container: Scalars['String']['input'];
  type: BlockType;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateBlockMutation = { __typename?: 'Mutation', websiteBlockCreate: { __typename?: 'WebsiteBlockCreateOutput', block: { __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }, containerBlocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } };

export type DeleteBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBlockMutation = { __typename?: 'Mutation', websiteBlockDelete: boolean };

export type MoveBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
}>;


export type MoveBlockMutation = { __typename?: 'Mutation', websiteBlockChangeSortOrder: { __typename?: 'WebsiteBlockChangeSortOrderOutput', block: { __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }, containerBlocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } };

export type UpdateBlockPayloadMutationVariables = Exact<{
  blockId: Scalars['ID']['input'];
  payload: Scalars['String']['input'];
}>;


export type UpdateBlockPayloadMutation = { __typename?: 'Mutation', websiteBlockUpdate: { __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string } };

type BlockFragment_BannerBlock_Fragment = { __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string };

type BlockFragment_BoardMembersBlock_Fragment = { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> };

type BlockFragment_HeadlineBlock_Fragment = { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string };

type BlockFragment_HeadlineImageBlock_Fragment = { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string };

type BlockFragment_ImageCollectionBlock_Fragment = { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string };

type BlockFragment_TwoColumnBlock_Fragment = { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string };

export type BlockFragmentFragment = BlockFragment_BannerBlock_Fragment | BlockFragment_BoardMembersBlock_Fragment | BlockFragment_HeadlineBlock_Fragment | BlockFragment_HeadlineImageBlock_Fragment | BlockFragment_ImageCollectionBlock_Fragment | BlockFragment_TwoColumnBlock_Fragment;

export type UpdateFileMutationVariables = Exact<{
  key: Scalars['String']['input'];
  input: FileUpdateInput;
  namespace: FileNamespace;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', fileUpdate: { __typename?: 'FileUpdateOutput', error?: string | null, file?: { __typename?: 'UploadedFileV2', key: string, url: string, uploadedAt: any } | null } };

export type DeleteFileMutationVariables = Exact<{
  key: Scalars['String']['input'];
  namespace: FileNamespace;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', fileDelete: { __typename?: 'FileDeleteOutput', error?: string | null } };

export type CreateDirectoryMutationVariables = Exact<{
  path: Scalars['String']['input'];
  name: Scalars['String']['input'];
  namespace: FileNamespace;
}>;


export type CreateDirectoryMutation = { __typename?: 'Mutation', directoryCreate: boolean };

export type DeleteDirectoryMutationVariables = Exact<{
  path: Scalars['String']['input'];
  namespace: FileNamespace;
}>;


export type DeleteDirectoryMutation = { __typename?: 'Mutation', directoryDelete: { __typename?: 'DirectoryDeleteOutput', success: boolean, error?: string | null } };

export type RenameDirectoryMutationVariables = Exact<{
  path: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type RenameDirectoryMutation = { __typename?: 'Mutation', directoryRename: { __typename?: 'DirectoryRenameOutput', error?: string | null, files?: Array<{ __typename?: 'UploadedFileV2', key: string, displayName: string }> | null } };

export type CreateUploadUrlMutationVariables = Exact<{
  path: Scalars['String']['input'];
  name: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  namespace: FileNamespace;
}>;


export type CreateUploadUrlMutation = { __typename?: 'Mutation', fileCreateUploadUrl: { __typename?: 'FileCreateUploadUrlOutput', filename?: string | null, url?: string | null } };

export type OrganizationFilesQueryVariables = Exact<{
  namespace: FileNamespace;
}>;


export type OrganizationFilesQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', files: Array<{ __typename?: 'UploadedFileV2', key: string, displayName: string, url: string, size: number, uploadedAt: any, isDirectory: boolean }> } } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInOutput', retryInSeconds?: number | null, error?: string | null } };

export type SignInVerifyMutationVariables = Exact<{
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mainSite: Scalars['Boolean']['input'];
}>;


export type SignInVerifyMutation = { __typename?: 'Mutation', signInVerify: { __typename?: 'SignInVerifyOutput', accessToken?: string | null, error?: string | null, websiteUrl?: string | null } };

export type GetOrganizationMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', id: string, members: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role, verified: boolean, apartmentNumber?: string | null, groups: Array<{ __typename?: 'UserGroup', id: string, name: string }> }> } } };

export type GetOrganizationGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string }> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role }, organization: { __typename?: 'Organization', id: string, name: string, createdAt: any, inviteLinkId: string, isPaying: boolean, members: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role, verified: boolean, verifiedByAdmin: boolean, apartmentNumber?: string | null }>, information: { __typename?: 'OrganizationInformation', address?: string | null, city?: string | null, postalCode?: string | null, email?: string | null, contactFirstName?: string | null, contactLastName?: string | null, contactEmail?: string | null, contactPhoneNumber?: string | null, billingDetails?: string | null, billingEmail?: string | null, orgNumber?: string | null, webmailLink?: string | null }, features: { __typename?: 'OrganizationFeatures', errands: boolean, bookings: boolean, meetings: boolean, agreements: boolean }, website: { __typename?: 'Website', id: string, slug: string, domain?: string | null, domainValidatedAt?: any | null, published: boolean, startPage?: { __typename?: 'StartPage', title: string, body: string, blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } | null } } } };

export type CreateNewsEntryMutationVariables = Exact<{
  websiteId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
}>;


export type CreateNewsEntryMutation = { __typename?: 'Mutation', newsEntryCreate: { __typename?: 'NewsEntry', id: string, title: string, body: string, createdAt: any } };

export type DeleteNewsEntryMutationVariables = Exact<{
  newsEntryId: Scalars['ID']['input'];
}>;


export type DeleteNewsEntryMutation = { __typename?: 'Mutation', newsEntryDelete: boolean };

export type UpdateNewsEntryMutationVariables = Exact<{
  newsEntryId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
}>;


export type UpdateNewsEntryMutation = { __typename?: 'Mutation', newsEntryUpdate: { __typename?: 'NewsEntry', id: string, title: string, body: string } };

export type ActivateOrgFeatureMutationVariables = Exact<{
  feature: OrganizationFeature;
}>;


export type ActivateOrgFeatureMutation = { __typename?: 'Mutation', featureActivate: { __typename?: 'Organization', id: string, features: { __typename?: 'OrganizationFeatures', errands: boolean } } };

export type DisableOrgFeatureMutationVariables = Exact<{
  feature: OrganizationFeature;
}>;


export type DisableOrgFeatureMutation = { __typename?: 'Mutation', featureDisable: { __typename?: 'Organization', id: string, features: { __typename?: 'OrganizationFeatures', errands: boolean } } };

export type PublishWebsiteMutationVariables = Exact<{
  websiteId: Scalars['ID']['input'];
}>;


export type PublishWebsiteMutation = { __typename?: 'Mutation', websitePublish: { __typename?: 'Website', id: string, published: boolean } };

export type UnpublishWebsiteMutationVariables = Exact<{
  websiteId: Scalars['ID']['input'];
}>;


export type UnpublishWebsiteMutation = { __typename?: 'Mutation', websiteUnpublish: { __typename?: 'Website', id: string, published: boolean } };

export type AgreementAttachmentsQueryVariables = Exact<{
  agreementId: Scalars['ID']['input'];
}>;


export type AgreementAttachmentsQuery = { __typename?: 'Query', agreement: { __typename?: 'Agreement', id: string, attachments: Array<{ __typename?: 'UploadedFileV2', key: string, isDirectory: boolean }> } };

export type AgreementNotesQueryVariables = Exact<{
  agreementId: Scalars['ID']['input'];
}>;


export type AgreementNotesQuery = { __typename?: 'Query', agreement: { __typename?: 'Agreement', id: string, notes: Array<{ __typename?: 'AgreementNote', id: string, message: string, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } };

export type CreateAgreementNoteMutationVariables = Exact<{
  agreementId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type CreateAgreementNoteMutation = { __typename?: 'Mutation', agreementNoteCreate: { __typename?: 'Agreement', id: string, notes: Array<{ __typename?: 'AgreementNote', id: string, message: string, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } };

export type DeleteAgreementMutationVariables = Exact<{
  agreementId: Scalars['ID']['input'];
}>;


export type DeleteAgreementMutation = { __typename?: 'Mutation', agreementDelete: boolean };

export type AgreementDetailsQueryVariables = Exact<{
  agreementId: Scalars['ID']['input'];
}>;


export type AgreementDetailsQuery = { __typename?: 'Query', agreement: { __typename?: 'Agreement', id: string, title: string, description: string, validUntil: any, companyName: string, companyContactName: string, companyContactEmail: string, companyContactPhone: string } };

export type CreateAgreementMutationVariables = Exact<{
  input: AgreementCreateInput;
}>;


export type CreateAgreementMutation = { __typename?: 'Mutation', agreementCreate: { __typename?: 'AgreementResult', error?: string | null, agreement?: { __typename?: 'Agreement', id: string, title: string, description: string, validUntil: any, companyName: string, companyContactName: string, companyContactEmail: string, companyContactPhone: string } | null } };

export type AllAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAgreementsQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', agreements: Array<{ __typename?: 'Agreement', id: string, title: string, description: string, validUntil: any }> } } };

export type OrganizationBookingCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationBookingCategoriesQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', id: string, bookingCategories: Array<{ __typename?: 'BookingCategory', id: string, name: string }> } } };

export type CreateBookingCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateBookingCategoryMutation = { __typename?: 'Mutation', bookingCategoryCreate: { __typename?: 'BookingCategoryCreateOutput', error?: string | null, bookingCategory?: { __typename?: 'BookingCategory', id: string, name: string, info: string } | null } };

export type DeleteBookingCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBookingCategoryMutation = { __typename?: 'Mutation', bookingCategoryDelete: { __typename?: 'BookingCategoryDeleteOutput', error?: string | null } };

export type UpdateBookingCategoryMutationVariables = Exact<{
  input: BookingCategoryUpdateInput;
}>;


export type UpdateBookingCategoryMutation = { __typename?: 'Mutation', bookingCategoryUpdate: { __typename?: 'BookingCategoryUpdateOutput', error?: string | null, bookingCategory?: { __typename?: 'BookingCategory', id: string, name: string, info: string } | null } };

export type UpdateBookingCategoryShowNamesOnBookingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  showNamesOnBookings: Scalars['Boolean']['input'];
}>;


export type UpdateBookingCategoryShowNamesOnBookingsMutation = { __typename?: 'Mutation', bookingCategoryUpdate: { __typename?: 'BookingCategoryUpdateOutput', error?: string | null, bookingCategory?: { __typename?: 'BookingCategory', id: string, settings: { __typename?: 'BookingCategorySettings', showNamesOnBookings: boolean } } | null } };

export type UpdateBookingCategoryMaxBookingsPerUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  maxBookingsPerUser?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateBookingCategoryMaxBookingsPerUserMutation = { __typename?: 'Mutation', bookingCategoryUpdateMaxBookingsPerUser: { __typename?: 'BookingCategory', id: string, settings: { __typename?: 'BookingCategorySettings', maxBookingsPerUser?: number | null } } };

export type BookingCategorySettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BookingCategorySettingsQuery = { __typename?: 'Query', bookingCategory: { __typename?: 'BookingCategory', id: string, name: string, info: string, settings: { __typename?: 'BookingCategorySettings', showNamesOnBookings: boolean, maxBookingsPerUser?: number | null } } };

export type BookingCategorySlotsAndEntriesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
}>;


export type BookingCategorySlotsAndEntriesQuery = { __typename?: 'Query', bookingCategory: { __typename?: 'BookingCategory', id: string, name: string, slots: Array<{ __typename?: 'BookingSlot', start: any, end: any, state: BookingSlotState }>, allEntries: Array<{ __typename?: 'BookingEntry', id: string, start: any, end: any, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } };

export type BookingCategorySlotsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
}>;


export type BookingCategorySlotsQuery = { __typename?: 'Query', bookingCategory: { __typename?: 'BookingCategory', id: string, name: string, slots: Array<{ __typename?: 'BookingSlot', templateId: string, start: any, end: any, state: BookingSlotState }> } };

export type CreateBookingTemplateEntryMutationVariables = Exact<{
  input: BookingTemplateEntryCreateInput;
}>;


export type CreateBookingTemplateEntryMutation = { __typename?: 'Mutation', bookingTemplateEntryCreate: { __typename?: 'BookingTemplateEntryCreateOutput', error?: string | null, bookingTemplateEntry?: { __typename?: 'BookingTemplateEntry', id: string, startHour: number, startMinute: number, endHour: number, endMinute: number, day: number } | null } };

export type DeleteBookingTemplateEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBookingTemplateEntryMutation = { __typename?: 'Mutation', bookingTemplateEntryDelete: boolean };

export type BookingCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BookingCategoryQuery = { __typename?: 'Query', bookingCategory: { __typename?: 'BookingCategory', id: string, name: string } };

export type ApplyBookingTemplateScheduleMutationVariables = Exact<{
  bookingCategoryId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
}>;


export type ApplyBookingTemplateScheduleMutation = { __typename?: 'Mutation', bookingTemplateScheduleApply: { __typename?: 'BookingCategory', id: string } };

export type EmailMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailMessageQuery = { __typename?: 'Query', emailMessage: { __typename?: 'EmailMessage', id: string, subject: string, body: string, createdAt: any, deliveries: Array<{ __typename?: 'MessageDelivery', status: MessageDeliveryStatus, error?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber: string } }> } };

export type SendEmailMutationVariables = Exact<{
  input: EmailSendMessageInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', emailSendMessage: { __typename?: 'EmailSendMessageOutput', message?: { __typename?: 'EmailMessage', id: string, subject: string, body: string, createdAt: any, deliveries: Array<{ __typename?: 'MessageDelivery', status: MessageDeliveryStatus, error?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } | null } };

export type SendSmsMutationVariables = Exact<{
  input: SmsSendMessageInput;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', smsSendMessage: { __typename?: 'SmsSendMessageOutput', error?: string | null, message?: { __typename?: 'SmsMessage', id: string, body: string, createdAt: any, deliveries: Array<{ __typename?: 'MessageDelivery', status: MessageDeliveryStatus, error?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } }> } | null } };

export type SmsMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SmsMessageQuery = { __typename?: 'Query', smsMessage: { __typename?: 'SmsMessage', id: string, body: string, createdAt: any, deliveries: Array<{ __typename?: 'MessageDelivery', status: MessageDeliveryStatus, error?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber: string } }> } };

export type EmailReplyToAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailReplyToAddressQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', information: { __typename?: 'OrganizationInformation', email?: string | null } } } };

export type SentEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type SentEmailQuery = { __typename?: 'Query', emailSentMessages: Array<{ __typename?: 'EmailMessage', id: string, subject: string, body: string, createdAt: any }> };

export type SentSmsQueryVariables = Exact<{ [key: string]: never; }>;


export type SentSmsQuery = { __typename?: 'Query', smsSentMessages: Array<{ __typename?: 'SmsMessage', id: string, body: string, createdAt: any }> };

export type SetErrandPendingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isPending: Scalars['Boolean']['input'];
}>;


export type SetErrandPendingMutation = { __typename?: 'Mutation', errandSetPending: { __typename?: 'Errand', id: string, isPending: boolean } };

export type AssignErrandToMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AssignErrandToMutation = { __typename?: 'Mutation', errandAssignToUser: { __typename?: 'Errand', id: string, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } };

export type CompleteErrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompleteErrandMutation = { __typename?: 'Mutation', errandClose: { __typename?: 'Errand', id: string, completedAt?: any | null } };

export type CreateErrandTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateErrandTypeMutation = { __typename?: 'Mutation', errandTypeCreate: { __typename?: 'ErrandTypeCreateOutput', error?: string | null, errandType?: { __typename?: 'ErrandType', id: string, displayName: string } | null } };

export type DeleteErrandTypeMutationVariables = Exact<{
  errandTypeId: Scalars['String']['input'];
}>;


export type DeleteErrandTypeMutation = { __typename?: 'Mutation', errandTypeDelete: { __typename?: 'ErrandTypeDeleteOutput', error?: string | null } };

export type ErrandCountQueryVariables = Exact<{
  filter?: InputMaybe<ErrandsFilter>;
}>;


export type ErrandCountQuery = { __typename?: 'Query', errands: Array<{ __typename?: 'Errand', id: string }> };

export type ErrandTypeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ErrandTypeQuery = { __typename?: 'Query', errandType: { __typename?: 'ErrandType', id: string, displayName: string } };

export type ErrandTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ErrandTypesQuery = { __typename?: 'Query', errandTypes: Array<{ __typename?: 'ErrandType', id: string, displayName: string }> };

export type ErrandQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ErrandQuery = { __typename?: 'Query', errand: { __typename?: 'Errand', id: string, body: string, createdAt: any, completedAt?: any | null, isPending: boolean, apartmentNumber: string, originator: { __typename?: 'ErrandOriginator', phoneNumber: string, email: string }, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } };

export type ErrandsQueryVariables = Exact<{
  filter?: InputMaybe<ErrandsFilter>;
}>;


export type ErrandsQuery = { __typename?: 'Query', errands: Array<{ __typename?: 'Errand', id: string, status: ErrandStatus, body: string, createdAt: any, completedAt?: any | null, apartmentNumber: string, isPending: boolean, type: { __typename?: 'ErrandType', id: string, displayName: string }, originator: { __typename?: 'ErrandOriginator', phoneNumber: string, email: string }, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }> };

export type UpdateErrandsExpiryMutationVariables = Exact<{
  expiryInDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateErrandsExpiryMutation = { __typename?: 'Mutation', errandsExpiryUpdate: { __typename?: 'Organization', id: string, errandsExpireInDays?: number | null } };

export type UpdateErrandTypeMutationVariables = Exact<{
  input: ErrandTypeUpdateInput;
}>;


export type UpdateErrandTypeMutation = { __typename?: 'Mutation', errandTypeUpdate: { __typename?: 'ErrandTypeUpdateOutput', error?: string | null, errandType?: { __typename?: 'ErrandType', id: string, displayName: string } | null } };

export type ErrandsExpiryQueryVariables = Exact<{ [key: string]: never; }>;


export type ErrandsExpiryQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', id: string, errandsExpireInDays?: number | null } } };

export type GetInfoTextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInfoTextQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', id: string, errandInfoText: string } } };

export type UpdateInfoTextMutationVariables = Exact<{
  info: Scalars['String']['input'];
}>;


export type UpdateInfoTextMutation = { __typename?: 'Mutation', errandInfoUpdate: { __typename?: 'Organization', id: string, errandInfoText: string } };

export type FileQueryVariables = Exact<{
  key: Scalars['String']['input'];
  namespace: FileNamespace;
}>;


export type FileQuery = { __typename?: 'Query', file: { __typename?: 'UploadedFileV2', key: string, displayName: string, url: string, signedUrl: string, size: number, contentType?: string | null, uploadedAt: any } };

export type MeNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeNotificationSettingsQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, notificationSettings: { __typename?: 'NotificationSettings', receiveErrandNotifications: boolean, receiveUserRegistrationNotifications: boolean } } };

export type UpdateErrandNotificationSettingsMutationVariables = Exact<{
  errandNotifications: Scalars['Boolean']['input'];
}>;


export type UpdateErrandNotificationSettingsMutation = { __typename?: 'Mutation', notificationSettingsUpdate: { __typename?: 'Me', notificationSettings: { __typename?: 'NotificationSettings', receiveErrandNotifications: boolean } } };

export type UpdateUserRegistrationNotificationSettingsMutationVariables = Exact<{
  userRegistrationNotifications: Scalars['Boolean']['input'];
}>;


export type UpdateUserRegistrationNotificationSettingsMutation = { __typename?: 'Mutation', notificationSettingsUpdate: { __typename?: 'Me', notificationSettings: { __typename?: 'NotificationSettings', receiveUserRegistrationNotifications: boolean } } };

export type GetUsersByIdsQueryVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetUsersByIdsQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null }> };

export type CreateMeetingProposalMutationVariables = Exact<{
  input: MeetingProposalCreateInput;
}>;


export type CreateMeetingProposalMutation = { __typename?: 'Mutation', meetingProposalCreate: { __typename?: 'MeetingProposalResult', error?: string | null, meetingProposal?: { __typename?: 'MeetingProposal', id: string, title: string, description: string } | null } };

export type GetMeetingProposalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeetingProposalsQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', id: string, meetingProposals: Array<{ __typename?: 'MeetingProposal', id: string, title: string, description: string, completed: boolean, pickedTimeslot?: { __typename?: 'MeetingTimeslot', id: string, start: any, end: any } | null }> } } };

export type AddMeetingProposalTimeslotMutationVariables = Exact<{
  meetingProposalId: Scalars['ID']['input'];
  start: Scalars['Time']['input'];
  end: Scalars['Time']['input'];
}>;


export type AddMeetingProposalTimeslotMutation = { __typename?: 'Mutation', meetingProposalAddTimeslot: { __typename?: 'MeetingProposalResult', error?: string | null, meetingProposal?: { __typename?: 'MeetingProposal', id: string, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, start: any, end: any }> } | null } };

export type RemoveMeetingProposalTimeslotMutationVariables = Exact<{
  timeslotId: Scalars['ID']['input'];
}>;


export type RemoveMeetingProposalTimeslotMutation = { __typename?: 'Mutation', meetingProposalRemoveTimeslot: { __typename?: 'MeetingProposal', id: string, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, start: any, end: any }> } };

export type FinishMeetingProposalPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishMeetingProposalPageQuery = { __typename?: 'Query', meetingProposal: { __typename?: 'MeetingProposal', id: string, title: string, description: string, completed: boolean, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, start: any, end: any, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, email: string, name: string, noVote: boolean, hasOpened: boolean } }> }> } };

export type FinishMeetingProposalMutationVariables = Exact<{
  timeslotId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinishMeetingProposalMutation = { __typename?: 'Mutation', meetingProposalPickTimeslot: { __typename?: 'MeetingProposal', id: string, completed: boolean, pickedTimeslot?: { __typename?: 'MeetingTimeslot', id: string, start: any, end: any } | null } };

export type AddParticipantToMeetingProposalMutationVariables = Exact<{
  meetingProposalId: Scalars['ID']['input'];
  participant: MeetingProposalParticipantInput;
}>;


export type AddParticipantToMeetingProposalMutation = { __typename?: 'Mutation', meetingProposalAddParticipant: { __typename?: 'MeetingProposalResult', meetingProposal?: { __typename?: 'MeetingProposal', id: string, participants: Array<{ __typename?: 'MeetingParticipant', id: string, email: string, name: string, user?: { __typename?: 'User', id: string } | null }> } | null } };

export type RemoveMeetingProposalParticipantMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type RemoveMeetingProposalParticipantMutation = { __typename?: 'Mutation', meetingProposalRemoveParticipant: { __typename?: 'MeetingProposal', id: string, participants: Array<{ __typename?: 'MeetingParticipant', id: string, email: string, name: string, user?: { __typename?: 'User', id: string } | null }> } };

export type GetMeetingProposalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMeetingProposalQuery = { __typename?: 'Query', meetingProposal: { __typename?: 'MeetingProposal', id: string, title: string, description: string, completed: boolean, pickedTimeslot?: { __typename?: 'MeetingTimeslot', id: string, start: any, end: any } | null, participants: Array<{ __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean, hasOpened: boolean, user?: { __typename?: 'User', id: string } | null }>, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, start: any, end: any, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, email: string, name: string, noVote: boolean, hasOpened: boolean, user?: { __typename?: 'User', id: string } | null } }> }> } };

export type UserUserGroupsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserUserGroupsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, groups: Array<{ __typename?: 'UserGroup', id: string, name: string }> } };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role, verified: boolean, apartmentNumber?: string | null } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  apartmentNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } };

export type InfoPageGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type InfoPageGroupsQuery = { __typename?: 'Query', infoPageGroups: Array<string> };

export type MemberPageGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberPageGroupsQuery = { __typename?: 'Query', memberPageGroups: Array<string> };

export type CreateMemberMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type CreateMemberMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'UserCreateOutput', error?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber: string, email: string, role: Role, verified: boolean } | null } };

export type DeleteMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMemberMutation = { __typename?: 'Mutation', userDelete: boolean };

export type CreateUserGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', userGroupCreate: { __typename?: 'UserGroupCreateOutput', error?: string | null, userGroup?: { __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> } | null } };

export type UpdateUserGroupNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateUserGroupNameMutation = { __typename?: 'Mutation', userGroupUpdateName: { __typename?: 'UserGroupUpdateNameOutput', error?: string | null, userGroup?: { __typename?: 'UserGroup', id: string, name: string } | null } };

export type DeleteUserGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutation', userGroupDelete: boolean };

export type AddUserToUserGroupMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;


export type AddUserToUserGroupMutation = { __typename?: 'Mutation', userGroupAddUser: { __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> } };

export type RemoveUserFromUserGroupMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;


export type RemoveUserFromUserGroupMutation = { __typename?: 'Mutation', userGroupRemoveUser: { __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> } };

export type AddUsersToUserGroupMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;


export type AddUsersToUserGroupMutation = { __typename?: 'Mutation', userGroupAddUsers: { __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, groups: Array<{ __typename?: 'UserGroup', id: string, name: string }> }> } };

export type RemoveUsersFromUserGroupMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;


export type RemoveUsersFromUserGroupMutation = { __typename?: 'Mutation', userGroupRemoveUsers: { __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> } };

export type UserGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserGroupQuery = { __typename?: 'Query', userGroup: { __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> } };

export type UserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, numberOfUsers: number }> };

export type CreateInviteLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateInviteLinkMutation = { __typename?: 'Mutation', inviteLinkCreate: { __typename?: 'Organization', id: string, inviteLinkId: string } };

export type ApproveUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveUserMutation = { __typename?: 'Mutation', userApprove: { __typename?: 'User', id: string, verifiedByAdmin: boolean } };

export type DeleteInfoPageMutationVariables = Exact<{
  infoPageId: Scalars['ID']['input'];
}>;


export type DeleteInfoPageMutation = { __typename?: 'Mutation', infoPageDelete: boolean };

export type UpdateInfoPageMutationVariables = Exact<{
  infoPageId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateInfoPageMutation = { __typename?: 'Mutation', infoPageUpdate: { __typename?: 'InfoPage', id: string, title: string, body: string, group?: string | null, slug: string } };

export type AssignInfoPagesToGroupMutationVariables = Exact<{
  group?: InputMaybe<Scalars['String']['input']>;
  infoPageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AssignInfoPagesToGroupMutation = { __typename?: 'Mutation', infoPagesUpdateGroup: Array<{ __typename?: 'InfoPage', id: string, group?: string | null }> };

export type ClearInfoPagesGroupMutationVariables = Exact<{
  infoPageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ClearInfoPagesGroupMutation = { __typename?: 'Mutation', infoPagesUpdateGroup: Array<{ __typename?: 'InfoPage', id: string, group?: string | null }> };

export type InfoPageQueryVariables = Exact<{
  infoPageId: Scalars['ID']['input'];
}>;


export type InfoPageQuery = { __typename?: 'Query', infoPage: { __typename?: 'InfoPage', id: string, title: string, body: string, group?: string | null } };

export type ChangeSortOrderMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
}>;


export type ChangeSortOrderMutation = { __typename?: 'Mutation', infoPageChangeSortOrder: Array<{ __typename?: 'InfoPage', id: string, sortOrder: number }> };

export type ChangeGroupSortOrderMutationVariables = Exact<{
  group: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  restricted: Scalars['Boolean']['input'];
}>;


export type ChangeGroupSortOrderMutation = { __typename?: 'Mutation', infoPageGroupChangeSortOrder: Array<{ __typename?: 'InfoPage', id: string, sortOrder: number }> };

export type WebsiteInfoPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type WebsiteInfoPagesQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', website: { __typename?: 'Website', infoPages: Array<{ __typename?: 'InfoPage', id: string, title: string, group?: string | null, sortOrder: number }>, memberInfoPages: Array<{ __typename?: 'InfoPage', id: string, title: string, group?: string | null, sortOrder: number }> } } } };

export type MakeInfoPagePrivateMutationVariables = Exact<{
  infoPageId: Scalars['ID']['input'];
}>;


export type MakeInfoPagePrivateMutation = { __typename?: 'Mutation', infoPageUpdateVisibility: { __typename?: 'InfoPageUpdateVisibilityOutput', error?: string | null } };

export type CreateInfoPageMutationVariables = Exact<{
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInfoPageMutation = { __typename?: 'Mutation', infoPageCreate: { __typename?: 'InfoPage', id: string, title: string, body: string, slug: string } };

export type MakeInfoPagePublicMutationVariables = Exact<{
  infoPageId: Scalars['ID']['input'];
}>;


export type MakeInfoPagePublicMutation = { __typename?: 'Mutation', infoPageUpdateVisibility: { __typename?: 'InfoPageUpdateVisibilityOutput', error?: string | null } };

export type CreateRestrictedInfoPageMutationVariables = Exact<{
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRestrictedInfoPageMutation = { __typename?: 'Mutation', infoPageCreate: { __typename?: 'InfoPage', id: string, title: string, body: string, slug: string } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', organizationUpdate: { __typename?: 'Organization', id: string, information: { __typename?: 'OrganizationInformation', address?: string | null, city?: string | null, postalCode?: string | null, email?: string | null, contactFirstName?: string | null, contactLastName?: string | null, contactEmail?: string | null, contactPhoneNumber?: string | null, billingDetails?: string | null, billingEmail?: string | null, orgNumber?: string | null } } };

export type UpdateCustomDomainMutationVariables = Exact<{
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomDomainMutation = { __typename?: 'Mutation', websiteUpdateCustomDomain: { __typename?: 'WebsiteUpdateCustomDomainOutput', error?: string | null, website?: { __typename?: 'Website', id: string, domain?: string | null, domainValidatedAt?: any | null } | null } };

export type ValidateDomainRecordsMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateDomainRecordsMutation = { __typename?: 'Mutation', websiteValidateRecords: { __typename?: 'WebsiteValidateRecordsOutput', firstRecordFound: boolean, secondRecordFound: boolean, thirdRecordFound: boolean, website: { __typename?: 'Website', id: string, domain?: string | null, domainValidatedAt?: any | null } } };

export type UpdateSlugMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UpdateSlugMutation = { __typename?: 'Mutation', websiteUpdateSlug: { __typename?: 'WebsiteUpdateSlugOutput', error?: string | null, website?: { __typename?: 'Website', id: string, slug: string } | null } };

export type UpdateWebmailMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;


export type UpdateWebmailMutation = { __typename?: 'Mutation', organizationUpdate: { __typename?: 'Organization', id: string, information: { __typename?: 'OrganizationInformation', webmailLink?: string | null } } };

export type CreateSupportTicketMutationVariables = Exact<{
  body: Scalars['String']['input'];
}>;


export type CreateSupportTicketMutation = { __typename?: 'Mutation', supportTicketCreate: boolean };

export type BookDemoMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type BookDemoMutation = { __typename?: 'Mutation', demoBook: boolean };

export type AssociationQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type AssociationQuery = { __typename?: 'Query', association: { __typename?: 'Association', slug: string, orgName: string, orgNumber: string, orgAddress: string, numberOfApartments: string, registrationYear: string, postal: string, city: string } };

export type AssociationSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type AssociationSitemapQuery = { __typename?: 'Query', associations: Array<{ __typename?: 'Association', slug: string }> };

export type SendOnboardCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type SendOnboardCodeMutation = { __typename?: 'Mutation', onboardCodeSend: { __typename?: 'OnboardCodeSendOutput', retryInSeconds?: number | null, error?: string | null } };

export type VerifyOnboardCodeMutationVariables = Exact<{
  orgName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyOnboardCodeMutation = { __typename?: 'Mutation', onboardCodeVerify: { __typename?: 'OnboardCodeVerifyOutput', accessToken?: string | null, error?: string | null } };

export type PushPartialOnboardingMutationVariables = Exact<{
  input: OnboardPushPartialInput;
}>;


export type PushPartialOnboardingMutation = { __typename?: 'Mutation', onboardPushPartial: boolean };

export type MemberPortalBookingCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberPortalBookingCategoriesQuery = { __typename?: 'Query', me: { __typename?: 'Me', organization: { __typename?: 'Organization', customBookingText?: string | null, customBookingLink?: string | null, bookingCategories: Array<{ __typename?: 'BookingCategory', id: string, name: string }> } } };

export type MemberPortalBookingEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberPortalBookingEntriesQuery = { __typename?: 'Query', me: { __typename?: 'Me', bookingEntries: Array<{ __typename?: 'BookingEntry', id: string, start: any, end: any, category: { __typename?: 'BookingCategory', id: string, name: string } }> } };

export type MemberPortalCreateBookingEntriesMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  times: Array<BookingEntryCreateInput> | BookingEntryCreateInput;
}>;


export type MemberPortalCreateBookingEntriesMutation = { __typename?: 'Mutation', bookingEntriesCreate: { __typename?: 'BookingEntriesCreateOutput', numberOfErrors: number, error?: string | null, bookingEntries: Array<{ __typename?: 'BookingEntry', id: string, start: any, end: any }> } };

export type MemberPortalDeleteBookingEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MemberPortalDeleteBookingEntryMutation = { __typename?: 'Mutation', bookingEntryDelete: boolean };

export type MemberPortalBookingCategorySlotsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
}>;


export type MemberPortalBookingCategorySlotsQuery = { __typename?: 'Query', bookingCategory: { __typename?: 'BookingCategory', id: string, name: string, slots: Array<{ __typename?: 'BookingSlot', templateId: string, start: any, end: any, state: BookingSlotState, bookedByName: string }> } };

export type MemberPortalInfoPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MemberPortalInfoPageQuery = { __typename?: 'Query', infoPage: { __typename?: 'InfoPage', id: string, title: string, slug: string, blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } };

export type PortalMeQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalMeQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role, apartmentNumber?: string | null } } };

export type PortalInfoPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalInfoPagesQuery = { __typename?: 'Query', me: { __typename?: 'Me', website: { __typename?: 'Website', id: string, infoPages: Array<{ __typename?: 'InfoPage', id: string, createdAt: any, updatedAt: any, title: string, slug: string, sortOrder: number }>, memberInfoPages: Array<{ __typename?: 'InfoPage', id: string, createdAt: any, updatedAt: any, title: string, slug: string, sortOrder: number }> } } };

export type MemberPortalUserQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type MemberPortalUserQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role, apartmentNumber?: string | null } | null } };

export type PortalUserUpdateSelfMutationVariables = Exact<{
  input: UserUpdateSelfInput;
}>;


export type PortalUserUpdateSelfMutation = { __typename?: 'Mutation', userUpdateSelf: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber: string, email: string, apartmentNumber?: string | null } };

export type StaticWebsiteInfoPageQueryVariables = Exact<{
  websiteSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type StaticWebsiteInfoPageQuery = { __typename?: 'Query', staticInfoPageBySlug: { __typename?: 'StaticInfoPage', id: string, title: string, body?: string | null, group?: string | null, restricted: boolean, blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } };

export type StaticWebsiteStartPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StaticWebsiteStartPageQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, name: string, orgNumber: string, indexable: boolean, address: { __typename?: 'StaticWebsiteAddress', street: string, postalCode: string, city: string }, startPage: { __typename?: 'StaticStartPage', title: string, body: string, blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } } };

export type CreateErrandMutationVariables = Exact<{
  input: ErrandCreateInput;
}>;


export type CreateErrandMutation = { __typename?: 'Mutation', errandCreate: { __typename?: 'ErrandCreateOutput', error?: string | null } };

export type ErrandFeatureQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ErrandFeatureQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, errandInfo: string, errandTypes: Array<{ __typename?: 'StaticErrandType', id: string, displayName: string }>, features: { __typename?: 'StaticFeatures', errands: boolean } } };

export type BookingCategoryInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BookingCategoryInfoQuery = { __typename?: 'Query', bookingCategory: { __typename?: 'BookingCategory', id: string, name: string, info: string } };

export type MemberPortalHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberPortalHomeQuery = { __typename?: 'Query', me: { __typename?: 'Me', user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, organization: { __typename?: 'Organization', id: string, name: string, features: { __typename?: 'OrganizationFeatures', bookings: boolean }, bookingCategories: Array<{ __typename?: 'BookingCategory', id: string, name: string }> } } };

export type StaticWebsiteLayoutQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StaticWebsiteLayoutQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, name: string, orgNumber: string, infoPages: Array<{ __typename?: 'StaticInfoPage', id: string, title: string, slug: string, group?: string | null }>, memberInfoPages: Array<{ __typename?: 'StaticInfoPage', id: string, title: string, slug: string, group?: string | null }>, features: { __typename?: 'StaticFeatures', errands: boolean }, address: { __typename?: 'StaticWebsiteAddress', street: string, postalCode: string, city: string }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } };

export type MeetingProposalPageQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type MeetingProposalPageQuery = { __typename?: 'Query', meetingProposalByParticipant: { __typename?: 'MeetingProposal', id: string, title: string, description: string, completed: boolean, finalMessage?: string | null, pickedTimeslot?: { __typename?: 'MeetingTimeslot', id: string, start: any, end: any } | null, participants: Array<{ __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean }>, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, start: any, end: any, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, email: string, name: string, noVote: boolean, hasVoted: boolean } }> }> } };

export type VoteOnTimeslotMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  timeslotId: Scalars['ID']['input'];
}>;


export type VoteOnTimeslotMutation = { __typename?: 'Mutation', meetingProposalVote: { __typename?: 'MeetingProposalResult', meetingProposal?: { __typename?: 'MeetingProposal', id: string, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean } }> }> } | null } };

export type UnVoteOnTimeslotMutationVariables = Exact<{
  voteId: Scalars['ID']['input'];
}>;


export type UnVoteOnTimeslotMutation = { __typename?: 'Mutation', meetingProposalUnVote: { __typename?: 'MeetingProposal', id: string, participants: Array<{ __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean }>, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean } }> }> } };

export type ParticipantNoVoteMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type ParticipantNoVoteMutation = { __typename?: 'Mutation', meetingProposalNoVote: { __typename?: 'MeetingProposal', id: string, participants: Array<{ __typename?: 'MeetingParticipant', id: string, email: string, name: string, noVote: boolean, hasVoted: boolean }>, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean } }> }> } };

export type ParticipantUnNoVoteMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type ParticipantUnNoVoteMutation = { __typename?: 'Mutation', meetingProposalUnNoVote: { __typename?: 'MeetingProposal', id: string, participants: Array<{ __typename?: 'MeetingParticipant', id: string, email: string, name: string, noVote: boolean, hasVoted: boolean }>, timeslots: Array<{ __typename?: 'MeetingTimeslot', id: string, votes: Array<{ __typename?: 'MeetingProposalVote', id: string, participant: { __typename?: 'MeetingParticipant', id: string, name: string, email: string, noVote: boolean, hasVoted: boolean } }> }> } };

export type ParticipantMarkOpenedMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
}>;


export type ParticipantMarkOpenedMutation = { __typename?: 'Mutation', meetingProposalMarkOpened: { __typename?: 'MeetingProposal', id: string, participants: Array<{ __typename?: 'MeetingParticipant', id: string, hasOpened: boolean }> } };

export type RegisterUserVerifyMutationVariables = Exact<{
  input: UserRegisterVerifyInput;
}>;


export type RegisterUserVerifyMutation = { __typename?: 'Mutation', userRegisterVerify: { __typename?: 'UserRegisterVerifyOutput', error?: string | null } };

export type RegisterUserMutationVariables = Exact<{
  input: UserRegisterInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', userRegister: { __typename?: 'UserRegisterOutput', retryInSeconds?: number | null, error?: string | null } };

export type ValidateInviteLinkQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  linkId: Scalars['String']['input'];
}>;


export type ValidateInviteLinkQuery = { __typename?: 'Query', inviteLinkValidate: boolean };

export type SlimStaticWebsiteQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type SlimStaticWebsiteQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, name: string, orgNumber: string, address: { __typename?: 'StaticWebsiteAddress', street: string, city: string, postalCode: string }, startPage: { __typename?: 'StaticStartPage', title: string, body: string }, features: { __typename?: 'StaticFeatures', errands: boolean } } };

export type StaticInfoPageBySlugQueryVariables = Exact<{
  websiteSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type StaticInfoPageBySlugQuery = { __typename?: 'Query', staticInfoPageBySlug: { __typename?: 'StaticInfoPage', id: string, title: string, body?: string | null, group?: string | null, blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } };

export type StaticPagesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StaticPagesQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, infoPages: Array<{ __typename?: 'StaticInfoPage', id: string, title: string, slug: string, group?: string | null }>, memberInfoPages: Array<{ __typename?: 'StaticInfoPage', id: string, title: string, slug: string, group?: string | null }> } };

export type StaticStartPageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StaticStartPageBySlugQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, startPage: { __typename?: 'StaticStartPage', blocks: Array<{ __typename: 'BannerBlock', id: string, displayName: string, sortOrder: number, headline: string, body: string, imageUrl: string, backgroundColor: string, textColor: string } | { __typename: 'BoardMembersBlock', id: string, displayName: string, sortOrder: number, boardMembers: Array<{ __typename?: 'BoardMemberEntry', id: string, name: string, title: string, description?: string | null, imageUrl?: string | null, email?: string | null, phoneNumber?: string | null }> } | { __typename: 'HeadlineBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string } | { __typename: 'HeadlineImageBlock', id: string, displayName: string, sortOrder: number, headline: string, subtitle: string, imageUrl: string, imageLink: string } | { __typename: 'ImageCollectionBlock', id: string, displayName: string, sortOrder: number, firstImageUrl: string, firstCaption: string, firstImageLink: string, secondImageUrl: string, secondCaption: string, secondImageLink: string, thirdImageUrl: string, thirdCaption: string, thirdImageLink: string } | { __typename: 'TwoColumnBlock', id: string, displayName: string, sortOrder: number, leftColumnTitle: string, leftColumnBody: string, rightColumnTitle: string, rightColumnBody: string }> } } };

export type StaticUserQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StaticUserQuery = { __typename?: 'Query', staticWebsite: { __typename?: 'StaticWebsite', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, phoneNumber: string, role: Role, apartmentNumber?: string | null } | null } };

export type UserUpdateSelfMutationVariables = Exact<{
  input: UserUpdateSelfInput;
}>;


export type UserUpdateSelfMutation = { __typename?: 'Mutation', userUpdateSelf: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber: string, email: string, apartmentNumber?: string | null } };

export const BlockFragmentFragmentDoc = gql`
    fragment BlockFragment on Block {
  __typename
  ... on BannerBlock {
    id
    displayName
    sortOrder
    headline
    body
    imageUrl
    backgroundColor
    textColor
  }
  ... on HeadlineImageBlock {
    id
    displayName
    sortOrder
    headline
    subtitle
    imageUrl
    imageLink
  }
  ... on HeadlineBlock {
    id
    displayName
    sortOrder
    headline
    subtitle
  }
  ... on ImageCollectionBlock {
    id
    displayName
    sortOrder
    firstImageUrl
    firstCaption
    firstImageLink
    secondImageUrl
    secondCaption
    secondImageLink
    thirdImageUrl
    thirdCaption
    thirdImageLink
  }
  ... on TwoColumnBlock {
    id
    displayName
    sortOrder
    leftColumnTitle
    leftColumnBody
    rightColumnTitle
    rightColumnBody
  }
  ... on BoardMembersBlock {
    id
    displayName
    sortOrder
    boardMembers {
      id
      name
      title
      description
      imageUrl
      email
      phoneNumber
    }
  }
}
    `;
export const CreatePublicCopyDocument = gql`
    mutation CreatePublicCopy($key: String!) {
  fileCreatePublicCopy(key: $key) {
    error
    file {
      key
      url
    }
  }
}
    `;
export type CreatePublicCopyMutationFn = Apollo.MutationFunction<CreatePublicCopyMutation, CreatePublicCopyMutationVariables>;

/**
 * __useCreatePublicCopyMutation__
 *
 * To run a mutation, you first call `useCreatePublicCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicCopyMutation, { data, loading, error }] = useCreatePublicCopyMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCreatePublicCopyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicCopyMutation, CreatePublicCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicCopyMutation, CreatePublicCopyMutationVariables>(CreatePublicCopyDocument, options);
      }
export type CreatePublicCopyMutationHookResult = ReturnType<typeof useCreatePublicCopyMutation>;
export type CreatePublicCopyMutationResult = Apollo.MutationResult<CreatePublicCopyMutation>;
export type CreatePublicCopyMutationOptions = Apollo.BaseMutationOptions<CreatePublicCopyMutation, CreatePublicCopyMutationVariables>;
export const CreateUnsortedCopyDocument = gql`
    mutation CreateUnsortedCopy($key: String!) {
  fileCreateUnsortedCopy(key: $key) {
    error
    file {
      key
      url
    }
  }
}
    `;
export type CreateUnsortedCopyMutationFn = Apollo.MutationFunction<CreateUnsortedCopyMutation, CreateUnsortedCopyMutationVariables>;

/**
 * __useCreateUnsortedCopyMutation__
 *
 * To run a mutation, you first call `useCreateUnsortedCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnsortedCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnsortedCopyMutation, { data, loading, error }] = useCreateUnsortedCopyMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCreateUnsortedCopyMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnsortedCopyMutation, CreateUnsortedCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnsortedCopyMutation, CreateUnsortedCopyMutationVariables>(CreateUnsortedCopyDocument, options);
      }
export type CreateUnsortedCopyMutationHookResult = ReturnType<typeof useCreateUnsortedCopyMutation>;
export type CreateUnsortedCopyMutationResult = Apollo.MutationResult<CreateUnsortedCopyMutation>;
export type CreateUnsortedCopyMutationOptions = Apollo.BaseMutationOptions<CreateUnsortedCopyMutation, CreateUnsortedCopyMutationVariables>;
export const WebsiteBlocksDocument = gql`
    query WebsiteBlocks($container: String!) {
  me {
    organization {
      website {
        id
        blocks(container: $container) {
          ...BlockFragment
        }
      }
      features {
        blocks
      }
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useWebsiteBlocksQuery__
 *
 * To run a query within a React component, call `useWebsiteBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteBlocksQuery({
 *   variables: {
 *      container: // value for 'container'
 *   },
 * });
 */
export function useWebsiteBlocksQuery(baseOptions: Apollo.QueryHookOptions<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>(WebsiteBlocksDocument, options);
      }
export function useWebsiteBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>(WebsiteBlocksDocument, options);
        }
export function useWebsiteBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>(WebsiteBlocksDocument, options);
        }
export type WebsiteBlocksQueryHookResult = ReturnType<typeof useWebsiteBlocksQuery>;
export type WebsiteBlocksLazyQueryHookResult = ReturnType<typeof useWebsiteBlocksLazyQuery>;
export type WebsiteBlocksSuspenseQueryHookResult = ReturnType<typeof useWebsiteBlocksSuspenseQuery>;
export type WebsiteBlocksQueryResult = Apollo.QueryResult<WebsiteBlocksQuery, WebsiteBlocksQueryVariables>;
export const CreateBlockDocument = gql`
    mutation CreateBlock($container: String!, $type: BlockType!, $sortOrder: Int) {
  websiteBlockCreate(
    input: {container: $container, blockType: $type, sortOrder: $sortOrder}
  ) {
    block {
      ...BlockFragment
    }
    containerBlocks {
      ...BlockFragment
    }
  }
}
    ${BlockFragmentFragmentDoc}`;
export type CreateBlockMutationFn = Apollo.MutationFunction<CreateBlockMutation, CreateBlockMutationVariables>;

/**
 * __useCreateBlockMutation__
 *
 * To run a mutation, you first call `useCreateBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockMutation, { data, loading, error }] = useCreateBlockMutation({
 *   variables: {
 *      container: // value for 'container'
 *      type: // value for 'type'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useCreateBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockMutation, CreateBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockMutation, CreateBlockMutationVariables>(CreateBlockDocument, options);
      }
export type CreateBlockMutationHookResult = ReturnType<typeof useCreateBlockMutation>;
export type CreateBlockMutationResult = Apollo.MutationResult<CreateBlockMutation>;
export type CreateBlockMutationOptions = Apollo.BaseMutationOptions<CreateBlockMutation, CreateBlockMutationVariables>;
export const DeleteBlockDocument = gql`
    mutation DeleteBlock($id: ID!) {
  websiteBlockDelete(id: $id)
}
    `;
export type DeleteBlockMutationFn = Apollo.MutationFunction<DeleteBlockMutation, DeleteBlockMutationVariables>;

/**
 * __useDeleteBlockMutation__
 *
 * To run a mutation, you first call `useDeleteBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockMutation, { data, loading, error }] = useDeleteBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlockMutation, DeleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument, options);
      }
export type DeleteBlockMutationHookResult = ReturnType<typeof useDeleteBlockMutation>;
export type DeleteBlockMutationResult = Apollo.MutationResult<DeleteBlockMutation>;
export type DeleteBlockMutationOptions = Apollo.BaseMutationOptions<DeleteBlockMutation, DeleteBlockMutationVariables>;
export const MoveBlockDocument = gql`
    mutation MoveBlock($id: ID!, $sortOrder: Int!) {
  websiteBlockChangeSortOrder(input: {blockId: $id, sortOrder: $sortOrder}) {
    block {
      ...BlockFragment
    }
    containerBlocks {
      ...BlockFragment
    }
  }
}
    ${BlockFragmentFragmentDoc}`;
export type MoveBlockMutationFn = Apollo.MutationFunction<MoveBlockMutation, MoveBlockMutationVariables>;

/**
 * __useMoveBlockMutation__
 *
 * To run a mutation, you first call `useMoveBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveBlockMutation, { data, loading, error }] = useMoveBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useMoveBlockMutation(baseOptions?: Apollo.MutationHookOptions<MoveBlockMutation, MoveBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveBlockMutation, MoveBlockMutationVariables>(MoveBlockDocument, options);
      }
export type MoveBlockMutationHookResult = ReturnType<typeof useMoveBlockMutation>;
export type MoveBlockMutationResult = Apollo.MutationResult<MoveBlockMutation>;
export type MoveBlockMutationOptions = Apollo.BaseMutationOptions<MoveBlockMutation, MoveBlockMutationVariables>;
export const UpdateBlockPayloadDocument = gql`
    mutation UpdateBlockPayload($blockId: ID!, $payload: String!) {
  websiteBlockUpdate(input: {blockId: $blockId, payload: $payload}) {
    ...BlockFragment
  }
}
    ${BlockFragmentFragmentDoc}`;
export type UpdateBlockPayloadMutationFn = Apollo.MutationFunction<UpdateBlockPayloadMutation, UpdateBlockPayloadMutationVariables>;

/**
 * __useUpdateBlockPayloadMutation__
 *
 * To run a mutation, you first call `useUpdateBlockPayloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockPayloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockPayloadMutation, { data, loading, error }] = useUpdateBlockPayloadMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateBlockPayloadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockPayloadMutation, UpdateBlockPayloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockPayloadMutation, UpdateBlockPayloadMutationVariables>(UpdateBlockPayloadDocument, options);
      }
export type UpdateBlockPayloadMutationHookResult = ReturnType<typeof useUpdateBlockPayloadMutation>;
export type UpdateBlockPayloadMutationResult = Apollo.MutationResult<UpdateBlockPayloadMutation>;
export type UpdateBlockPayloadMutationOptions = Apollo.BaseMutationOptions<UpdateBlockPayloadMutation, UpdateBlockPayloadMutationVariables>;
export const UpdateFileDocument = gql`
    mutation UpdateFile($key: String!, $input: FileUpdateInput!, $namespace: FileNamespace!) {
  fileUpdate(key: $key, input: $input, namespace: $namespace) {
    file {
      key
      url
      uploadedAt
    }
    error
  }
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      key: // value for 'key'
 *      input: // value for 'input'
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($key: String!, $namespace: FileNamespace!) {
  fileDelete(key: $key, namespace: $namespace) {
    error
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      key: // value for 'key'
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const CreateDirectoryDocument = gql`
    mutation CreateDirectory($path: String!, $name: String!, $namespace: FileNamespace!) {
  directoryCreate(path: $path, name: $name, namespace: $namespace)
}
    `;
export type CreateDirectoryMutationFn = Apollo.MutationFunction<CreateDirectoryMutation, CreateDirectoryMutationVariables>;

/**
 * __useCreateDirectoryMutation__
 *
 * To run a mutation, you first call `useCreateDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectoryMutation, { data, loading, error }] = useCreateDirectoryMutation({
 *   variables: {
 *      path: // value for 'path'
 *      name: // value for 'name'
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useCreateDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectoryMutation, CreateDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectoryMutation, CreateDirectoryMutationVariables>(CreateDirectoryDocument, options);
      }
export type CreateDirectoryMutationHookResult = ReturnType<typeof useCreateDirectoryMutation>;
export type CreateDirectoryMutationResult = Apollo.MutationResult<CreateDirectoryMutation>;
export type CreateDirectoryMutationOptions = Apollo.BaseMutationOptions<CreateDirectoryMutation, CreateDirectoryMutationVariables>;
export const DeleteDirectoryDocument = gql`
    mutation DeleteDirectory($path: String!, $namespace: FileNamespace!) {
  directoryDelete(path: $path, namespace: $namespace) {
    success
    error
  }
}
    `;
export type DeleteDirectoryMutationFn = Apollo.MutationFunction<DeleteDirectoryMutation, DeleteDirectoryMutationVariables>;

/**
 * __useDeleteDirectoryMutation__
 *
 * To run a mutation, you first call `useDeleteDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectoryMutation, { data, loading, error }] = useDeleteDirectoryMutation({
 *   variables: {
 *      path: // value for 'path'
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useDeleteDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDirectoryMutation, DeleteDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDirectoryMutation, DeleteDirectoryMutationVariables>(DeleteDirectoryDocument, options);
      }
export type DeleteDirectoryMutationHookResult = ReturnType<typeof useDeleteDirectoryMutation>;
export type DeleteDirectoryMutationResult = Apollo.MutationResult<DeleteDirectoryMutation>;
export type DeleteDirectoryMutationOptions = Apollo.BaseMutationOptions<DeleteDirectoryMutation, DeleteDirectoryMutationVariables>;
export const RenameDirectoryDocument = gql`
    mutation RenameDirectory($path: String!, $newName: String!) {
  directoryRename(path: $path, newName: $newName, namespace: General) {
    files {
      key
      displayName
    }
    error
  }
}
    `;
export type RenameDirectoryMutationFn = Apollo.MutationFunction<RenameDirectoryMutation, RenameDirectoryMutationVariables>;

/**
 * __useRenameDirectoryMutation__
 *
 * To run a mutation, you first call `useRenameDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameDirectoryMutation, { data, loading, error }] = useRenameDirectoryMutation({
 *   variables: {
 *      path: // value for 'path'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<RenameDirectoryMutation, RenameDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameDirectoryMutation, RenameDirectoryMutationVariables>(RenameDirectoryDocument, options);
      }
export type RenameDirectoryMutationHookResult = ReturnType<typeof useRenameDirectoryMutation>;
export type RenameDirectoryMutationResult = Apollo.MutationResult<RenameDirectoryMutation>;
export type RenameDirectoryMutationOptions = Apollo.BaseMutationOptions<RenameDirectoryMutation, RenameDirectoryMutationVariables>;
export const CreateUploadUrlDocument = gql`
    mutation CreateUploadUrl($path: String!, $name: String!, $contentType: String!, $namespace: FileNamespace!) {
  fileCreateUploadUrl(
    path: $path
    name: $name
    contentType: $contentType
    namespace: $namespace
  ) {
    filename
    url
  }
}
    `;
export type CreateUploadUrlMutationFn = Apollo.MutationFunction<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;

/**
 * __useCreateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadUrlMutation, { data, loading, error }] = useCreateUploadUrlMutation({
 *   variables: {
 *      path: // value for 'path'
 *      name: // value for 'name'
 *      contentType: // value for 'contentType'
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useCreateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>(CreateUploadUrlDocument, options);
      }
export type CreateUploadUrlMutationHookResult = ReturnType<typeof useCreateUploadUrlMutation>;
export type CreateUploadUrlMutationResult = Apollo.MutationResult<CreateUploadUrlMutation>;
export type CreateUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;
export const OrganizationFilesDocument = gql`
    query OrganizationFiles($namespace: FileNamespace!) {
  me {
    organization {
      files(namespace: $namespace) {
        key
        displayName
        url
        size
        uploadedAt
        isDirectory
      }
    }
  }
}
    `;

/**
 * __useOrganizationFilesQuery__
 *
 * To run a query within a React component, call `useOrganizationFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFilesQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useOrganizationFilesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationFilesQuery, OrganizationFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationFilesQuery, OrganizationFilesQueryVariables>(OrganizationFilesDocument, options);
      }
export function useOrganizationFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationFilesQuery, OrganizationFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationFilesQuery, OrganizationFilesQueryVariables>(OrganizationFilesDocument, options);
        }
export function useOrganizationFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationFilesQuery, OrganizationFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationFilesQuery, OrganizationFilesQueryVariables>(OrganizationFilesDocument, options);
        }
export type OrganizationFilesQueryHookResult = ReturnType<typeof useOrganizationFilesQuery>;
export type OrganizationFilesLazyQueryHookResult = ReturnType<typeof useOrganizationFilesLazyQuery>;
export type OrganizationFilesSuspenseQueryHookResult = ReturnType<typeof useOrganizationFilesSuspenseQuery>;
export type OrganizationFilesQueryResult = Apollo.QueryResult<OrganizationFilesQuery, OrganizationFilesQueryVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $phoneNumber: String!) {
  signIn(input: {phoneNumber: $phoneNumber, email: $email}) {
    retryInSeconds
    error
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignInVerifyDocument = gql`
    mutation SignInVerify($code: String!, $phoneNumber: String!, $email: String!, $mainSite: Boolean!) {
  signInVerify(
    input: {phoneNumber: $phoneNumber, code: $code, email: $email, mainSite: $mainSite}
  ) {
    accessToken
    error
    websiteUrl
  }
}
    `;
export type SignInVerifyMutationFn = Apollo.MutationFunction<SignInVerifyMutation, SignInVerifyMutationVariables>;

/**
 * __useSignInVerifyMutation__
 *
 * To run a mutation, you first call `useSignInVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInVerifyMutation, { data, loading, error }] = useSignInVerifyMutation({
 *   variables: {
 *      code: // value for 'code'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      mainSite: // value for 'mainSite'
 *   },
 * });
 */
export function useSignInVerifyMutation(baseOptions?: Apollo.MutationHookOptions<SignInVerifyMutation, SignInVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInVerifyMutation, SignInVerifyMutationVariables>(SignInVerifyDocument, options);
      }
export type SignInVerifyMutationHookResult = ReturnType<typeof useSignInVerifyMutation>;
export type SignInVerifyMutationResult = Apollo.MutationResult<SignInVerifyMutation>;
export type SignInVerifyMutationOptions = Apollo.BaseMutationOptions<SignInVerifyMutation, SignInVerifyMutationVariables>;
export const GetOrganizationMembersDocument = gql`
    query GetOrganizationMembers {
  me {
    organization {
      id
      members {
        id
        firstName
        lastName
        email
        phoneNumber
        role
        verified
        apartmentNumber
        groups {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
      }
export function useGetOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
export type GetOrganizationMembersQueryHookResult = ReturnType<typeof useGetOrganizationMembersQuery>;
export type GetOrganizationMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizationMembersLazyQuery>;
export type GetOrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationMembersSuspenseQuery>;
export type GetOrganizationMembersQueryResult = Apollo.QueryResult<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const GetOrganizationGroupsDocument = gql`
    query GetOrganizationGroups {
  userGroups {
    id
    name
    numberOfUsers
    users {
      id
    }
  }
}
    `;

/**
 * __useGetOrganizationGroupsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>(GetOrganizationGroupsDocument, options);
      }
export function useGetOrganizationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>(GetOrganizationGroupsDocument, options);
        }
export function useGetOrganizationGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>(GetOrganizationGroupsDocument, options);
        }
export type GetOrganizationGroupsQueryHookResult = ReturnType<typeof useGetOrganizationGroupsQuery>;
export type GetOrganizationGroupsLazyQueryHookResult = ReturnType<typeof useGetOrganizationGroupsLazyQuery>;
export type GetOrganizationGroupsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationGroupsSuspenseQuery>;
export type GetOrganizationGroupsQueryResult = Apollo.QueryResult<GetOrganizationGroupsQuery, GetOrganizationGroupsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    user {
      id
      firstName
      lastName
      email
      phoneNumber
      role
    }
    organization {
      id
      name
      createdAt
      inviteLinkId
      isPaying
      members {
        id
        firstName
        lastName
        email
        phoneNumber
        role
        verified
        verifiedByAdmin
        apartmentNumber
      }
      information {
        address
        city
        postalCode
        email
        contactFirstName
        contactLastName
        contactEmail
        contactPhoneNumber
        billingDetails
        billingEmail
        orgNumber
        webmailLink
      }
      features {
        errands
        bookings
        meetings
        agreements
      }
      website {
        id
        slug
        domain
        domainValidatedAt
        published
        startPage {
          title
          body
          blocks {
            ...BlockFragment
          }
        }
      }
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CreateNewsEntryDocument = gql`
    mutation CreateNewsEntry($websiteId: ID!, $title: String!, $body: String!) {
  newsEntryCreate(input: {websiteId: $websiteId, title: $title, body: $body}) {
    id
    title
    body
    createdAt
  }
}
    `;
export type CreateNewsEntryMutationFn = Apollo.MutationFunction<CreateNewsEntryMutation, CreateNewsEntryMutationVariables>;

/**
 * __useCreateNewsEntryMutation__
 *
 * To run a mutation, you first call `useCreateNewsEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsEntryMutation, { data, loading, error }] = useCreateNewsEntryMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateNewsEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsEntryMutation, CreateNewsEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsEntryMutation, CreateNewsEntryMutationVariables>(CreateNewsEntryDocument, options);
      }
export type CreateNewsEntryMutationHookResult = ReturnType<typeof useCreateNewsEntryMutation>;
export type CreateNewsEntryMutationResult = Apollo.MutationResult<CreateNewsEntryMutation>;
export type CreateNewsEntryMutationOptions = Apollo.BaseMutationOptions<CreateNewsEntryMutation, CreateNewsEntryMutationVariables>;
export const DeleteNewsEntryDocument = gql`
    mutation DeleteNewsEntry($newsEntryId: ID!) {
  newsEntryDelete(id: $newsEntryId)
}
    `;
export type DeleteNewsEntryMutationFn = Apollo.MutationFunction<DeleteNewsEntryMutation, DeleteNewsEntryMutationVariables>;

/**
 * __useDeleteNewsEntryMutation__
 *
 * To run a mutation, you first call `useDeleteNewsEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsEntryMutation, { data, loading, error }] = useDeleteNewsEntryMutation({
 *   variables: {
 *      newsEntryId: // value for 'newsEntryId'
 *   },
 * });
 */
export function useDeleteNewsEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNewsEntryMutation, DeleteNewsEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNewsEntryMutation, DeleteNewsEntryMutationVariables>(DeleteNewsEntryDocument, options);
      }
export type DeleteNewsEntryMutationHookResult = ReturnType<typeof useDeleteNewsEntryMutation>;
export type DeleteNewsEntryMutationResult = Apollo.MutationResult<DeleteNewsEntryMutation>;
export type DeleteNewsEntryMutationOptions = Apollo.BaseMutationOptions<DeleteNewsEntryMutation, DeleteNewsEntryMutationVariables>;
export const UpdateNewsEntryDocument = gql`
    mutation UpdateNewsEntry($newsEntryId: ID!, $title: String!, $body: String!) {
  newsEntryUpdate(input: {newsEntryId: $newsEntryId, title: $title, body: $body}) {
    id
    title
    body
  }
}
    `;
export type UpdateNewsEntryMutationFn = Apollo.MutationFunction<UpdateNewsEntryMutation, UpdateNewsEntryMutationVariables>;

/**
 * __useUpdateNewsEntryMutation__
 *
 * To run a mutation, you first call `useUpdateNewsEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsEntryMutation, { data, loading, error }] = useUpdateNewsEntryMutation({
 *   variables: {
 *      newsEntryId: // value for 'newsEntryId'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateNewsEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsEntryMutation, UpdateNewsEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsEntryMutation, UpdateNewsEntryMutationVariables>(UpdateNewsEntryDocument, options);
      }
export type UpdateNewsEntryMutationHookResult = ReturnType<typeof useUpdateNewsEntryMutation>;
export type UpdateNewsEntryMutationResult = Apollo.MutationResult<UpdateNewsEntryMutation>;
export type UpdateNewsEntryMutationOptions = Apollo.BaseMutationOptions<UpdateNewsEntryMutation, UpdateNewsEntryMutationVariables>;
export const ActivateOrgFeatureDocument = gql`
    mutation ActivateOrgFeature($feature: OrganizationFeature!) {
  featureActivate(feature: $feature) {
    id
    features {
      errands
    }
  }
}
    `;
export type ActivateOrgFeatureMutationFn = Apollo.MutationFunction<ActivateOrgFeatureMutation, ActivateOrgFeatureMutationVariables>;

/**
 * __useActivateOrgFeatureMutation__
 *
 * To run a mutation, you first call `useActivateOrgFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateOrgFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateOrgFeatureMutation, { data, loading, error }] = useActivateOrgFeatureMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useActivateOrgFeatureMutation(baseOptions?: Apollo.MutationHookOptions<ActivateOrgFeatureMutation, ActivateOrgFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateOrgFeatureMutation, ActivateOrgFeatureMutationVariables>(ActivateOrgFeatureDocument, options);
      }
export type ActivateOrgFeatureMutationHookResult = ReturnType<typeof useActivateOrgFeatureMutation>;
export type ActivateOrgFeatureMutationResult = Apollo.MutationResult<ActivateOrgFeatureMutation>;
export type ActivateOrgFeatureMutationOptions = Apollo.BaseMutationOptions<ActivateOrgFeatureMutation, ActivateOrgFeatureMutationVariables>;
export const DisableOrgFeatureDocument = gql`
    mutation DisableOrgFeature($feature: OrganizationFeature!) {
  featureDisable(feature: $feature) {
    id
    features {
      errands
    }
  }
}
    `;
export type DisableOrgFeatureMutationFn = Apollo.MutationFunction<DisableOrgFeatureMutation, DisableOrgFeatureMutationVariables>;

/**
 * __useDisableOrgFeatureMutation__
 *
 * To run a mutation, you first call `useDisableOrgFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableOrgFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableOrgFeatureMutation, { data, loading, error }] = useDisableOrgFeatureMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useDisableOrgFeatureMutation(baseOptions?: Apollo.MutationHookOptions<DisableOrgFeatureMutation, DisableOrgFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableOrgFeatureMutation, DisableOrgFeatureMutationVariables>(DisableOrgFeatureDocument, options);
      }
export type DisableOrgFeatureMutationHookResult = ReturnType<typeof useDisableOrgFeatureMutation>;
export type DisableOrgFeatureMutationResult = Apollo.MutationResult<DisableOrgFeatureMutation>;
export type DisableOrgFeatureMutationOptions = Apollo.BaseMutationOptions<DisableOrgFeatureMutation, DisableOrgFeatureMutationVariables>;
export const PublishWebsiteDocument = gql`
    mutation PublishWebsite($websiteId: ID!) {
  websitePublish(id: $websiteId) {
    id
    published
  }
}
    `;
export type PublishWebsiteMutationFn = Apollo.MutationFunction<PublishWebsiteMutation, PublishWebsiteMutationVariables>;

/**
 * __usePublishWebsiteMutation__
 *
 * To run a mutation, you first call `usePublishWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWebsiteMutation, { data, loading, error }] = usePublishWebsiteMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePublishWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<PublishWebsiteMutation, PublishWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWebsiteMutation, PublishWebsiteMutationVariables>(PublishWebsiteDocument, options);
      }
export type PublishWebsiteMutationHookResult = ReturnType<typeof usePublishWebsiteMutation>;
export type PublishWebsiteMutationResult = Apollo.MutationResult<PublishWebsiteMutation>;
export type PublishWebsiteMutationOptions = Apollo.BaseMutationOptions<PublishWebsiteMutation, PublishWebsiteMutationVariables>;
export const UnpublishWebsiteDocument = gql`
    mutation UnpublishWebsite($websiteId: ID!) {
  websiteUnpublish(id: $websiteId) {
    id
    published
  }
}
    `;
export type UnpublishWebsiteMutationFn = Apollo.MutationFunction<UnpublishWebsiteMutation, UnpublishWebsiteMutationVariables>;

/**
 * __useUnpublishWebsiteMutation__
 *
 * To run a mutation, you first call `useUnpublishWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishWebsiteMutation, { data, loading, error }] = useUnpublishWebsiteMutation({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUnpublishWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishWebsiteMutation, UnpublishWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishWebsiteMutation, UnpublishWebsiteMutationVariables>(UnpublishWebsiteDocument, options);
      }
export type UnpublishWebsiteMutationHookResult = ReturnType<typeof useUnpublishWebsiteMutation>;
export type UnpublishWebsiteMutationResult = Apollo.MutationResult<UnpublishWebsiteMutation>;
export type UnpublishWebsiteMutationOptions = Apollo.BaseMutationOptions<UnpublishWebsiteMutation, UnpublishWebsiteMutationVariables>;
export const AgreementAttachmentsDocument = gql`
    query AgreementAttachments($agreementId: ID!) {
  agreement(id: $agreementId) {
    id
    attachments {
      key
      isDirectory
    }
  }
}
    `;

/**
 * __useAgreementAttachmentsQuery__
 *
 * To run a query within a React component, call `useAgreementAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementAttachmentsQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useAgreementAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>(AgreementAttachmentsDocument, options);
      }
export function useAgreementAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>(AgreementAttachmentsDocument, options);
        }
export function useAgreementAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>(AgreementAttachmentsDocument, options);
        }
export type AgreementAttachmentsQueryHookResult = ReturnType<typeof useAgreementAttachmentsQuery>;
export type AgreementAttachmentsLazyQueryHookResult = ReturnType<typeof useAgreementAttachmentsLazyQuery>;
export type AgreementAttachmentsSuspenseQueryHookResult = ReturnType<typeof useAgreementAttachmentsSuspenseQuery>;
export type AgreementAttachmentsQueryResult = Apollo.QueryResult<AgreementAttachmentsQuery, AgreementAttachmentsQueryVariables>;
export const AgreementNotesDocument = gql`
    query AgreementNotes($agreementId: ID!) {
  agreement(id: $agreementId) {
    id
    notes {
      id
      message
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useAgreementNotesQuery__
 *
 * To run a query within a React component, call `useAgreementNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementNotesQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useAgreementNotesQuery(baseOptions: Apollo.QueryHookOptions<AgreementNotesQuery, AgreementNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgreementNotesQuery, AgreementNotesQueryVariables>(AgreementNotesDocument, options);
      }
export function useAgreementNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementNotesQuery, AgreementNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgreementNotesQuery, AgreementNotesQueryVariables>(AgreementNotesDocument, options);
        }
export function useAgreementNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgreementNotesQuery, AgreementNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgreementNotesQuery, AgreementNotesQueryVariables>(AgreementNotesDocument, options);
        }
export type AgreementNotesQueryHookResult = ReturnType<typeof useAgreementNotesQuery>;
export type AgreementNotesLazyQueryHookResult = ReturnType<typeof useAgreementNotesLazyQuery>;
export type AgreementNotesSuspenseQueryHookResult = ReturnType<typeof useAgreementNotesSuspenseQuery>;
export type AgreementNotesQueryResult = Apollo.QueryResult<AgreementNotesQuery, AgreementNotesQueryVariables>;
export const CreateAgreementNoteDocument = gql`
    mutation CreateAgreementNote($agreementId: ID!, $message: String!) {
  agreementNoteCreate(agreementId: $agreementId, message: $message) {
    id
    notes {
      id
      message
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type CreateAgreementNoteMutationFn = Apollo.MutationFunction<CreateAgreementNoteMutation, CreateAgreementNoteMutationVariables>;

/**
 * __useCreateAgreementNoteMutation__
 *
 * To run a mutation, you first call `useCreateAgreementNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementNoteMutation, { data, loading, error }] = useCreateAgreementNoteMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateAgreementNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgreementNoteMutation, CreateAgreementNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgreementNoteMutation, CreateAgreementNoteMutationVariables>(CreateAgreementNoteDocument, options);
      }
export type CreateAgreementNoteMutationHookResult = ReturnType<typeof useCreateAgreementNoteMutation>;
export type CreateAgreementNoteMutationResult = Apollo.MutationResult<CreateAgreementNoteMutation>;
export type CreateAgreementNoteMutationOptions = Apollo.BaseMutationOptions<CreateAgreementNoteMutation, CreateAgreementNoteMutationVariables>;
export const DeleteAgreementDocument = gql`
    mutation DeleteAgreement($agreementId: ID!) {
  agreementDelete(id: $agreementId)
}
    `;
export type DeleteAgreementMutationFn = Apollo.MutationFunction<DeleteAgreementMutation, DeleteAgreementMutationVariables>;

/**
 * __useDeleteAgreementMutation__
 *
 * To run a mutation, you first call `useDeleteAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgreementMutation, { data, loading, error }] = useDeleteAgreementMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useDeleteAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgreementMutation, DeleteAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgreementMutation, DeleteAgreementMutationVariables>(DeleteAgreementDocument, options);
      }
export type DeleteAgreementMutationHookResult = ReturnType<typeof useDeleteAgreementMutation>;
export type DeleteAgreementMutationResult = Apollo.MutationResult<DeleteAgreementMutation>;
export type DeleteAgreementMutationOptions = Apollo.BaseMutationOptions<DeleteAgreementMutation, DeleteAgreementMutationVariables>;
export const AgreementDetailsDocument = gql`
    query AgreementDetails($agreementId: ID!) {
  agreement(id: $agreementId) {
    id
    title
    description
    validUntil
    companyName
    companyContactName
    companyContactEmail
    companyContactPhone
  }
}
    `;

/**
 * __useAgreementDetailsQuery__
 *
 * To run a query within a React component, call `useAgreementDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementDetailsQuery({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useAgreementDetailsQuery(baseOptions: Apollo.QueryHookOptions<AgreementDetailsQuery, AgreementDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgreementDetailsQuery, AgreementDetailsQueryVariables>(AgreementDetailsDocument, options);
      }
export function useAgreementDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgreementDetailsQuery, AgreementDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgreementDetailsQuery, AgreementDetailsQueryVariables>(AgreementDetailsDocument, options);
        }
export function useAgreementDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgreementDetailsQuery, AgreementDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgreementDetailsQuery, AgreementDetailsQueryVariables>(AgreementDetailsDocument, options);
        }
export type AgreementDetailsQueryHookResult = ReturnType<typeof useAgreementDetailsQuery>;
export type AgreementDetailsLazyQueryHookResult = ReturnType<typeof useAgreementDetailsLazyQuery>;
export type AgreementDetailsSuspenseQueryHookResult = ReturnType<typeof useAgreementDetailsSuspenseQuery>;
export type AgreementDetailsQueryResult = Apollo.QueryResult<AgreementDetailsQuery, AgreementDetailsQueryVariables>;
export const CreateAgreementDocument = gql`
    mutation CreateAgreement($input: AgreementCreateInput!) {
  agreementCreate(input: $input) {
    agreement {
      id
      title
      description
      validUntil
      companyName
      companyContactName
      companyContactEmail
      companyContactPhone
    }
    error
  }
}
    `;
export type CreateAgreementMutationFn = Apollo.MutationFunction<CreateAgreementMutation, CreateAgreementMutationVariables>;

/**
 * __useCreateAgreementMutation__
 *
 * To run a mutation, you first call `useCreateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementMutation, { data, loading, error }] = useCreateAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgreementMutation, CreateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgreementMutation, CreateAgreementMutationVariables>(CreateAgreementDocument, options);
      }
export type CreateAgreementMutationHookResult = ReturnType<typeof useCreateAgreementMutation>;
export type CreateAgreementMutationResult = Apollo.MutationResult<CreateAgreementMutation>;
export type CreateAgreementMutationOptions = Apollo.BaseMutationOptions<CreateAgreementMutation, CreateAgreementMutationVariables>;
export const AllAgreementsDocument = gql`
    query AllAgreements {
  me {
    organization {
      agreements {
        id
        title
        description
        validUntil
      }
    }
  }
}
    `;

/**
 * __useAllAgreementsQuery__
 *
 * To run a query within a React component, call `useAllAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAgreementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAgreementsQuery(baseOptions?: Apollo.QueryHookOptions<AllAgreementsQuery, AllAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAgreementsQuery, AllAgreementsQueryVariables>(AllAgreementsDocument, options);
      }
export function useAllAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAgreementsQuery, AllAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAgreementsQuery, AllAgreementsQueryVariables>(AllAgreementsDocument, options);
        }
export function useAllAgreementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAgreementsQuery, AllAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAgreementsQuery, AllAgreementsQueryVariables>(AllAgreementsDocument, options);
        }
export type AllAgreementsQueryHookResult = ReturnType<typeof useAllAgreementsQuery>;
export type AllAgreementsLazyQueryHookResult = ReturnType<typeof useAllAgreementsLazyQuery>;
export type AllAgreementsSuspenseQueryHookResult = ReturnType<typeof useAllAgreementsSuspenseQuery>;
export type AllAgreementsQueryResult = Apollo.QueryResult<AllAgreementsQuery, AllAgreementsQueryVariables>;
export const OrganizationBookingCategoriesDocument = gql`
    query OrganizationBookingCategories {
  me {
    organization {
      id
      bookingCategories {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useOrganizationBookingCategoriesQuery__
 *
 * To run a query within a React component, call `useOrganizationBookingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBookingCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBookingCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationBookingCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>(OrganizationBookingCategoriesDocument, options);
      }
export function useOrganizationBookingCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>(OrganizationBookingCategoriesDocument, options);
        }
export function useOrganizationBookingCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>(OrganizationBookingCategoriesDocument, options);
        }
export type OrganizationBookingCategoriesQueryHookResult = ReturnType<typeof useOrganizationBookingCategoriesQuery>;
export type OrganizationBookingCategoriesLazyQueryHookResult = ReturnType<typeof useOrganizationBookingCategoriesLazyQuery>;
export type OrganizationBookingCategoriesSuspenseQueryHookResult = ReturnType<typeof useOrganizationBookingCategoriesSuspenseQuery>;
export type OrganizationBookingCategoriesQueryResult = Apollo.QueryResult<OrganizationBookingCategoriesQuery, OrganizationBookingCategoriesQueryVariables>;
export const CreateBookingCategoryDocument = gql`
    mutation CreateBookingCategory($name: String!) {
  bookingCategoryCreate(name: $name) {
    bookingCategory {
      id
      name
      info
    }
    error
  }
}
    `;
export type CreateBookingCategoryMutationFn = Apollo.MutationFunction<CreateBookingCategoryMutation, CreateBookingCategoryMutationVariables>;

/**
 * __useCreateBookingCategoryMutation__
 *
 * To run a mutation, you first call `useCreateBookingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingCategoryMutation, { data, loading, error }] = useCreateBookingCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateBookingCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingCategoryMutation, CreateBookingCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingCategoryMutation, CreateBookingCategoryMutationVariables>(CreateBookingCategoryDocument, options);
      }
export type CreateBookingCategoryMutationHookResult = ReturnType<typeof useCreateBookingCategoryMutation>;
export type CreateBookingCategoryMutationResult = Apollo.MutationResult<CreateBookingCategoryMutation>;
export type CreateBookingCategoryMutationOptions = Apollo.BaseMutationOptions<CreateBookingCategoryMutation, CreateBookingCategoryMutationVariables>;
export const DeleteBookingCategoryDocument = gql`
    mutation DeleteBookingCategory($id: ID!) {
  bookingCategoryDelete(id: $id) {
    error
  }
}
    `;
export type DeleteBookingCategoryMutationFn = Apollo.MutationFunction<DeleteBookingCategoryMutation, DeleteBookingCategoryMutationVariables>;

/**
 * __useDeleteBookingCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteBookingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingCategoryMutation, { data, loading, error }] = useDeleteBookingCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookingCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingCategoryMutation, DeleteBookingCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingCategoryMutation, DeleteBookingCategoryMutationVariables>(DeleteBookingCategoryDocument, options);
      }
export type DeleteBookingCategoryMutationHookResult = ReturnType<typeof useDeleteBookingCategoryMutation>;
export type DeleteBookingCategoryMutationResult = Apollo.MutationResult<DeleteBookingCategoryMutation>;
export type DeleteBookingCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteBookingCategoryMutation, DeleteBookingCategoryMutationVariables>;
export const UpdateBookingCategoryDocument = gql`
    mutation UpdateBookingCategory($input: BookingCategoryUpdateInput!) {
  bookingCategoryUpdate(input: $input) {
    bookingCategory {
      id
      name
      info
    }
    error
  }
}
    `;
export type UpdateBookingCategoryMutationFn = Apollo.MutationFunction<UpdateBookingCategoryMutation, UpdateBookingCategoryMutationVariables>;

/**
 * __useUpdateBookingCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCategoryMutation, { data, loading, error }] = useUpdateBookingCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCategoryMutation, UpdateBookingCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCategoryMutation, UpdateBookingCategoryMutationVariables>(UpdateBookingCategoryDocument, options);
      }
export type UpdateBookingCategoryMutationHookResult = ReturnType<typeof useUpdateBookingCategoryMutation>;
export type UpdateBookingCategoryMutationResult = Apollo.MutationResult<UpdateBookingCategoryMutation>;
export type UpdateBookingCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCategoryMutation, UpdateBookingCategoryMutationVariables>;
export const UpdateBookingCategoryShowNamesOnBookingsDocument = gql`
    mutation UpdateBookingCategoryShowNamesOnBookings($id: ID!, $showNamesOnBookings: Boolean!) {
  bookingCategoryUpdate(
    input: {id: $id, showNamesOnBookings: $showNamesOnBookings}
  ) {
    bookingCategory {
      id
      settings {
        showNamesOnBookings
      }
    }
    error
  }
}
    `;
export type UpdateBookingCategoryShowNamesOnBookingsMutationFn = Apollo.MutationFunction<UpdateBookingCategoryShowNamesOnBookingsMutation, UpdateBookingCategoryShowNamesOnBookingsMutationVariables>;

/**
 * __useUpdateBookingCategoryShowNamesOnBookingsMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCategoryShowNamesOnBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCategoryShowNamesOnBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCategoryShowNamesOnBookingsMutation, { data, loading, error }] = useUpdateBookingCategoryShowNamesOnBookingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      showNamesOnBookings: // value for 'showNamesOnBookings'
 *   },
 * });
 */
export function useUpdateBookingCategoryShowNamesOnBookingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCategoryShowNamesOnBookingsMutation, UpdateBookingCategoryShowNamesOnBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCategoryShowNamesOnBookingsMutation, UpdateBookingCategoryShowNamesOnBookingsMutationVariables>(UpdateBookingCategoryShowNamesOnBookingsDocument, options);
      }
export type UpdateBookingCategoryShowNamesOnBookingsMutationHookResult = ReturnType<typeof useUpdateBookingCategoryShowNamesOnBookingsMutation>;
export type UpdateBookingCategoryShowNamesOnBookingsMutationResult = Apollo.MutationResult<UpdateBookingCategoryShowNamesOnBookingsMutation>;
export type UpdateBookingCategoryShowNamesOnBookingsMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCategoryShowNamesOnBookingsMutation, UpdateBookingCategoryShowNamesOnBookingsMutationVariables>;
export const UpdateBookingCategoryMaxBookingsPerUserDocument = gql`
    mutation UpdateBookingCategoryMaxBookingsPerUser($id: ID!, $maxBookingsPerUser: Int) {
  bookingCategoryUpdateMaxBookingsPerUser(
    id: $id
    maxBookingsPerUser: $maxBookingsPerUser
  ) {
    id
    settings {
      maxBookingsPerUser
    }
  }
}
    `;
export type UpdateBookingCategoryMaxBookingsPerUserMutationFn = Apollo.MutationFunction<UpdateBookingCategoryMaxBookingsPerUserMutation, UpdateBookingCategoryMaxBookingsPerUserMutationVariables>;

/**
 * __useUpdateBookingCategoryMaxBookingsPerUserMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCategoryMaxBookingsPerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCategoryMaxBookingsPerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCategoryMaxBookingsPerUserMutation, { data, loading, error }] = useUpdateBookingCategoryMaxBookingsPerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      maxBookingsPerUser: // value for 'maxBookingsPerUser'
 *   },
 * });
 */
export function useUpdateBookingCategoryMaxBookingsPerUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCategoryMaxBookingsPerUserMutation, UpdateBookingCategoryMaxBookingsPerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCategoryMaxBookingsPerUserMutation, UpdateBookingCategoryMaxBookingsPerUserMutationVariables>(UpdateBookingCategoryMaxBookingsPerUserDocument, options);
      }
export type UpdateBookingCategoryMaxBookingsPerUserMutationHookResult = ReturnType<typeof useUpdateBookingCategoryMaxBookingsPerUserMutation>;
export type UpdateBookingCategoryMaxBookingsPerUserMutationResult = Apollo.MutationResult<UpdateBookingCategoryMaxBookingsPerUserMutation>;
export type UpdateBookingCategoryMaxBookingsPerUserMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCategoryMaxBookingsPerUserMutation, UpdateBookingCategoryMaxBookingsPerUserMutationVariables>;
export const BookingCategorySettingsDocument = gql`
    query BookingCategorySettings($id: ID!) {
  bookingCategory(id: $id) {
    id
    name
    info
    settings {
      showNamesOnBookings
      maxBookingsPerUser
    }
  }
}
    `;

/**
 * __useBookingCategorySettingsQuery__
 *
 * To run a query within a React component, call `useBookingCategorySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCategorySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCategorySettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingCategorySettingsQuery(baseOptions: Apollo.QueryHookOptions<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>(BookingCategorySettingsDocument, options);
      }
export function useBookingCategorySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>(BookingCategorySettingsDocument, options);
        }
export function useBookingCategorySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>(BookingCategorySettingsDocument, options);
        }
export type BookingCategorySettingsQueryHookResult = ReturnType<typeof useBookingCategorySettingsQuery>;
export type BookingCategorySettingsLazyQueryHookResult = ReturnType<typeof useBookingCategorySettingsLazyQuery>;
export type BookingCategorySettingsSuspenseQueryHookResult = ReturnType<typeof useBookingCategorySettingsSuspenseQuery>;
export type BookingCategorySettingsQueryResult = Apollo.QueryResult<BookingCategorySettingsQuery, BookingCategorySettingsQueryVariables>;
export const BookingCategorySlotsAndEntriesDocument = gql`
    query BookingCategorySlotsAndEntries($id: ID!, $from: Time!, $to: Time!) {
  bookingCategory(id: $id) {
    id
    name
    slots(from: $from, to: $to) {
      start
      end
      state
    }
    allEntries(from: $from, to: $to) {
      id
      start
      end
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useBookingCategorySlotsAndEntriesQuery__
 *
 * To run a query within a React component, call `useBookingCategorySlotsAndEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCategorySlotsAndEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCategorySlotsAndEntriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useBookingCategorySlotsAndEntriesQuery(baseOptions: Apollo.QueryHookOptions<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>(BookingCategorySlotsAndEntriesDocument, options);
      }
export function useBookingCategorySlotsAndEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>(BookingCategorySlotsAndEntriesDocument, options);
        }
export function useBookingCategorySlotsAndEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>(BookingCategorySlotsAndEntriesDocument, options);
        }
export type BookingCategorySlotsAndEntriesQueryHookResult = ReturnType<typeof useBookingCategorySlotsAndEntriesQuery>;
export type BookingCategorySlotsAndEntriesLazyQueryHookResult = ReturnType<typeof useBookingCategorySlotsAndEntriesLazyQuery>;
export type BookingCategorySlotsAndEntriesSuspenseQueryHookResult = ReturnType<typeof useBookingCategorySlotsAndEntriesSuspenseQuery>;
export type BookingCategorySlotsAndEntriesQueryResult = Apollo.QueryResult<BookingCategorySlotsAndEntriesQuery, BookingCategorySlotsAndEntriesQueryVariables>;
export const BookingCategorySlotsDocument = gql`
    query BookingCategorySlots($id: ID!, $from: Time!, $to: Time!) {
  bookingCategory(id: $id) {
    id
    name
    slots(from: $from, to: $to) {
      templateId
      start
      end
      state
    }
  }
}
    `;

/**
 * __useBookingCategorySlotsQuery__
 *
 * To run a query within a React component, call `useBookingCategorySlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCategorySlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCategorySlotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useBookingCategorySlotsQuery(baseOptions: Apollo.QueryHookOptions<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>(BookingCategorySlotsDocument, options);
      }
export function useBookingCategorySlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>(BookingCategorySlotsDocument, options);
        }
export function useBookingCategorySlotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>(BookingCategorySlotsDocument, options);
        }
export type BookingCategorySlotsQueryHookResult = ReturnType<typeof useBookingCategorySlotsQuery>;
export type BookingCategorySlotsLazyQueryHookResult = ReturnType<typeof useBookingCategorySlotsLazyQuery>;
export type BookingCategorySlotsSuspenseQueryHookResult = ReturnType<typeof useBookingCategorySlotsSuspenseQuery>;
export type BookingCategorySlotsQueryResult = Apollo.QueryResult<BookingCategorySlotsQuery, BookingCategorySlotsQueryVariables>;
export const CreateBookingTemplateEntryDocument = gql`
    mutation CreateBookingTemplateEntry($input: BookingTemplateEntryCreateInput!) {
  bookingTemplateEntryCreate(input: $input) {
    bookingTemplateEntry {
      id
      startHour
      startMinute
      endHour
      endMinute
      day
    }
    error
  }
}
    `;
export type CreateBookingTemplateEntryMutationFn = Apollo.MutationFunction<CreateBookingTemplateEntryMutation, CreateBookingTemplateEntryMutationVariables>;

/**
 * __useCreateBookingTemplateEntryMutation__
 *
 * To run a mutation, you first call `useCreateBookingTemplateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingTemplateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingTemplateEntryMutation, { data, loading, error }] = useCreateBookingTemplateEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingTemplateEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingTemplateEntryMutation, CreateBookingTemplateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingTemplateEntryMutation, CreateBookingTemplateEntryMutationVariables>(CreateBookingTemplateEntryDocument, options);
      }
export type CreateBookingTemplateEntryMutationHookResult = ReturnType<typeof useCreateBookingTemplateEntryMutation>;
export type CreateBookingTemplateEntryMutationResult = Apollo.MutationResult<CreateBookingTemplateEntryMutation>;
export type CreateBookingTemplateEntryMutationOptions = Apollo.BaseMutationOptions<CreateBookingTemplateEntryMutation, CreateBookingTemplateEntryMutationVariables>;
export const DeleteBookingTemplateEntryDocument = gql`
    mutation DeleteBookingTemplateEntry($id: ID!) {
  bookingTemplateEntryDelete(id: $id)
}
    `;
export type DeleteBookingTemplateEntryMutationFn = Apollo.MutationFunction<DeleteBookingTemplateEntryMutation, DeleteBookingTemplateEntryMutationVariables>;

/**
 * __useDeleteBookingTemplateEntryMutation__
 *
 * To run a mutation, you first call `useDeleteBookingTemplateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingTemplateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingTemplateEntryMutation, { data, loading, error }] = useDeleteBookingTemplateEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookingTemplateEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingTemplateEntryMutation, DeleteBookingTemplateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingTemplateEntryMutation, DeleteBookingTemplateEntryMutationVariables>(DeleteBookingTemplateEntryDocument, options);
      }
export type DeleteBookingTemplateEntryMutationHookResult = ReturnType<typeof useDeleteBookingTemplateEntryMutation>;
export type DeleteBookingTemplateEntryMutationResult = Apollo.MutationResult<DeleteBookingTemplateEntryMutation>;
export type DeleteBookingTemplateEntryMutationOptions = Apollo.BaseMutationOptions<DeleteBookingTemplateEntryMutation, DeleteBookingTemplateEntryMutationVariables>;
export const BookingCategoryDocument = gql`
    query BookingCategory($id: ID!) {
  bookingCategory(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useBookingCategoryQuery__
 *
 * To run a query within a React component, call `useBookingCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingCategoryQuery(baseOptions: Apollo.QueryHookOptions<BookingCategoryQuery, BookingCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingCategoryQuery, BookingCategoryQueryVariables>(BookingCategoryDocument, options);
      }
export function useBookingCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingCategoryQuery, BookingCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingCategoryQuery, BookingCategoryQueryVariables>(BookingCategoryDocument, options);
        }
export function useBookingCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingCategoryQuery, BookingCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingCategoryQuery, BookingCategoryQueryVariables>(BookingCategoryDocument, options);
        }
export type BookingCategoryQueryHookResult = ReturnType<typeof useBookingCategoryQuery>;
export type BookingCategoryLazyQueryHookResult = ReturnType<typeof useBookingCategoryLazyQuery>;
export type BookingCategorySuspenseQueryHookResult = ReturnType<typeof useBookingCategorySuspenseQuery>;
export type BookingCategoryQueryResult = Apollo.QueryResult<BookingCategoryQuery, BookingCategoryQueryVariables>;
export const ApplyBookingTemplateScheduleDocument = gql`
    mutation ApplyBookingTemplateSchedule($bookingCategoryId: ID!, $scheduleId: ID!) {
  bookingTemplateScheduleApply(
    bookingCategoryId: $bookingCategoryId
    scheduleId: $scheduleId
  ) {
    id
  }
}
    `;
export type ApplyBookingTemplateScheduleMutationFn = Apollo.MutationFunction<ApplyBookingTemplateScheduleMutation, ApplyBookingTemplateScheduleMutationVariables>;

/**
 * __useApplyBookingTemplateScheduleMutation__
 *
 * To run a mutation, you first call `useApplyBookingTemplateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyBookingTemplateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyBookingTemplateScheduleMutation, { data, loading, error }] = useApplyBookingTemplateScheduleMutation({
 *   variables: {
 *      bookingCategoryId: // value for 'bookingCategoryId'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useApplyBookingTemplateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ApplyBookingTemplateScheduleMutation, ApplyBookingTemplateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyBookingTemplateScheduleMutation, ApplyBookingTemplateScheduleMutationVariables>(ApplyBookingTemplateScheduleDocument, options);
      }
export type ApplyBookingTemplateScheduleMutationHookResult = ReturnType<typeof useApplyBookingTemplateScheduleMutation>;
export type ApplyBookingTemplateScheduleMutationResult = Apollo.MutationResult<ApplyBookingTemplateScheduleMutation>;
export type ApplyBookingTemplateScheduleMutationOptions = Apollo.BaseMutationOptions<ApplyBookingTemplateScheduleMutation, ApplyBookingTemplateScheduleMutationVariables>;
export const EmailMessageDocument = gql`
    query EmailMessage($id: ID!) {
  emailMessage(id: $id) {
    id
    subject
    body
    createdAt
    deliveries {
      user {
        id
        firstName
        lastName
        phoneNumber
      }
      status
      error
    }
  }
}
    `;

/**
 * __useEmailMessageQuery__
 *
 * To run a query within a React component, call `useEmailMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailMessageQuery(baseOptions: Apollo.QueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessageQuery, EmailMessageQueryVariables>(EmailMessageDocument, options);
      }
export function useEmailMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessageQuery, EmailMessageQueryVariables>(EmailMessageDocument, options);
        }
export function useEmailMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessageQuery, EmailMessageQueryVariables>(EmailMessageDocument, options);
        }
export type EmailMessageQueryHookResult = ReturnType<typeof useEmailMessageQuery>;
export type EmailMessageLazyQueryHookResult = ReturnType<typeof useEmailMessageLazyQuery>;
export type EmailMessageSuspenseQueryHookResult = ReturnType<typeof useEmailMessageSuspenseQuery>;
export type EmailMessageQueryResult = Apollo.QueryResult<EmailMessageQuery, EmailMessageQueryVariables>;
export const SendEmailDocument = gql`
    mutation SendEmail($input: EmailSendMessageInput!) {
  emailSendMessage(input: $input) {
    message {
      id
      subject
      body
      createdAt
      deliveries {
        user {
          id
          firstName
          lastName
        }
        status
        error
      }
    }
  }
}
    `;
export type SendEmailMutationFn = Apollo.MutationFunction<SendEmailMutation, SendEmailMutationVariables>;

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, options);
      }
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>;
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMutation, SendEmailMutationVariables>;
export const SendSmsDocument = gql`
    mutation SendSMS($input: SmsSendMessageInput!) {
  smsSendMessage(input: $input) {
    error
    message {
      id
      body
      createdAt
      deliveries {
        user {
          id
          firstName
          lastName
        }
        status
        error
      }
    }
  }
}
    `;
export type SendSmsMutationFn = Apollo.MutationFunction<SendSmsMutation, SendSmsMutationVariables>;

/**
 * __useSendSmsMutation__
 *
 * To run a mutation, you first call `useSendSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsMutation, { data, loading, error }] = useSendSmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsMutation, SendSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument, options);
      }
export type SendSmsMutationHookResult = ReturnType<typeof useSendSmsMutation>;
export type SendSmsMutationResult = Apollo.MutationResult<SendSmsMutation>;
export type SendSmsMutationOptions = Apollo.BaseMutationOptions<SendSmsMutation, SendSmsMutationVariables>;
export const SmsMessageDocument = gql`
    query SMSMessage($id: ID!) {
  smsMessage(id: $id) {
    id
    body
    createdAt
    deliveries {
      user {
        id
        firstName
        lastName
        phoneNumber
      }
      status
      error
    }
  }
}
    `;

/**
 * __useSmsMessageQuery__
 *
 * To run a query within a React component, call `useSmsMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmsMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmsMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmsMessageQuery(baseOptions: Apollo.QueryHookOptions<SmsMessageQuery, SmsMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmsMessageQuery, SmsMessageQueryVariables>(SmsMessageDocument, options);
      }
export function useSmsMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmsMessageQuery, SmsMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmsMessageQuery, SmsMessageQueryVariables>(SmsMessageDocument, options);
        }
export function useSmsMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmsMessageQuery, SmsMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmsMessageQuery, SmsMessageQueryVariables>(SmsMessageDocument, options);
        }
export type SmsMessageQueryHookResult = ReturnType<typeof useSmsMessageQuery>;
export type SmsMessageLazyQueryHookResult = ReturnType<typeof useSmsMessageLazyQuery>;
export type SmsMessageSuspenseQueryHookResult = ReturnType<typeof useSmsMessageSuspenseQuery>;
export type SmsMessageQueryResult = Apollo.QueryResult<SmsMessageQuery, SmsMessageQueryVariables>;
export const EmailReplyToAddressDocument = gql`
    query EmailReplyToAddress {
  me {
    organization {
      information {
        email
      }
    }
  }
}
    `;

/**
 * __useEmailReplyToAddressQuery__
 *
 * To run a query within a React component, call `useEmailReplyToAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailReplyToAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailReplyToAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailReplyToAddressQuery(baseOptions?: Apollo.QueryHookOptions<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>(EmailReplyToAddressDocument, options);
      }
export function useEmailReplyToAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>(EmailReplyToAddressDocument, options);
        }
export function useEmailReplyToAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>(EmailReplyToAddressDocument, options);
        }
export type EmailReplyToAddressQueryHookResult = ReturnType<typeof useEmailReplyToAddressQuery>;
export type EmailReplyToAddressLazyQueryHookResult = ReturnType<typeof useEmailReplyToAddressLazyQuery>;
export type EmailReplyToAddressSuspenseQueryHookResult = ReturnType<typeof useEmailReplyToAddressSuspenseQuery>;
export type EmailReplyToAddressQueryResult = Apollo.QueryResult<EmailReplyToAddressQuery, EmailReplyToAddressQueryVariables>;
export const SentEmailDocument = gql`
    query SentEmail {
  emailSentMessages {
    id
    subject
    body
    createdAt
  }
}
    `;

/**
 * __useSentEmailQuery__
 *
 * To run a query within a React component, call `useSentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useSentEmailQuery(baseOptions?: Apollo.QueryHookOptions<SentEmailQuery, SentEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentEmailQuery, SentEmailQueryVariables>(SentEmailDocument, options);
      }
export function useSentEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentEmailQuery, SentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentEmailQuery, SentEmailQueryVariables>(SentEmailDocument, options);
        }
export function useSentEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SentEmailQuery, SentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentEmailQuery, SentEmailQueryVariables>(SentEmailDocument, options);
        }
export type SentEmailQueryHookResult = ReturnType<typeof useSentEmailQuery>;
export type SentEmailLazyQueryHookResult = ReturnType<typeof useSentEmailLazyQuery>;
export type SentEmailSuspenseQueryHookResult = ReturnType<typeof useSentEmailSuspenseQuery>;
export type SentEmailQueryResult = Apollo.QueryResult<SentEmailQuery, SentEmailQueryVariables>;
export const SentSmsDocument = gql`
    query SentSMS {
  smsSentMessages {
    id
    body
    createdAt
  }
}
    `;

/**
 * __useSentSmsQuery__
 *
 * To run a query within a React component, call `useSentSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentSmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSentSmsQuery(baseOptions?: Apollo.QueryHookOptions<SentSmsQuery, SentSmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentSmsQuery, SentSmsQueryVariables>(SentSmsDocument, options);
      }
export function useSentSmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentSmsQuery, SentSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentSmsQuery, SentSmsQueryVariables>(SentSmsDocument, options);
        }
export function useSentSmsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SentSmsQuery, SentSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentSmsQuery, SentSmsQueryVariables>(SentSmsDocument, options);
        }
export type SentSmsQueryHookResult = ReturnType<typeof useSentSmsQuery>;
export type SentSmsLazyQueryHookResult = ReturnType<typeof useSentSmsLazyQuery>;
export type SentSmsSuspenseQueryHookResult = ReturnType<typeof useSentSmsSuspenseQuery>;
export type SentSmsQueryResult = Apollo.QueryResult<SentSmsQuery, SentSmsQueryVariables>;
export const SetErrandPendingDocument = gql`
    mutation SetErrandPending($id: ID!, $isPending: Boolean!) {
  errandSetPending(id: $id, isPending: $isPending) {
    id
    isPending
  }
}
    `;
export type SetErrandPendingMutationFn = Apollo.MutationFunction<SetErrandPendingMutation, SetErrandPendingMutationVariables>;

/**
 * __useSetErrandPendingMutation__
 *
 * To run a mutation, you first call `useSetErrandPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetErrandPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setErrandPendingMutation, { data, loading, error }] = useSetErrandPendingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPending: // value for 'isPending'
 *   },
 * });
 */
export function useSetErrandPendingMutation(baseOptions?: Apollo.MutationHookOptions<SetErrandPendingMutation, SetErrandPendingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetErrandPendingMutation, SetErrandPendingMutationVariables>(SetErrandPendingDocument, options);
      }
export type SetErrandPendingMutationHookResult = ReturnType<typeof useSetErrandPendingMutation>;
export type SetErrandPendingMutationResult = Apollo.MutationResult<SetErrandPendingMutation>;
export type SetErrandPendingMutationOptions = Apollo.BaseMutationOptions<SetErrandPendingMutation, SetErrandPendingMutationVariables>;
export const AssignErrandToDocument = gql`
    mutation AssignErrandTo($id: ID!, $userId: ID) {
  errandAssignToUser(id: $id, userId: $userId) {
    id
    assignedTo {
      id
      firstName
      lastName
    }
  }
}
    `;
export type AssignErrandToMutationFn = Apollo.MutationFunction<AssignErrandToMutation, AssignErrandToMutationVariables>;

/**
 * __useAssignErrandToMutation__
 *
 * To run a mutation, you first call `useAssignErrandToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignErrandToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignErrandToMutation, { data, loading, error }] = useAssignErrandToMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignErrandToMutation(baseOptions?: Apollo.MutationHookOptions<AssignErrandToMutation, AssignErrandToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignErrandToMutation, AssignErrandToMutationVariables>(AssignErrandToDocument, options);
      }
export type AssignErrandToMutationHookResult = ReturnType<typeof useAssignErrandToMutation>;
export type AssignErrandToMutationResult = Apollo.MutationResult<AssignErrandToMutation>;
export type AssignErrandToMutationOptions = Apollo.BaseMutationOptions<AssignErrandToMutation, AssignErrandToMutationVariables>;
export const CompleteErrandDocument = gql`
    mutation CompleteErrand($id: ID!) {
  errandClose(id: $id) {
    id
    completedAt
  }
}
    `;
export type CompleteErrandMutationFn = Apollo.MutationFunction<CompleteErrandMutation, CompleteErrandMutationVariables>;

/**
 * __useCompleteErrandMutation__
 *
 * To run a mutation, you first call `useCompleteErrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteErrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeErrandMutation, { data, loading, error }] = useCompleteErrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteErrandMutation(baseOptions?: Apollo.MutationHookOptions<CompleteErrandMutation, CompleteErrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteErrandMutation, CompleteErrandMutationVariables>(CompleteErrandDocument, options);
      }
export type CompleteErrandMutationHookResult = ReturnType<typeof useCompleteErrandMutation>;
export type CompleteErrandMutationResult = Apollo.MutationResult<CompleteErrandMutation>;
export type CompleteErrandMutationOptions = Apollo.BaseMutationOptions<CompleteErrandMutation, CompleteErrandMutationVariables>;
export const CreateErrandTypeDocument = gql`
    mutation CreateErrandType($name: String!) {
  errandTypeCreate(name: $name) {
    errandType {
      id
      displayName
    }
    error
  }
}
    `;
export type CreateErrandTypeMutationFn = Apollo.MutationFunction<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>;

/**
 * __useCreateErrandTypeMutation__
 *
 * To run a mutation, you first call `useCreateErrandTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandTypeMutation, { data, loading, error }] = useCreateErrandTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateErrandTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>(CreateErrandTypeDocument, options);
      }
export type CreateErrandTypeMutationHookResult = ReturnType<typeof useCreateErrandTypeMutation>;
export type CreateErrandTypeMutationResult = Apollo.MutationResult<CreateErrandTypeMutation>;
export type CreateErrandTypeMutationOptions = Apollo.BaseMutationOptions<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>;
export const DeleteErrandTypeDocument = gql`
    mutation DeleteErrandType($errandTypeId: String!) {
  errandTypeDelete(errandTypeId: $errandTypeId) {
    error
  }
}
    `;
export type DeleteErrandTypeMutationFn = Apollo.MutationFunction<DeleteErrandTypeMutation, DeleteErrandTypeMutationVariables>;

/**
 * __useDeleteErrandTypeMutation__
 *
 * To run a mutation, you first call `useDeleteErrandTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrandTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrandTypeMutation, { data, loading, error }] = useDeleteErrandTypeMutation({
 *   variables: {
 *      errandTypeId: // value for 'errandTypeId'
 *   },
 * });
 */
export function useDeleteErrandTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrandTypeMutation, DeleteErrandTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrandTypeMutation, DeleteErrandTypeMutationVariables>(DeleteErrandTypeDocument, options);
      }
export type DeleteErrandTypeMutationHookResult = ReturnType<typeof useDeleteErrandTypeMutation>;
export type DeleteErrandTypeMutationResult = Apollo.MutationResult<DeleteErrandTypeMutation>;
export type DeleteErrandTypeMutationOptions = Apollo.BaseMutationOptions<DeleteErrandTypeMutation, DeleteErrandTypeMutationVariables>;
export const ErrandCountDocument = gql`
    query ErrandCount($filter: ErrandsFilter) {
  errands(filter: $filter) {
    id
  }
}
    `;

/**
 * __useErrandCountQuery__
 *
 * To run a query within a React component, call `useErrandCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useErrandCountQuery(baseOptions?: Apollo.QueryHookOptions<ErrandCountQuery, ErrandCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandCountQuery, ErrandCountQueryVariables>(ErrandCountDocument, options);
      }
export function useErrandCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandCountQuery, ErrandCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandCountQuery, ErrandCountQueryVariables>(ErrandCountDocument, options);
        }
export function useErrandCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandCountQuery, ErrandCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandCountQuery, ErrandCountQueryVariables>(ErrandCountDocument, options);
        }
export type ErrandCountQueryHookResult = ReturnType<typeof useErrandCountQuery>;
export type ErrandCountLazyQueryHookResult = ReturnType<typeof useErrandCountLazyQuery>;
export type ErrandCountSuspenseQueryHookResult = ReturnType<typeof useErrandCountSuspenseQuery>;
export type ErrandCountQueryResult = Apollo.QueryResult<ErrandCountQuery, ErrandCountQueryVariables>;
export const ErrandTypeDocument = gql`
    query ErrandType($id: ID!) {
  errandType(id: $id) {
    id
    displayName
  }
}
    `;

/**
 * __useErrandTypeQuery__
 *
 * To run a query within a React component, call `useErrandTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErrandTypeQuery(baseOptions: Apollo.QueryHookOptions<ErrandTypeQuery, ErrandTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandTypeQuery, ErrandTypeQueryVariables>(ErrandTypeDocument, options);
      }
export function useErrandTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandTypeQuery, ErrandTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandTypeQuery, ErrandTypeQueryVariables>(ErrandTypeDocument, options);
        }
export function useErrandTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandTypeQuery, ErrandTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandTypeQuery, ErrandTypeQueryVariables>(ErrandTypeDocument, options);
        }
export type ErrandTypeQueryHookResult = ReturnType<typeof useErrandTypeQuery>;
export type ErrandTypeLazyQueryHookResult = ReturnType<typeof useErrandTypeLazyQuery>;
export type ErrandTypeSuspenseQueryHookResult = ReturnType<typeof useErrandTypeSuspenseQuery>;
export type ErrandTypeQueryResult = Apollo.QueryResult<ErrandTypeQuery, ErrandTypeQueryVariables>;
export const ErrandTypesDocument = gql`
    query ErrandTypes {
  errandTypes {
    id
    displayName
  }
}
    `;

/**
 * __useErrandTypesQuery__
 *
 * To run a query within a React component, call `useErrandTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErrandTypesQuery(baseOptions?: Apollo.QueryHookOptions<ErrandTypesQuery, ErrandTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandTypesQuery, ErrandTypesQueryVariables>(ErrandTypesDocument, options);
      }
export function useErrandTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandTypesQuery, ErrandTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandTypesQuery, ErrandTypesQueryVariables>(ErrandTypesDocument, options);
        }
export function useErrandTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandTypesQuery, ErrandTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandTypesQuery, ErrandTypesQueryVariables>(ErrandTypesDocument, options);
        }
export type ErrandTypesQueryHookResult = ReturnType<typeof useErrandTypesQuery>;
export type ErrandTypesLazyQueryHookResult = ReturnType<typeof useErrandTypesLazyQuery>;
export type ErrandTypesSuspenseQueryHookResult = ReturnType<typeof useErrandTypesSuspenseQuery>;
export type ErrandTypesQueryResult = Apollo.QueryResult<ErrandTypesQuery, ErrandTypesQueryVariables>;
export const ErrandDocument = gql`
    query Errand($id: ID!) {
  errand(id: $id) {
    id
    originator {
      phoneNumber
      email
    }
    body
    createdAt
    completedAt
    isPending
    apartmentNumber
    assignedTo {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useErrandQuery__
 *
 * To run a query within a React component, call `useErrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useErrandQuery(baseOptions: Apollo.QueryHookOptions<ErrandQuery, ErrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandQuery, ErrandQueryVariables>(ErrandDocument, options);
      }
export function useErrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandQuery, ErrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandQuery, ErrandQueryVariables>(ErrandDocument, options);
        }
export function useErrandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandQuery, ErrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandQuery, ErrandQueryVariables>(ErrandDocument, options);
        }
export type ErrandQueryHookResult = ReturnType<typeof useErrandQuery>;
export type ErrandLazyQueryHookResult = ReturnType<typeof useErrandLazyQuery>;
export type ErrandSuspenseQueryHookResult = ReturnType<typeof useErrandSuspenseQuery>;
export type ErrandQueryResult = Apollo.QueryResult<ErrandQuery, ErrandQueryVariables>;
export const ErrandsDocument = gql`
    query Errands($filter: ErrandsFilter) {
  errands(filter: $filter) {
    id
    type {
      id
      displayName
    }
    status
    body
    createdAt
    completedAt
    apartmentNumber
    isPending
    originator {
      phoneNumber
      email
    }
    assignedTo {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useErrandsQuery__
 *
 * To run a query within a React component, call `useErrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useErrandsQuery(baseOptions?: Apollo.QueryHookOptions<ErrandsQuery, ErrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandsQuery, ErrandsQueryVariables>(ErrandsDocument, options);
      }
export function useErrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandsQuery, ErrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandsQuery, ErrandsQueryVariables>(ErrandsDocument, options);
        }
export function useErrandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandsQuery, ErrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandsQuery, ErrandsQueryVariables>(ErrandsDocument, options);
        }
export type ErrandsQueryHookResult = ReturnType<typeof useErrandsQuery>;
export type ErrandsLazyQueryHookResult = ReturnType<typeof useErrandsLazyQuery>;
export type ErrandsSuspenseQueryHookResult = ReturnType<typeof useErrandsSuspenseQuery>;
export type ErrandsQueryResult = Apollo.QueryResult<ErrandsQuery, ErrandsQueryVariables>;
export const UpdateErrandsExpiryDocument = gql`
    mutation UpdateErrandsExpiry($expiryInDays: Int) {
  errandsExpiryUpdate(expiryInDays: $expiryInDays) {
    id
    errandsExpireInDays
  }
}
    `;
export type UpdateErrandsExpiryMutationFn = Apollo.MutationFunction<UpdateErrandsExpiryMutation, UpdateErrandsExpiryMutationVariables>;

/**
 * __useUpdateErrandsExpiryMutation__
 *
 * To run a mutation, you first call `useUpdateErrandsExpiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrandsExpiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrandsExpiryMutation, { data, loading, error }] = useUpdateErrandsExpiryMutation({
 *   variables: {
 *      expiryInDays: // value for 'expiryInDays'
 *   },
 * });
 */
export function useUpdateErrandsExpiryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrandsExpiryMutation, UpdateErrandsExpiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrandsExpiryMutation, UpdateErrandsExpiryMutationVariables>(UpdateErrandsExpiryDocument, options);
      }
export type UpdateErrandsExpiryMutationHookResult = ReturnType<typeof useUpdateErrandsExpiryMutation>;
export type UpdateErrandsExpiryMutationResult = Apollo.MutationResult<UpdateErrandsExpiryMutation>;
export type UpdateErrandsExpiryMutationOptions = Apollo.BaseMutationOptions<UpdateErrandsExpiryMutation, UpdateErrandsExpiryMutationVariables>;
export const UpdateErrandTypeDocument = gql`
    mutation UpdateErrandType($input: ErrandTypeUpdateInput!) {
  errandTypeUpdate(input: $input) {
    errandType {
      id
      displayName
    }
    error
  }
}
    `;
export type UpdateErrandTypeMutationFn = Apollo.MutationFunction<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>;

/**
 * __useUpdateErrandTypeMutation__
 *
 * To run a mutation, you first call `useUpdateErrandTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrandTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrandTypeMutation, { data, loading, error }] = useUpdateErrandTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateErrandTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>(UpdateErrandTypeDocument, options);
      }
export type UpdateErrandTypeMutationHookResult = ReturnType<typeof useUpdateErrandTypeMutation>;
export type UpdateErrandTypeMutationResult = Apollo.MutationResult<UpdateErrandTypeMutation>;
export type UpdateErrandTypeMutationOptions = Apollo.BaseMutationOptions<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>;
export const ErrandsExpiryDocument = gql`
    query ErrandsExpiry {
  me {
    organization {
      id
      errandsExpireInDays
    }
  }
}
    `;

/**
 * __useErrandsExpiryQuery__
 *
 * To run a query within a React component, call `useErrandsExpiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandsExpiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandsExpiryQuery({
 *   variables: {
 *   },
 * });
 */
export function useErrandsExpiryQuery(baseOptions?: Apollo.QueryHookOptions<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>(ErrandsExpiryDocument, options);
      }
export function useErrandsExpiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>(ErrandsExpiryDocument, options);
        }
export function useErrandsExpirySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>(ErrandsExpiryDocument, options);
        }
export type ErrandsExpiryQueryHookResult = ReturnType<typeof useErrandsExpiryQuery>;
export type ErrandsExpiryLazyQueryHookResult = ReturnType<typeof useErrandsExpiryLazyQuery>;
export type ErrandsExpirySuspenseQueryHookResult = ReturnType<typeof useErrandsExpirySuspenseQuery>;
export type ErrandsExpiryQueryResult = Apollo.QueryResult<ErrandsExpiryQuery, ErrandsExpiryQueryVariables>;
export const GetInfoTextDocument = gql`
    query GetInfoText {
  me {
    organization {
      id
      errandInfoText
    }
  }
}
    `;

/**
 * __useGetInfoTextQuery__
 *
 * To run a query within a React component, call `useGetInfoTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoTextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInfoTextQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoTextQuery, GetInfoTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoTextQuery, GetInfoTextQueryVariables>(GetInfoTextDocument, options);
      }
export function useGetInfoTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoTextQuery, GetInfoTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoTextQuery, GetInfoTextQueryVariables>(GetInfoTextDocument, options);
        }
export function useGetInfoTextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInfoTextQuery, GetInfoTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoTextQuery, GetInfoTextQueryVariables>(GetInfoTextDocument, options);
        }
export type GetInfoTextQueryHookResult = ReturnType<typeof useGetInfoTextQuery>;
export type GetInfoTextLazyQueryHookResult = ReturnType<typeof useGetInfoTextLazyQuery>;
export type GetInfoTextSuspenseQueryHookResult = ReturnType<typeof useGetInfoTextSuspenseQuery>;
export type GetInfoTextQueryResult = Apollo.QueryResult<GetInfoTextQuery, GetInfoTextQueryVariables>;
export const UpdateInfoTextDocument = gql`
    mutation UpdateInfoText($info: String!) {
  errandInfoUpdate(info: $info) {
    id
    errandInfoText
  }
}
    `;
export type UpdateInfoTextMutationFn = Apollo.MutationFunction<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>;

/**
 * __useUpdateInfoTextMutation__
 *
 * To run a mutation, you first call `useUpdateInfoTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInfoTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInfoTextMutation, { data, loading, error }] = useUpdateInfoTextMutation({
 *   variables: {
 *      info: // value for 'info'
 *   },
 * });
 */
export function useUpdateInfoTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>(UpdateInfoTextDocument, options);
      }
export type UpdateInfoTextMutationHookResult = ReturnType<typeof useUpdateInfoTextMutation>;
export type UpdateInfoTextMutationResult = Apollo.MutationResult<UpdateInfoTextMutation>;
export type UpdateInfoTextMutationOptions = Apollo.BaseMutationOptions<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>;
export const FileDocument = gql`
    query File($key: String!, $namespace: FileNamespace!) {
  file(key: $key, namespace: $namespace) {
    key
    displayName
    url
    signedUrl
    size
    contentType
    uploadedAt
  }
}
    `;

/**
 * __useFileQuery__
 *
 * To run a query within a React component, call `useFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileQuery({
 *   variables: {
 *      key: // value for 'key'
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useFileQuery(baseOptions: Apollo.QueryHookOptions<FileQuery, FileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileQuery, FileQueryVariables>(FileDocument, options);
      }
export function useFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileQuery, FileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileQuery, FileQueryVariables>(FileDocument, options);
        }
export function useFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileQuery, FileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileQuery, FileQueryVariables>(FileDocument, options);
        }
export type FileQueryHookResult = ReturnType<typeof useFileQuery>;
export type FileLazyQueryHookResult = ReturnType<typeof useFileLazyQuery>;
export type FileSuspenseQueryHookResult = ReturnType<typeof useFileSuspenseQuery>;
export type FileQueryResult = Apollo.QueryResult<FileQuery, FileQueryVariables>;
export const MeNotificationSettingsDocument = gql`
    query MeNotificationSettings {
  me {
    user {
      id
      firstName
      lastName
    }
    notificationSettings {
      receiveErrandNotifications
      receiveUserRegistrationNotifications
    }
  }
}
    `;

/**
 * __useMeNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useMeNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>(MeNotificationSettingsDocument, options);
      }
export function useMeNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>(MeNotificationSettingsDocument, options);
        }
export function useMeNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>(MeNotificationSettingsDocument, options);
        }
export type MeNotificationSettingsQueryHookResult = ReturnType<typeof useMeNotificationSettingsQuery>;
export type MeNotificationSettingsLazyQueryHookResult = ReturnType<typeof useMeNotificationSettingsLazyQuery>;
export type MeNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useMeNotificationSettingsSuspenseQuery>;
export type MeNotificationSettingsQueryResult = Apollo.QueryResult<MeNotificationSettingsQuery, MeNotificationSettingsQueryVariables>;
export const UpdateErrandNotificationSettingsDocument = gql`
    mutation UpdateErrandNotificationSettings($errandNotifications: Boolean!) {
  notificationSettingsUpdate(
    input: {receiveErrandNotifications: $errandNotifications}
  ) {
    notificationSettings {
      receiveErrandNotifications
    }
  }
}
    `;
export type UpdateErrandNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateErrandNotificationSettingsMutation, UpdateErrandNotificationSettingsMutationVariables>;

/**
 * __useUpdateErrandNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateErrandNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrandNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrandNotificationSettingsMutation, { data, loading, error }] = useUpdateErrandNotificationSettingsMutation({
 *   variables: {
 *      errandNotifications: // value for 'errandNotifications'
 *   },
 * });
 */
export function useUpdateErrandNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrandNotificationSettingsMutation, UpdateErrandNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrandNotificationSettingsMutation, UpdateErrandNotificationSettingsMutationVariables>(UpdateErrandNotificationSettingsDocument, options);
      }
export type UpdateErrandNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateErrandNotificationSettingsMutation>;
export type UpdateErrandNotificationSettingsMutationResult = Apollo.MutationResult<UpdateErrandNotificationSettingsMutation>;
export type UpdateErrandNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateErrandNotificationSettingsMutation, UpdateErrandNotificationSettingsMutationVariables>;
export const UpdateUserRegistrationNotificationSettingsDocument = gql`
    mutation UpdateUserRegistrationNotificationSettings($userRegistrationNotifications: Boolean!) {
  notificationSettingsUpdate(
    input: {receiveUserRegistrationNotifications: $userRegistrationNotifications}
  ) {
    notificationSettings {
      receiveUserRegistrationNotifications
    }
  }
}
    `;
export type UpdateUserRegistrationNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateUserRegistrationNotificationSettingsMutation, UpdateUserRegistrationNotificationSettingsMutationVariables>;

/**
 * __useUpdateUserRegistrationNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserRegistrationNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRegistrationNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRegistrationNotificationSettingsMutation, { data, loading, error }] = useUpdateUserRegistrationNotificationSettingsMutation({
 *   variables: {
 *      userRegistrationNotifications: // value for 'userRegistrationNotifications'
 *   },
 * });
 */
export function useUpdateUserRegistrationNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRegistrationNotificationSettingsMutation, UpdateUserRegistrationNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRegistrationNotificationSettingsMutation, UpdateUserRegistrationNotificationSettingsMutationVariables>(UpdateUserRegistrationNotificationSettingsDocument, options);
      }
export type UpdateUserRegistrationNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateUserRegistrationNotificationSettingsMutation>;
export type UpdateUserRegistrationNotificationSettingsMutationResult = Apollo.MutationResult<UpdateUserRegistrationNotificationSettingsMutation>;
export type UpdateUserRegistrationNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserRegistrationNotificationSettingsMutation, UpdateUserRegistrationNotificationSettingsMutationVariables>;
export const GetUsersByIdsDocument = gql`
    query GetUsersByIds($userIds: [ID!]!) {
  users(ids: $userIds) {
    id
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetUsersByIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetUsersByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>(GetUsersByIdsDocument, options);
      }
export function useGetUsersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>(GetUsersByIdsDocument, options);
        }
export function useGetUsersByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>(GetUsersByIdsDocument, options);
        }
export type GetUsersByIdsQueryHookResult = ReturnType<typeof useGetUsersByIdsQuery>;
export type GetUsersByIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByIdsLazyQuery>;
export type GetUsersByIdsSuspenseQueryHookResult = ReturnType<typeof useGetUsersByIdsSuspenseQuery>;
export type GetUsersByIdsQueryResult = Apollo.QueryResult<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>;
export const CreateMeetingProposalDocument = gql`
    mutation CreateMeetingProposal($input: MeetingProposalCreateInput!) {
  meetingProposalCreate(input: $input) {
    meetingProposal {
      id
      title
      description
    }
    error
  }
}
    `;
export type CreateMeetingProposalMutationFn = Apollo.MutationFunction<CreateMeetingProposalMutation, CreateMeetingProposalMutationVariables>;

/**
 * __useCreateMeetingProposalMutation__
 *
 * To run a mutation, you first call `useCreateMeetingProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingProposalMutation, { data, loading, error }] = useCreateMeetingProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeetingProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingProposalMutation, CreateMeetingProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingProposalMutation, CreateMeetingProposalMutationVariables>(CreateMeetingProposalDocument, options);
      }
export type CreateMeetingProposalMutationHookResult = ReturnType<typeof useCreateMeetingProposalMutation>;
export type CreateMeetingProposalMutationResult = Apollo.MutationResult<CreateMeetingProposalMutation>;
export type CreateMeetingProposalMutationOptions = Apollo.BaseMutationOptions<CreateMeetingProposalMutation, CreateMeetingProposalMutationVariables>;
export const GetMeetingProposalsDocument = gql`
    query GetMeetingProposals {
  me {
    organization {
      id
      meetingProposals {
        id
        title
        description
        completed
        pickedTimeslot {
          id
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useGetMeetingProposalsQuery__
 *
 * To run a query within a React component, call `useGetMeetingProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingProposalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeetingProposalsQuery(baseOptions?: Apollo.QueryHookOptions<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>(GetMeetingProposalsDocument, options);
      }
export function useGetMeetingProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>(GetMeetingProposalsDocument, options);
        }
export function useGetMeetingProposalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>(GetMeetingProposalsDocument, options);
        }
export type GetMeetingProposalsQueryHookResult = ReturnType<typeof useGetMeetingProposalsQuery>;
export type GetMeetingProposalsLazyQueryHookResult = ReturnType<typeof useGetMeetingProposalsLazyQuery>;
export type GetMeetingProposalsSuspenseQueryHookResult = ReturnType<typeof useGetMeetingProposalsSuspenseQuery>;
export type GetMeetingProposalsQueryResult = Apollo.QueryResult<GetMeetingProposalsQuery, GetMeetingProposalsQueryVariables>;
export const AddMeetingProposalTimeslotDocument = gql`
    mutation AddMeetingProposalTimeslot($meetingProposalId: ID!, $start: Time!, $end: Time!) {
  meetingProposalAddTimeslot(
    meetingProposalId: $meetingProposalId
    start: $start
    end: $end
  ) {
    meetingProposal {
      id
      timeslots {
        id
        start
        end
      }
    }
    error
  }
}
    `;
export type AddMeetingProposalTimeslotMutationFn = Apollo.MutationFunction<AddMeetingProposalTimeslotMutation, AddMeetingProposalTimeslotMutationVariables>;

/**
 * __useAddMeetingProposalTimeslotMutation__
 *
 * To run a mutation, you first call `useAddMeetingProposalTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMeetingProposalTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMeetingProposalTimeslotMutation, { data, loading, error }] = useAddMeetingProposalTimeslotMutation({
 *   variables: {
 *      meetingProposalId: // value for 'meetingProposalId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useAddMeetingProposalTimeslotMutation(baseOptions?: Apollo.MutationHookOptions<AddMeetingProposalTimeslotMutation, AddMeetingProposalTimeslotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMeetingProposalTimeslotMutation, AddMeetingProposalTimeslotMutationVariables>(AddMeetingProposalTimeslotDocument, options);
      }
export type AddMeetingProposalTimeslotMutationHookResult = ReturnType<typeof useAddMeetingProposalTimeslotMutation>;
export type AddMeetingProposalTimeslotMutationResult = Apollo.MutationResult<AddMeetingProposalTimeslotMutation>;
export type AddMeetingProposalTimeslotMutationOptions = Apollo.BaseMutationOptions<AddMeetingProposalTimeslotMutation, AddMeetingProposalTimeslotMutationVariables>;
export const RemoveMeetingProposalTimeslotDocument = gql`
    mutation RemoveMeetingProposalTimeslot($timeslotId: ID!) {
  meetingProposalRemoveTimeslot(timeslotId: $timeslotId) {
    id
    timeslots {
      id
      start
      end
    }
  }
}
    `;
export type RemoveMeetingProposalTimeslotMutationFn = Apollo.MutationFunction<RemoveMeetingProposalTimeslotMutation, RemoveMeetingProposalTimeslotMutationVariables>;

/**
 * __useRemoveMeetingProposalTimeslotMutation__
 *
 * To run a mutation, you first call `useRemoveMeetingProposalTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMeetingProposalTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMeetingProposalTimeslotMutation, { data, loading, error }] = useRemoveMeetingProposalTimeslotMutation({
 *   variables: {
 *      timeslotId: // value for 'timeslotId'
 *   },
 * });
 */
export function useRemoveMeetingProposalTimeslotMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMeetingProposalTimeslotMutation, RemoveMeetingProposalTimeslotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMeetingProposalTimeslotMutation, RemoveMeetingProposalTimeslotMutationVariables>(RemoveMeetingProposalTimeslotDocument, options);
      }
export type RemoveMeetingProposalTimeslotMutationHookResult = ReturnType<typeof useRemoveMeetingProposalTimeslotMutation>;
export type RemoveMeetingProposalTimeslotMutationResult = Apollo.MutationResult<RemoveMeetingProposalTimeslotMutation>;
export type RemoveMeetingProposalTimeslotMutationOptions = Apollo.BaseMutationOptions<RemoveMeetingProposalTimeslotMutation, RemoveMeetingProposalTimeslotMutationVariables>;
export const FinishMeetingProposalPageDocument = gql`
    query FinishMeetingProposalPage($id: ID!) {
  meetingProposal(id: $id) {
    id
    title
    description
    completed
    timeslots {
      id
      start
      end
      votes {
        id
        participant {
          id
          email
          name
          noVote
          hasOpened
        }
      }
    }
  }
}
    `;

/**
 * __useFinishMeetingProposalPageQuery__
 *
 * To run a query within a React component, call `useFinishMeetingProposalPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishMeetingProposalPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishMeetingProposalPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishMeetingProposalPageQuery(baseOptions: Apollo.QueryHookOptions<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>(FinishMeetingProposalPageDocument, options);
      }
export function useFinishMeetingProposalPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>(FinishMeetingProposalPageDocument, options);
        }
export function useFinishMeetingProposalPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>(FinishMeetingProposalPageDocument, options);
        }
export type FinishMeetingProposalPageQueryHookResult = ReturnType<typeof useFinishMeetingProposalPageQuery>;
export type FinishMeetingProposalPageLazyQueryHookResult = ReturnType<typeof useFinishMeetingProposalPageLazyQuery>;
export type FinishMeetingProposalPageSuspenseQueryHookResult = ReturnType<typeof useFinishMeetingProposalPageSuspenseQuery>;
export type FinishMeetingProposalPageQueryResult = Apollo.QueryResult<FinishMeetingProposalPageQuery, FinishMeetingProposalPageQueryVariables>;
export const FinishMeetingProposalDocument = gql`
    mutation FinishMeetingProposal($timeslotId: ID!, $message: String) {
  meetingProposalPickTimeslot(input: {timeslotId: $timeslotId, message: $message}) {
    id
    completed
    pickedTimeslot {
      id
      start
      end
    }
  }
}
    `;
export type FinishMeetingProposalMutationFn = Apollo.MutationFunction<FinishMeetingProposalMutation, FinishMeetingProposalMutationVariables>;

/**
 * __useFinishMeetingProposalMutation__
 *
 * To run a mutation, you first call `useFinishMeetingProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMeetingProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMeetingProposalMutation, { data, loading, error }] = useFinishMeetingProposalMutation({
 *   variables: {
 *      timeslotId: // value for 'timeslotId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useFinishMeetingProposalMutation(baseOptions?: Apollo.MutationHookOptions<FinishMeetingProposalMutation, FinishMeetingProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishMeetingProposalMutation, FinishMeetingProposalMutationVariables>(FinishMeetingProposalDocument, options);
      }
export type FinishMeetingProposalMutationHookResult = ReturnType<typeof useFinishMeetingProposalMutation>;
export type FinishMeetingProposalMutationResult = Apollo.MutationResult<FinishMeetingProposalMutation>;
export type FinishMeetingProposalMutationOptions = Apollo.BaseMutationOptions<FinishMeetingProposalMutation, FinishMeetingProposalMutationVariables>;
export const AddParticipantToMeetingProposalDocument = gql`
    mutation AddParticipantToMeetingProposal($meetingProposalId: ID!, $participant: MeetingProposalParticipantInput!) {
  meetingProposalAddParticipant(
    meetingProposalId: $meetingProposalId
    participant: $participant
  ) {
    meetingProposal {
      id
      participants {
        id
        email
        name
        user {
          id
        }
      }
    }
  }
}
    `;
export type AddParticipantToMeetingProposalMutationFn = Apollo.MutationFunction<AddParticipantToMeetingProposalMutation, AddParticipantToMeetingProposalMutationVariables>;

/**
 * __useAddParticipantToMeetingProposalMutation__
 *
 * To run a mutation, you first call `useAddParticipantToMeetingProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddParticipantToMeetingProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addParticipantToMeetingProposalMutation, { data, loading, error }] = useAddParticipantToMeetingProposalMutation({
 *   variables: {
 *      meetingProposalId: // value for 'meetingProposalId'
 *      participant: // value for 'participant'
 *   },
 * });
 */
export function useAddParticipantToMeetingProposalMutation(baseOptions?: Apollo.MutationHookOptions<AddParticipantToMeetingProposalMutation, AddParticipantToMeetingProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddParticipantToMeetingProposalMutation, AddParticipantToMeetingProposalMutationVariables>(AddParticipantToMeetingProposalDocument, options);
      }
export type AddParticipantToMeetingProposalMutationHookResult = ReturnType<typeof useAddParticipantToMeetingProposalMutation>;
export type AddParticipantToMeetingProposalMutationResult = Apollo.MutationResult<AddParticipantToMeetingProposalMutation>;
export type AddParticipantToMeetingProposalMutationOptions = Apollo.BaseMutationOptions<AddParticipantToMeetingProposalMutation, AddParticipantToMeetingProposalMutationVariables>;
export const RemoveMeetingProposalParticipantDocument = gql`
    mutation RemoveMeetingProposalParticipant($participantId: ID!) {
  meetingProposalRemoveParticipant(participantId: $participantId) {
    id
    participants {
      id
      email
      name
      user {
        id
      }
    }
  }
}
    `;
export type RemoveMeetingProposalParticipantMutationFn = Apollo.MutationFunction<RemoveMeetingProposalParticipantMutation, RemoveMeetingProposalParticipantMutationVariables>;

/**
 * __useRemoveMeetingProposalParticipantMutation__
 *
 * To run a mutation, you first call `useRemoveMeetingProposalParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMeetingProposalParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMeetingProposalParticipantMutation, { data, loading, error }] = useRemoveMeetingProposalParticipantMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useRemoveMeetingProposalParticipantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMeetingProposalParticipantMutation, RemoveMeetingProposalParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMeetingProposalParticipantMutation, RemoveMeetingProposalParticipantMutationVariables>(RemoveMeetingProposalParticipantDocument, options);
      }
export type RemoveMeetingProposalParticipantMutationHookResult = ReturnType<typeof useRemoveMeetingProposalParticipantMutation>;
export type RemoveMeetingProposalParticipantMutationResult = Apollo.MutationResult<RemoveMeetingProposalParticipantMutation>;
export type RemoveMeetingProposalParticipantMutationOptions = Apollo.BaseMutationOptions<RemoveMeetingProposalParticipantMutation, RemoveMeetingProposalParticipantMutationVariables>;
export const GetMeetingProposalDocument = gql`
    query GetMeetingProposal($id: ID!) {
  meetingProposal(id: $id) {
    id
    title
    description
    completed
    pickedTimeslot {
      id
      start
      end
    }
    participants {
      id
      name
      email
      noVote
      hasVoted
      hasOpened
      user {
        id
      }
    }
    timeslots {
      id
      start
      end
      votes {
        id
        participant {
          id
          email
          name
          noVote
          hasOpened
          user {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMeetingProposalQuery__
 *
 * To run a query within a React component, call `useGetMeetingProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMeetingProposalQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>(GetMeetingProposalDocument, options);
      }
export function useGetMeetingProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>(GetMeetingProposalDocument, options);
        }
export function useGetMeetingProposalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>(GetMeetingProposalDocument, options);
        }
export type GetMeetingProposalQueryHookResult = ReturnType<typeof useGetMeetingProposalQuery>;
export type GetMeetingProposalLazyQueryHookResult = ReturnType<typeof useGetMeetingProposalLazyQuery>;
export type GetMeetingProposalSuspenseQueryHookResult = ReturnType<typeof useGetMeetingProposalSuspenseQuery>;
export type GetMeetingProposalQueryResult = Apollo.QueryResult<GetMeetingProposalQuery, GetMeetingProposalQueryVariables>;
export const UserUserGroupsDocument = gql`
    query UserUserGroups($userId: ID!) {
  user(id: $userId) {
    id
    groups {
      id
      name
    }
  }
}
    `;

/**
 * __useUserUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUserGroupsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<UserUserGroupsQuery, UserUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserUserGroupsQuery, UserUserGroupsQueryVariables>(UserUserGroupsDocument, options);
      }
export function useUserUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserUserGroupsQuery, UserUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserUserGroupsQuery, UserUserGroupsQueryVariables>(UserUserGroupsDocument, options);
        }
export function useUserUserGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserUserGroupsQuery, UserUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserUserGroupsQuery, UserUserGroupsQueryVariables>(UserUserGroupsDocument, options);
        }
export type UserUserGroupsQueryHookResult = ReturnType<typeof useUserUserGroupsQuery>;
export type UserUserGroupsLazyQueryHookResult = ReturnType<typeof useUserUserGroupsLazyQuery>;
export type UserUserGroupsSuspenseQueryHookResult = ReturnType<typeof useUserUserGroupsSuspenseQuery>;
export type UserUserGroupsQueryResult = Apollo.QueryResult<UserUserGroupsQuery, UserUserGroupsQueryVariables>;
export const UserDocument = gql`
    query User($userId: ID!) {
  user(id: $userId) {
    id
    firstName
    lastName
    email
    phoneNumber
    role
    verified
    apartmentNumber
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: ID!, $firstName: String, $lastName: String, $role: Role, $apartmentNumber: String) {
  userUpdate(
    input: {userId: $userId, firstName: $firstName, lastName: $lastName, role: $role, apartmentNumber: $apartmentNumber}
  ) {
    id
    firstName
    lastName
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *      apartmentNumber: // value for 'apartmentNumber'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const InfoPageGroupsDocument = gql`
    query InfoPageGroups {
  infoPageGroups
}
    `;

/**
 * __useInfoPageGroupsQuery__
 *
 * To run a query within a React component, call `useInfoPageGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPageGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPageGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoPageGroupsQuery(baseOptions?: Apollo.QueryHookOptions<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>(InfoPageGroupsDocument, options);
      }
export function useInfoPageGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>(InfoPageGroupsDocument, options);
        }
export function useInfoPageGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>(InfoPageGroupsDocument, options);
        }
export type InfoPageGroupsQueryHookResult = ReturnType<typeof useInfoPageGroupsQuery>;
export type InfoPageGroupsLazyQueryHookResult = ReturnType<typeof useInfoPageGroupsLazyQuery>;
export type InfoPageGroupsSuspenseQueryHookResult = ReturnType<typeof useInfoPageGroupsSuspenseQuery>;
export type InfoPageGroupsQueryResult = Apollo.QueryResult<InfoPageGroupsQuery, InfoPageGroupsQueryVariables>;
export const MemberPageGroupsDocument = gql`
    query MemberPageGroups {
  memberPageGroups
}
    `;

/**
 * __useMemberPageGroupsQuery__
 *
 * To run a query within a React component, call `useMemberPageGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPageGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPageGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberPageGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>(MemberPageGroupsDocument, options);
      }
export function useMemberPageGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>(MemberPageGroupsDocument, options);
        }
export function useMemberPageGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>(MemberPageGroupsDocument, options);
        }
export type MemberPageGroupsQueryHookResult = ReturnType<typeof useMemberPageGroupsQuery>;
export type MemberPageGroupsLazyQueryHookResult = ReturnType<typeof useMemberPageGroupsLazyQuery>;
export type MemberPageGroupsSuspenseQueryHookResult = ReturnType<typeof useMemberPageGroupsSuspenseQuery>;
export type MemberPageGroupsQueryResult = Apollo.QueryResult<MemberPageGroupsQuery, MemberPageGroupsQueryVariables>;
export const CreateMemberDocument = gql`
    mutation CreateMember($input: UserCreateInput!) {
  userCreate(input: $input) {
    user {
      id
      firstName
      lastName
      phoneNumber
      email
      role
      verified
    }
    error
  }
}
    `;
export type CreateMemberMutationFn = Apollo.MutationFunction<CreateMemberMutation, CreateMemberMutationVariables>;

/**
 * __useCreateMemberMutation__
 *
 * To run a mutation, you first call `useCreateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemberMutation, { data, loading, error }] = useCreateMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateMemberMutation, CreateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMemberMutation, CreateMemberMutationVariables>(CreateMemberDocument, options);
      }
export type CreateMemberMutationHookResult = ReturnType<typeof useCreateMemberMutation>;
export type CreateMemberMutationResult = Apollo.MutationResult<CreateMemberMutation>;
export type CreateMemberMutationOptions = Apollo.BaseMutationOptions<CreateMemberMutation, CreateMemberMutationVariables>;
export const DeleteMemberDocument = gql`
    mutation DeleteMember($id: ID!) {
  userDelete(id: $id)
}
    `;
export type DeleteMemberMutationFn = Apollo.MutationFunction<DeleteMemberMutation, DeleteMemberMutationVariables>;

/**
 * __useDeleteMemberMutation__
 *
 * To run a mutation, you first call `useDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemberMutation, { data, loading, error }] = useDeleteMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemberMutation, DeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, options);
      }
export type DeleteMemberMutationHookResult = ReturnType<typeof useDeleteMemberMutation>;
export type DeleteMemberMutationResult = Apollo.MutationResult<DeleteMemberMutation>;
export type DeleteMemberMutationOptions = Apollo.BaseMutationOptions<DeleteMemberMutation, DeleteMemberMutationVariables>;
export const CreateUserGroupDocument = gql`
    mutation CreateUserGroup($name: String!) {
  userGroupCreate(input: {name: $name}) {
    userGroup {
      id
      name
      numberOfUsers
      users {
        id
        firstName
        lastName
      }
    }
    error
  }
}
    `;
export type CreateUserGroupMutationFn = Apollo.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, options);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = Apollo.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const UpdateUserGroupNameDocument = gql`
    mutation UpdateUserGroupName($id: ID!, $name: String!) {
  userGroupUpdateName(input: {id: $id, name: $name}) {
    userGroup {
      id
      name
    }
    error
  }
}
    `;
export type UpdateUserGroupNameMutationFn = Apollo.MutationFunction<UpdateUserGroupNameMutation, UpdateUserGroupNameMutationVariables>;

/**
 * __useUpdateUserGroupNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGroupNameMutation, { data, loading, error }] = useUpdateUserGroupNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateUserGroupNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGroupNameMutation, UpdateUserGroupNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGroupNameMutation, UpdateUserGroupNameMutationVariables>(UpdateUserGroupNameDocument, options);
      }
export type UpdateUserGroupNameMutationHookResult = ReturnType<typeof useUpdateUserGroupNameMutation>;
export type UpdateUserGroupNameMutationResult = Apollo.MutationResult<UpdateUserGroupNameMutation>;
export type UpdateUserGroupNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserGroupNameMutation, UpdateUserGroupNameMutationVariables>;
export const DeleteUserGroupDocument = gql`
    mutation DeleteUserGroup($id: ID!) {
  userGroupDelete(id: $id)
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const AddUserToUserGroupDocument = gql`
    mutation AddUserToUserGroup($userId: ID!, $userGroupId: ID!) {
  userGroupAddUser(input: {userId: $userId, userGroupId: $userGroupId}) {
    id
    name
    numberOfUsers
    users {
      id
      firstName
      lastName
    }
  }
}
    `;
export type AddUserToUserGroupMutationFn = Apollo.MutationFunction<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>;

/**
 * __useAddUserToUserGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToUserGroupMutation, { data, loading, error }] = useAddUserToUserGroupMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useAddUserToUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>(AddUserToUserGroupDocument, options);
      }
export type AddUserToUserGroupMutationHookResult = ReturnType<typeof useAddUserToUserGroupMutation>;
export type AddUserToUserGroupMutationResult = Apollo.MutationResult<AddUserToUserGroupMutation>;
export type AddUserToUserGroupMutationOptions = Apollo.BaseMutationOptions<AddUserToUserGroupMutation, AddUserToUserGroupMutationVariables>;
export const RemoveUserFromUserGroupDocument = gql`
    mutation RemoveUserFromUserGroup($userId: ID!, $userGroupId: ID!) {
  userGroupRemoveUser(input: {userId: $userId, userGroupId: $userGroupId}) {
    id
    name
    numberOfUsers
    users {
      id
      firstName
      lastName
    }
  }
}
    `;
export type RemoveUserFromUserGroupMutationFn = Apollo.MutationFunction<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>;

/**
 * __useRemoveUserFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromUserGroupMutation, { data, loading, error }] = useRemoveUserFromUserGroupMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useRemoveUserFromUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>(RemoveUserFromUserGroupDocument, options);
      }
export type RemoveUserFromUserGroupMutationHookResult = ReturnType<typeof useRemoveUserFromUserGroupMutation>;
export type RemoveUserFromUserGroupMutationResult = Apollo.MutationResult<RemoveUserFromUserGroupMutation>;
export type RemoveUserFromUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromUserGroupMutation, RemoveUserFromUserGroupMutationVariables>;
export const AddUsersToUserGroupDocument = gql`
    mutation AddUsersToUserGroup($userIds: [ID!]!, $userGroupId: ID!) {
  userGroupAddUsers(input: {userIds: $userIds, userGroupId: $userGroupId}) {
    id
    name
    numberOfUsers
    users {
      id
      firstName
      lastName
      groups {
        id
        name
      }
    }
  }
}
    `;
export type AddUsersToUserGroupMutationFn = Apollo.MutationFunction<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>;

/**
 * __useAddUsersToUserGroupMutation__
 *
 * To run a mutation, you first call `useAddUsersToUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToUserGroupMutation, { data, loading, error }] = useAddUsersToUserGroupMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useAddUsersToUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>(AddUsersToUserGroupDocument, options);
      }
export type AddUsersToUserGroupMutationHookResult = ReturnType<typeof useAddUsersToUserGroupMutation>;
export type AddUsersToUserGroupMutationResult = Apollo.MutationResult<AddUsersToUserGroupMutation>;
export type AddUsersToUserGroupMutationOptions = Apollo.BaseMutationOptions<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>;
export const RemoveUsersFromUserGroupDocument = gql`
    mutation RemoveUsersFromUserGroup($userIds: [ID!]!, $userGroupId: ID!) {
  userGroupRemoveUsers(input: {userIds: $userIds, userGroupId: $userGroupId}) {
    id
    name
    numberOfUsers
    users {
      id
      firstName
      lastName
    }
  }
}
    `;
export type RemoveUsersFromUserGroupMutationFn = Apollo.MutationFunction<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>;

/**
 * __useRemoveUsersFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromUserGroupMutation, { data, loading, error }] = useRemoveUsersFromUserGroupMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useRemoveUsersFromUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>(RemoveUsersFromUserGroupDocument, options);
      }
export type RemoveUsersFromUserGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromUserGroupMutation>;
export type RemoveUsersFromUserGroupMutationResult = Apollo.MutationResult<RemoveUsersFromUserGroupMutation>;
export type RemoveUsersFromUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>;
export const UserGroupDocument = gql`
    query UserGroup($id: ID!) {
  userGroup(id: $id) {
    id
    name
    numberOfUsers
    users {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useUserGroupQuery__
 *
 * To run a query within a React component, call `useUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupQuery(baseOptions: Apollo.QueryHookOptions<UserGroupQuery, UserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, options);
      }
export function useUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupQuery, UserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, options);
        }
export function useUserGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupQuery, UserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, options);
        }
export type UserGroupQueryHookResult = ReturnType<typeof useUserGroupQuery>;
export type UserGroupLazyQueryHookResult = ReturnType<typeof useUserGroupLazyQuery>;
export type UserGroupSuspenseQueryHookResult = ReturnType<typeof useUserGroupSuspenseQuery>;
export type UserGroupQueryResult = Apollo.QueryResult<UserGroupQuery, UserGroupQueryVariables>;
export const UserGroupsDocument = gql`
    query UserGroups {
  userGroups {
    id
    name
    numberOfUsers
  }
}
    `;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
      }
export function useUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export function useUserGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsSuspenseQueryHookResult = ReturnType<typeof useUserGroupsSuspenseQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const CreateInviteLinkDocument = gql`
    mutation CreateInviteLink {
  inviteLinkCreate {
    id
    inviteLinkId
  }
}
    `;
export type CreateInviteLinkMutationFn = Apollo.MutationFunction<CreateInviteLinkMutation, CreateInviteLinkMutationVariables>;

/**
 * __useCreateInviteLinkMutation__
 *
 * To run a mutation, you first call `useCreateInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteLinkMutation, { data, loading, error }] = useCreateInviteLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateInviteLinkMutation, CreateInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInviteLinkMutation, CreateInviteLinkMutationVariables>(CreateInviteLinkDocument, options);
      }
export type CreateInviteLinkMutationHookResult = ReturnType<typeof useCreateInviteLinkMutation>;
export type CreateInviteLinkMutationResult = Apollo.MutationResult<CreateInviteLinkMutation>;
export type CreateInviteLinkMutationOptions = Apollo.BaseMutationOptions<CreateInviteLinkMutation, CreateInviteLinkMutationVariables>;
export const ApproveUserDocument = gql`
    mutation ApproveUser($id: ID!) {
  userApprove(id: $id) {
    id
    verifiedByAdmin
  }
}
    `;
export type ApproveUserMutationFn = Apollo.MutationFunction<ApproveUserMutation, ApproveUserMutationVariables>;

/**
 * __useApproveUserMutation__
 *
 * To run a mutation, you first call `useApproveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveUserMutation, { data, loading, error }] = useApproveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveUserMutation(baseOptions?: Apollo.MutationHookOptions<ApproveUserMutation, ApproveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveUserMutation, ApproveUserMutationVariables>(ApproveUserDocument, options);
      }
export type ApproveUserMutationHookResult = ReturnType<typeof useApproveUserMutation>;
export type ApproveUserMutationResult = Apollo.MutationResult<ApproveUserMutation>;
export type ApproveUserMutationOptions = Apollo.BaseMutationOptions<ApproveUserMutation, ApproveUserMutationVariables>;
export const DeleteInfoPageDocument = gql`
    mutation DeleteInfoPage($infoPageId: ID!) {
  infoPageDelete(id: $infoPageId)
}
    `;
export type DeleteInfoPageMutationFn = Apollo.MutationFunction<DeleteInfoPageMutation, DeleteInfoPageMutationVariables>;

/**
 * __useDeleteInfoPageMutation__
 *
 * To run a mutation, you first call `useDeleteInfoPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInfoPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInfoPageMutation, { data, loading, error }] = useDeleteInfoPageMutation({
 *   variables: {
 *      infoPageId: // value for 'infoPageId'
 *   },
 * });
 */
export function useDeleteInfoPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInfoPageMutation, DeleteInfoPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInfoPageMutation, DeleteInfoPageMutationVariables>(DeleteInfoPageDocument, options);
      }
export type DeleteInfoPageMutationHookResult = ReturnType<typeof useDeleteInfoPageMutation>;
export type DeleteInfoPageMutationResult = Apollo.MutationResult<DeleteInfoPageMutation>;
export type DeleteInfoPageMutationOptions = Apollo.BaseMutationOptions<DeleteInfoPageMutation, DeleteInfoPageMutationVariables>;
export const UpdateInfoPageDocument = gql`
    mutation UpdateInfoPage($infoPageId: ID!, $title: String!, $body: String!, $group: String) {
  infoPageUpdate(
    input: {infoPageId: $infoPageId, title: $title, body: $body, group: $group}
  ) {
    id
    title
    body
    group
    slug
  }
}
    `;
export type UpdateInfoPageMutationFn = Apollo.MutationFunction<UpdateInfoPageMutation, UpdateInfoPageMutationVariables>;

/**
 * __useUpdateInfoPageMutation__
 *
 * To run a mutation, you first call `useUpdateInfoPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInfoPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInfoPageMutation, { data, loading, error }] = useUpdateInfoPageMutation({
 *   variables: {
 *      infoPageId: // value for 'infoPageId'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpdateInfoPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInfoPageMutation, UpdateInfoPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInfoPageMutation, UpdateInfoPageMutationVariables>(UpdateInfoPageDocument, options);
      }
export type UpdateInfoPageMutationHookResult = ReturnType<typeof useUpdateInfoPageMutation>;
export type UpdateInfoPageMutationResult = Apollo.MutationResult<UpdateInfoPageMutation>;
export type UpdateInfoPageMutationOptions = Apollo.BaseMutationOptions<UpdateInfoPageMutation, UpdateInfoPageMutationVariables>;
export const AssignInfoPagesToGroupDocument = gql`
    mutation AssignInfoPagesToGroup($group: String, $infoPageIds: [ID!]!) {
  infoPagesUpdateGroup(input: {group: $group, infoPageIds: $infoPageIds}) {
    id
    group
  }
}
    `;
export type AssignInfoPagesToGroupMutationFn = Apollo.MutationFunction<AssignInfoPagesToGroupMutation, AssignInfoPagesToGroupMutationVariables>;

/**
 * __useAssignInfoPagesToGroupMutation__
 *
 * To run a mutation, you first call `useAssignInfoPagesToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignInfoPagesToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignInfoPagesToGroupMutation, { data, loading, error }] = useAssignInfoPagesToGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *      infoPageIds: // value for 'infoPageIds'
 *   },
 * });
 */
export function useAssignInfoPagesToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AssignInfoPagesToGroupMutation, AssignInfoPagesToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignInfoPagesToGroupMutation, AssignInfoPagesToGroupMutationVariables>(AssignInfoPagesToGroupDocument, options);
      }
export type AssignInfoPagesToGroupMutationHookResult = ReturnType<typeof useAssignInfoPagesToGroupMutation>;
export type AssignInfoPagesToGroupMutationResult = Apollo.MutationResult<AssignInfoPagesToGroupMutation>;
export type AssignInfoPagesToGroupMutationOptions = Apollo.BaseMutationOptions<AssignInfoPagesToGroupMutation, AssignInfoPagesToGroupMutationVariables>;
export const ClearInfoPagesGroupDocument = gql`
    mutation ClearInfoPagesGroup($infoPageIds: [ID!]!) {
  infoPagesUpdateGroup(input: {group: null, infoPageIds: $infoPageIds}) {
    id
    group
  }
}
    `;
export type ClearInfoPagesGroupMutationFn = Apollo.MutationFunction<ClearInfoPagesGroupMutation, ClearInfoPagesGroupMutationVariables>;

/**
 * __useClearInfoPagesGroupMutation__
 *
 * To run a mutation, you first call `useClearInfoPagesGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearInfoPagesGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearInfoPagesGroupMutation, { data, loading, error }] = useClearInfoPagesGroupMutation({
 *   variables: {
 *      infoPageIds: // value for 'infoPageIds'
 *   },
 * });
 */
export function useClearInfoPagesGroupMutation(baseOptions?: Apollo.MutationHookOptions<ClearInfoPagesGroupMutation, ClearInfoPagesGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearInfoPagesGroupMutation, ClearInfoPagesGroupMutationVariables>(ClearInfoPagesGroupDocument, options);
      }
export type ClearInfoPagesGroupMutationHookResult = ReturnType<typeof useClearInfoPagesGroupMutation>;
export type ClearInfoPagesGroupMutationResult = Apollo.MutationResult<ClearInfoPagesGroupMutation>;
export type ClearInfoPagesGroupMutationOptions = Apollo.BaseMutationOptions<ClearInfoPagesGroupMutation, ClearInfoPagesGroupMutationVariables>;
export const InfoPageDocument = gql`
    query InfoPage($infoPageId: ID!) {
  infoPage(id: $infoPageId) {
    id
    title
    body
    group
  }
}
    `;

/**
 * __useInfoPageQuery__
 *
 * To run a query within a React component, call `useInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPageQuery({
 *   variables: {
 *      infoPageId: // value for 'infoPageId'
 *   },
 * });
 */
export function useInfoPageQuery(baseOptions: Apollo.QueryHookOptions<InfoPageQuery, InfoPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPageQuery, InfoPageQueryVariables>(InfoPageDocument, options);
      }
export function useInfoPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPageQuery, InfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPageQuery, InfoPageQueryVariables>(InfoPageDocument, options);
        }
export function useInfoPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InfoPageQuery, InfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoPageQuery, InfoPageQueryVariables>(InfoPageDocument, options);
        }
export type InfoPageQueryHookResult = ReturnType<typeof useInfoPageQuery>;
export type InfoPageLazyQueryHookResult = ReturnType<typeof useInfoPageLazyQuery>;
export type InfoPageSuspenseQueryHookResult = ReturnType<typeof useInfoPageSuspenseQuery>;
export type InfoPageQueryResult = Apollo.QueryResult<InfoPageQuery, InfoPageQueryVariables>;
export const ChangeSortOrderDocument = gql`
    mutation ChangeSortOrder($pageId: ID!, $order: Int!) {
  infoPageChangeSortOrder(input: {infoPageId: $pageId, sortOrder: $order}) {
    id
    sortOrder
  }
}
    `;
export type ChangeSortOrderMutationFn = Apollo.MutationFunction<ChangeSortOrderMutation, ChangeSortOrderMutationVariables>;

/**
 * __useChangeSortOrderMutation__
 *
 * To run a mutation, you first call `useChangeSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSortOrderMutation, { data, loading, error }] = useChangeSortOrderMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useChangeSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSortOrderMutation, ChangeSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSortOrderMutation, ChangeSortOrderMutationVariables>(ChangeSortOrderDocument, options);
      }
export type ChangeSortOrderMutationHookResult = ReturnType<typeof useChangeSortOrderMutation>;
export type ChangeSortOrderMutationResult = Apollo.MutationResult<ChangeSortOrderMutation>;
export type ChangeSortOrderMutationOptions = Apollo.BaseMutationOptions<ChangeSortOrderMutation, ChangeSortOrderMutationVariables>;
export const ChangeGroupSortOrderDocument = gql`
    mutation ChangeGroupSortOrder($group: String!, $order: Int!, $restricted: Boolean!) {
  infoPageGroupChangeSortOrder(
    input: {infoPageGroup: $group, sortOrder: $order, restricted: $restricted}
  ) {
    id
    sortOrder
  }
}
    `;
export type ChangeGroupSortOrderMutationFn = Apollo.MutationFunction<ChangeGroupSortOrderMutation, ChangeGroupSortOrderMutationVariables>;

/**
 * __useChangeGroupSortOrderMutation__
 *
 * To run a mutation, you first call `useChangeGroupSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGroupSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGroupSortOrderMutation, { data, loading, error }] = useChangeGroupSortOrderMutation({
 *   variables: {
 *      group: // value for 'group'
 *      order: // value for 'order'
 *      restricted: // value for 'restricted'
 *   },
 * });
 */
export function useChangeGroupSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<ChangeGroupSortOrderMutation, ChangeGroupSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeGroupSortOrderMutation, ChangeGroupSortOrderMutationVariables>(ChangeGroupSortOrderDocument, options);
      }
export type ChangeGroupSortOrderMutationHookResult = ReturnType<typeof useChangeGroupSortOrderMutation>;
export type ChangeGroupSortOrderMutationResult = Apollo.MutationResult<ChangeGroupSortOrderMutation>;
export type ChangeGroupSortOrderMutationOptions = Apollo.BaseMutationOptions<ChangeGroupSortOrderMutation, ChangeGroupSortOrderMutationVariables>;
export const WebsiteInfoPagesDocument = gql`
    query WebsiteInfoPages {
  me {
    organization {
      website {
        infoPages {
          id
          title
          group
          sortOrder
        }
        memberInfoPages {
          id
          title
          group
          sortOrder
        }
      }
    }
  }
}
    `;

/**
 * __useWebsiteInfoPagesQuery__
 *
 * To run a query within a React component, call `useWebsiteInfoPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteInfoPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteInfoPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebsiteInfoPagesQuery(baseOptions?: Apollo.QueryHookOptions<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>(WebsiteInfoPagesDocument, options);
      }
export function useWebsiteInfoPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>(WebsiteInfoPagesDocument, options);
        }
export function useWebsiteInfoPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>(WebsiteInfoPagesDocument, options);
        }
export type WebsiteInfoPagesQueryHookResult = ReturnType<typeof useWebsiteInfoPagesQuery>;
export type WebsiteInfoPagesLazyQueryHookResult = ReturnType<typeof useWebsiteInfoPagesLazyQuery>;
export type WebsiteInfoPagesSuspenseQueryHookResult = ReturnType<typeof useWebsiteInfoPagesSuspenseQuery>;
export type WebsiteInfoPagesQueryResult = Apollo.QueryResult<WebsiteInfoPagesQuery, WebsiteInfoPagesQueryVariables>;
export const MakeInfoPagePrivateDocument = gql`
    mutation MakeInfoPagePrivate($infoPageId: ID!) {
  infoPageUpdateVisibility(id: $infoPageId, restricted: true) {
    error
  }
}
    `;
export type MakeInfoPagePrivateMutationFn = Apollo.MutationFunction<MakeInfoPagePrivateMutation, MakeInfoPagePrivateMutationVariables>;

/**
 * __useMakeInfoPagePrivateMutation__
 *
 * To run a mutation, you first call `useMakeInfoPagePrivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeInfoPagePrivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeInfoPagePrivateMutation, { data, loading, error }] = useMakeInfoPagePrivateMutation({
 *   variables: {
 *      infoPageId: // value for 'infoPageId'
 *   },
 * });
 */
export function useMakeInfoPagePrivateMutation(baseOptions?: Apollo.MutationHookOptions<MakeInfoPagePrivateMutation, MakeInfoPagePrivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeInfoPagePrivateMutation, MakeInfoPagePrivateMutationVariables>(MakeInfoPagePrivateDocument, options);
      }
export type MakeInfoPagePrivateMutationHookResult = ReturnType<typeof useMakeInfoPagePrivateMutation>;
export type MakeInfoPagePrivateMutationResult = Apollo.MutationResult<MakeInfoPagePrivateMutation>;
export type MakeInfoPagePrivateMutationOptions = Apollo.BaseMutationOptions<MakeInfoPagePrivateMutation, MakeInfoPagePrivateMutationVariables>;
export const CreateInfoPageDocument = gql`
    mutation CreateInfoPage($title: String!, $body: String!, $group: String) {
  infoPageCreate(
    input: {title: $title, body: $body, restricted: false, group: $group}
  ) {
    id
    title
    body
    slug
  }
}
    `;
export type CreateInfoPageMutationFn = Apollo.MutationFunction<CreateInfoPageMutation, CreateInfoPageMutationVariables>;

/**
 * __useCreateInfoPageMutation__
 *
 * To run a mutation, you first call `useCreateInfoPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInfoPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInfoPageMutation, { data, loading, error }] = useCreateInfoPageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateInfoPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateInfoPageMutation, CreateInfoPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInfoPageMutation, CreateInfoPageMutationVariables>(CreateInfoPageDocument, options);
      }
export type CreateInfoPageMutationHookResult = ReturnType<typeof useCreateInfoPageMutation>;
export type CreateInfoPageMutationResult = Apollo.MutationResult<CreateInfoPageMutation>;
export type CreateInfoPageMutationOptions = Apollo.BaseMutationOptions<CreateInfoPageMutation, CreateInfoPageMutationVariables>;
export const MakeInfoPagePublicDocument = gql`
    mutation MakeInfoPagePublic($infoPageId: ID!) {
  infoPageUpdateVisibility(id: $infoPageId, restricted: false) {
    error
  }
}
    `;
export type MakeInfoPagePublicMutationFn = Apollo.MutationFunction<MakeInfoPagePublicMutation, MakeInfoPagePublicMutationVariables>;

/**
 * __useMakeInfoPagePublicMutation__
 *
 * To run a mutation, you first call `useMakeInfoPagePublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeInfoPagePublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeInfoPagePublicMutation, { data, loading, error }] = useMakeInfoPagePublicMutation({
 *   variables: {
 *      infoPageId: // value for 'infoPageId'
 *   },
 * });
 */
export function useMakeInfoPagePublicMutation(baseOptions?: Apollo.MutationHookOptions<MakeInfoPagePublicMutation, MakeInfoPagePublicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeInfoPagePublicMutation, MakeInfoPagePublicMutationVariables>(MakeInfoPagePublicDocument, options);
      }
export type MakeInfoPagePublicMutationHookResult = ReturnType<typeof useMakeInfoPagePublicMutation>;
export type MakeInfoPagePublicMutationResult = Apollo.MutationResult<MakeInfoPagePublicMutation>;
export type MakeInfoPagePublicMutationOptions = Apollo.BaseMutationOptions<MakeInfoPagePublicMutation, MakeInfoPagePublicMutationVariables>;
export const CreateRestrictedInfoPageDocument = gql`
    mutation CreateRestrictedInfoPage($title: String!, $body: String!, $group: String) {
  infoPageCreate(
    input: {title: $title, body: $body, restricted: true, group: $group}
  ) {
    id
    title
    body
    slug
  }
}
    `;
export type CreateRestrictedInfoPageMutationFn = Apollo.MutationFunction<CreateRestrictedInfoPageMutation, CreateRestrictedInfoPageMutationVariables>;

/**
 * __useCreateRestrictedInfoPageMutation__
 *
 * To run a mutation, you first call `useCreateRestrictedInfoPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRestrictedInfoPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRestrictedInfoPageMutation, { data, loading, error }] = useCreateRestrictedInfoPageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateRestrictedInfoPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateRestrictedInfoPageMutation, CreateRestrictedInfoPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRestrictedInfoPageMutation, CreateRestrictedInfoPageMutationVariables>(CreateRestrictedInfoPageDocument, options);
      }
export type CreateRestrictedInfoPageMutationHookResult = ReturnType<typeof useCreateRestrictedInfoPageMutation>;
export type CreateRestrictedInfoPageMutationResult = Apollo.MutationResult<CreateRestrictedInfoPageMutation>;
export type CreateRestrictedInfoPageMutationOptions = Apollo.BaseMutationOptions<CreateRestrictedInfoPageMutation, CreateRestrictedInfoPageMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: OrganizationUpdateInput!) {
  organizationUpdate(input: $input) {
    id
    information {
      address
      city
      postalCode
      email
      contactFirstName
      contactLastName
      contactEmail
      contactPhoneNumber
      billingDetails
      billingEmail
      orgNumber
    }
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateCustomDomainDocument = gql`
    mutation UpdateCustomDomain($domain: String) {
  websiteUpdateCustomDomain(domain: $domain) {
    website {
      id
      domain
      domainValidatedAt
    }
    error
  }
}
    `;
export type UpdateCustomDomainMutationFn = Apollo.MutationFunction<UpdateCustomDomainMutation, UpdateCustomDomainMutationVariables>;

/**
 * __useUpdateCustomDomainMutation__
 *
 * To run a mutation, you first call `useUpdateCustomDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomDomainMutation, { data, loading, error }] = useUpdateCustomDomainMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useUpdateCustomDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomDomainMutation, UpdateCustomDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomDomainMutation, UpdateCustomDomainMutationVariables>(UpdateCustomDomainDocument, options);
      }
export type UpdateCustomDomainMutationHookResult = ReturnType<typeof useUpdateCustomDomainMutation>;
export type UpdateCustomDomainMutationResult = Apollo.MutationResult<UpdateCustomDomainMutation>;
export type UpdateCustomDomainMutationOptions = Apollo.BaseMutationOptions<UpdateCustomDomainMutation, UpdateCustomDomainMutationVariables>;
export const ValidateDomainRecordsDocument = gql`
    mutation ValidateDomainRecords {
  websiteValidateRecords {
    firstRecordFound
    secondRecordFound
    thirdRecordFound
    website {
      id
      domain
      domainValidatedAt
    }
  }
}
    `;
export type ValidateDomainRecordsMutationFn = Apollo.MutationFunction<ValidateDomainRecordsMutation, ValidateDomainRecordsMutationVariables>;

/**
 * __useValidateDomainRecordsMutation__
 *
 * To run a mutation, you first call `useValidateDomainRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDomainRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDomainRecordsMutation, { data, loading, error }] = useValidateDomainRecordsMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateDomainRecordsMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDomainRecordsMutation, ValidateDomainRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDomainRecordsMutation, ValidateDomainRecordsMutationVariables>(ValidateDomainRecordsDocument, options);
      }
export type ValidateDomainRecordsMutationHookResult = ReturnType<typeof useValidateDomainRecordsMutation>;
export type ValidateDomainRecordsMutationResult = Apollo.MutationResult<ValidateDomainRecordsMutation>;
export type ValidateDomainRecordsMutationOptions = Apollo.BaseMutationOptions<ValidateDomainRecordsMutation, ValidateDomainRecordsMutationVariables>;
export const UpdateSlugDocument = gql`
    mutation UpdateSlug($slug: String!) {
  websiteUpdateSlug(slug: $slug) {
    website {
      id
      slug
    }
    error
  }
}
    `;
export type UpdateSlugMutationFn = Apollo.MutationFunction<UpdateSlugMutation, UpdateSlugMutationVariables>;

/**
 * __useUpdateSlugMutation__
 *
 * To run a mutation, you first call `useUpdateSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlugMutation, { data, loading, error }] = useUpdateSlugMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUpdateSlugMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlugMutation, UpdateSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlugMutation, UpdateSlugMutationVariables>(UpdateSlugDocument, options);
      }
export type UpdateSlugMutationHookResult = ReturnType<typeof useUpdateSlugMutation>;
export type UpdateSlugMutationResult = Apollo.MutationResult<UpdateSlugMutation>;
export type UpdateSlugMutationOptions = Apollo.BaseMutationOptions<UpdateSlugMutation, UpdateSlugMutationVariables>;
export const UpdateWebmailDocument = gql`
    mutation UpdateWebmail($input: OrganizationUpdateInput!) {
  organizationUpdate(input: $input) {
    id
    information {
      webmailLink
    }
  }
}
    `;
export type UpdateWebmailMutationFn = Apollo.MutationFunction<UpdateWebmailMutation, UpdateWebmailMutationVariables>;

/**
 * __useUpdateWebmailMutation__
 *
 * To run a mutation, you first call `useUpdateWebmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebmailMutation, { data, loading, error }] = useUpdateWebmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebmailMutation, UpdateWebmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebmailMutation, UpdateWebmailMutationVariables>(UpdateWebmailDocument, options);
      }
export type UpdateWebmailMutationHookResult = ReturnType<typeof useUpdateWebmailMutation>;
export type UpdateWebmailMutationResult = Apollo.MutationResult<UpdateWebmailMutation>;
export type UpdateWebmailMutationOptions = Apollo.BaseMutationOptions<UpdateWebmailMutation, UpdateWebmailMutationVariables>;
export const CreateSupportTicketDocument = gql`
    mutation CreateSupportTicket($body: String!) {
  supportTicketCreate(input: {body: $body})
}
    `;
export type CreateSupportTicketMutationFn = Apollo.MutationFunction<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;

/**
 * __useCreateSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketMutation, { data, loading, error }] = useCreateSupportTicketMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateSupportTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(CreateSupportTicketDocument, options);
      }
export type CreateSupportTicketMutationHookResult = ReturnType<typeof useCreateSupportTicketMutation>;
export type CreateSupportTicketMutationResult = Apollo.MutationResult<CreateSupportTicketMutation>;
export type CreateSupportTicketMutationOptions = Apollo.BaseMutationOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;
export const BookDemoDocument = gql`
    mutation BookDemo($name: String!, $email: String!) {
  demoBook(input: {name: $name, email: $email})
}
    `;
export type BookDemoMutationFn = Apollo.MutationFunction<BookDemoMutation, BookDemoMutationVariables>;

/**
 * __useBookDemoMutation__
 *
 * To run a mutation, you first call `useBookDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookDemoMutation, { data, loading, error }] = useBookDemoMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useBookDemoMutation(baseOptions?: Apollo.MutationHookOptions<BookDemoMutation, BookDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookDemoMutation, BookDemoMutationVariables>(BookDemoDocument, options);
      }
export type BookDemoMutationHookResult = ReturnType<typeof useBookDemoMutation>;
export type BookDemoMutationResult = Apollo.MutationResult<BookDemoMutation>;
export type BookDemoMutationOptions = Apollo.BaseMutationOptions<BookDemoMutation, BookDemoMutationVariables>;
export const AssociationDocument = gql`
    query Association($slug: ID!) {
  association(slug: $slug) {
    slug
    orgName
    orgNumber
    orgAddress
    numberOfApartments
    registrationYear
    postal
    city
  }
}
    `;

/**
 * __useAssociationQuery__
 *
 * To run a query within a React component, call `useAssociationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssociationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssociationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAssociationQuery(baseOptions: Apollo.QueryHookOptions<AssociationQuery, AssociationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssociationQuery, AssociationQueryVariables>(AssociationDocument, options);
      }
export function useAssociationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssociationQuery, AssociationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssociationQuery, AssociationQueryVariables>(AssociationDocument, options);
        }
export function useAssociationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssociationQuery, AssociationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssociationQuery, AssociationQueryVariables>(AssociationDocument, options);
        }
export type AssociationQueryHookResult = ReturnType<typeof useAssociationQuery>;
export type AssociationLazyQueryHookResult = ReturnType<typeof useAssociationLazyQuery>;
export type AssociationSuspenseQueryHookResult = ReturnType<typeof useAssociationSuspenseQuery>;
export type AssociationQueryResult = Apollo.QueryResult<AssociationQuery, AssociationQueryVariables>;
export const AssociationSitemapDocument = gql`
    query AssociationSitemap {
  associations {
    slug
  }
}
    `;

/**
 * __useAssociationSitemapQuery__
 *
 * To run a query within a React component, call `useAssociationSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssociationSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssociationSitemapQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssociationSitemapQuery(baseOptions?: Apollo.QueryHookOptions<AssociationSitemapQuery, AssociationSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssociationSitemapQuery, AssociationSitemapQueryVariables>(AssociationSitemapDocument, options);
      }
export function useAssociationSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssociationSitemapQuery, AssociationSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssociationSitemapQuery, AssociationSitemapQueryVariables>(AssociationSitemapDocument, options);
        }
export function useAssociationSitemapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssociationSitemapQuery, AssociationSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssociationSitemapQuery, AssociationSitemapQueryVariables>(AssociationSitemapDocument, options);
        }
export type AssociationSitemapQueryHookResult = ReturnType<typeof useAssociationSitemapQuery>;
export type AssociationSitemapLazyQueryHookResult = ReturnType<typeof useAssociationSitemapLazyQuery>;
export type AssociationSitemapSuspenseQueryHookResult = ReturnType<typeof useAssociationSitemapSuspenseQuery>;
export type AssociationSitemapQueryResult = Apollo.QueryResult<AssociationSitemapQuery, AssociationSitemapQueryVariables>;
export const SendOnboardCodeDocument = gql`
    mutation SendOnboardCode($phoneNumber: String!, $email: String!) {
  onboardCodeSend(input: {phoneNumber: $phoneNumber, email: $email}) {
    retryInSeconds
    error
  }
}
    `;
export type SendOnboardCodeMutationFn = Apollo.MutationFunction<SendOnboardCodeMutation, SendOnboardCodeMutationVariables>;

/**
 * __useSendOnboardCodeMutation__
 *
 * To run a mutation, you first call `useSendOnboardCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOnboardCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOnboardCodeMutation, { data, loading, error }] = useSendOnboardCodeMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendOnboardCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendOnboardCodeMutation, SendOnboardCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOnboardCodeMutation, SendOnboardCodeMutationVariables>(SendOnboardCodeDocument, options);
      }
export type SendOnboardCodeMutationHookResult = ReturnType<typeof useSendOnboardCodeMutation>;
export type SendOnboardCodeMutationResult = Apollo.MutationResult<SendOnboardCodeMutation>;
export type SendOnboardCodeMutationOptions = Apollo.BaseMutationOptions<SendOnboardCodeMutation, SendOnboardCodeMutationVariables>;
export const VerifyOnboardCodeDocument = gql`
    mutation VerifyOnboardCode($orgName: String!, $phoneNumber: String!, $email: String!, $code: String!) {
  onboardCodeVerify(
    input: {orgName: $orgName, phoneNumber: $phoneNumber, email: $email, code: $code}
  ) {
    accessToken
    error
  }
}
    `;
export type VerifyOnboardCodeMutationFn = Apollo.MutationFunction<VerifyOnboardCodeMutation, VerifyOnboardCodeMutationVariables>;

/**
 * __useVerifyOnboardCodeMutation__
 *
 * To run a mutation, you first call `useVerifyOnboardCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOnboardCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOnboardCodeMutation, { data, loading, error }] = useVerifyOnboardCodeMutation({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyOnboardCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOnboardCodeMutation, VerifyOnboardCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOnboardCodeMutation, VerifyOnboardCodeMutationVariables>(VerifyOnboardCodeDocument, options);
      }
export type VerifyOnboardCodeMutationHookResult = ReturnType<typeof useVerifyOnboardCodeMutation>;
export type VerifyOnboardCodeMutationResult = Apollo.MutationResult<VerifyOnboardCodeMutation>;
export type VerifyOnboardCodeMutationOptions = Apollo.BaseMutationOptions<VerifyOnboardCodeMutation, VerifyOnboardCodeMutationVariables>;
export const PushPartialOnboardingDocument = gql`
    mutation PushPartialOnboarding($input: OnboardPushPartialInput!) {
  onboardPushPartial(input: $input)
}
    `;
export type PushPartialOnboardingMutationFn = Apollo.MutationFunction<PushPartialOnboardingMutation, PushPartialOnboardingMutationVariables>;

/**
 * __usePushPartialOnboardingMutation__
 *
 * To run a mutation, you first call `usePushPartialOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushPartialOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushPartialOnboardingMutation, { data, loading, error }] = usePushPartialOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushPartialOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<PushPartialOnboardingMutation, PushPartialOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushPartialOnboardingMutation, PushPartialOnboardingMutationVariables>(PushPartialOnboardingDocument, options);
      }
export type PushPartialOnboardingMutationHookResult = ReturnType<typeof usePushPartialOnboardingMutation>;
export type PushPartialOnboardingMutationResult = Apollo.MutationResult<PushPartialOnboardingMutation>;
export type PushPartialOnboardingMutationOptions = Apollo.BaseMutationOptions<PushPartialOnboardingMutation, PushPartialOnboardingMutationVariables>;
export const MemberPortalBookingCategoriesDocument = gql`
    query MemberPortalBookingCategories {
  me {
    organization {
      customBookingText
      customBookingLink
      bookingCategories {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMemberPortalBookingCategoriesQuery__
 *
 * To run a query within a React component, call `useMemberPortalBookingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalBookingCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPortalBookingCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberPortalBookingCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>(MemberPortalBookingCategoriesDocument, options);
      }
export function useMemberPortalBookingCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>(MemberPortalBookingCategoriesDocument, options);
        }
export function useMemberPortalBookingCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>(MemberPortalBookingCategoriesDocument, options);
        }
export type MemberPortalBookingCategoriesQueryHookResult = ReturnType<typeof useMemberPortalBookingCategoriesQuery>;
export type MemberPortalBookingCategoriesLazyQueryHookResult = ReturnType<typeof useMemberPortalBookingCategoriesLazyQuery>;
export type MemberPortalBookingCategoriesSuspenseQueryHookResult = ReturnType<typeof useMemberPortalBookingCategoriesSuspenseQuery>;
export type MemberPortalBookingCategoriesQueryResult = Apollo.QueryResult<MemberPortalBookingCategoriesQuery, MemberPortalBookingCategoriesQueryVariables>;
export const MemberPortalBookingEntriesDocument = gql`
    query MemberPortalBookingEntries {
  me {
    bookingEntries {
      id
      start
      end
      category {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMemberPortalBookingEntriesQuery__
 *
 * To run a query within a React component, call `useMemberPortalBookingEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalBookingEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPortalBookingEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberPortalBookingEntriesQuery(baseOptions?: Apollo.QueryHookOptions<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>(MemberPortalBookingEntriesDocument, options);
      }
export function useMemberPortalBookingEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>(MemberPortalBookingEntriesDocument, options);
        }
export function useMemberPortalBookingEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>(MemberPortalBookingEntriesDocument, options);
        }
export type MemberPortalBookingEntriesQueryHookResult = ReturnType<typeof useMemberPortalBookingEntriesQuery>;
export type MemberPortalBookingEntriesLazyQueryHookResult = ReturnType<typeof useMemberPortalBookingEntriesLazyQuery>;
export type MemberPortalBookingEntriesSuspenseQueryHookResult = ReturnType<typeof useMemberPortalBookingEntriesSuspenseQuery>;
export type MemberPortalBookingEntriesQueryResult = Apollo.QueryResult<MemberPortalBookingEntriesQuery, MemberPortalBookingEntriesQueryVariables>;
export const MemberPortalCreateBookingEntriesDocument = gql`
    mutation MemberPortalCreateBookingEntries($categoryId: ID!, $times: [BookingEntryCreateInput!]!) {
  bookingEntriesCreate(categoryId: $categoryId, times: $times) {
    bookingEntries {
      id
      start
      end
    }
    numberOfErrors
    error
  }
}
    `;
export type MemberPortalCreateBookingEntriesMutationFn = Apollo.MutationFunction<MemberPortalCreateBookingEntriesMutation, MemberPortalCreateBookingEntriesMutationVariables>;

/**
 * __useMemberPortalCreateBookingEntriesMutation__
 *
 * To run a mutation, you first call `useMemberPortalCreateBookingEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalCreateBookingEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberPortalCreateBookingEntriesMutation, { data, loading, error }] = useMemberPortalCreateBookingEntriesMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      times: // value for 'times'
 *   },
 * });
 */
export function useMemberPortalCreateBookingEntriesMutation(baseOptions?: Apollo.MutationHookOptions<MemberPortalCreateBookingEntriesMutation, MemberPortalCreateBookingEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MemberPortalCreateBookingEntriesMutation, MemberPortalCreateBookingEntriesMutationVariables>(MemberPortalCreateBookingEntriesDocument, options);
      }
export type MemberPortalCreateBookingEntriesMutationHookResult = ReturnType<typeof useMemberPortalCreateBookingEntriesMutation>;
export type MemberPortalCreateBookingEntriesMutationResult = Apollo.MutationResult<MemberPortalCreateBookingEntriesMutation>;
export type MemberPortalCreateBookingEntriesMutationOptions = Apollo.BaseMutationOptions<MemberPortalCreateBookingEntriesMutation, MemberPortalCreateBookingEntriesMutationVariables>;
export const MemberPortalDeleteBookingEntryDocument = gql`
    mutation MemberPortalDeleteBookingEntry($id: ID!) {
  bookingEntryDelete(id: $id)
}
    `;
export type MemberPortalDeleteBookingEntryMutationFn = Apollo.MutationFunction<MemberPortalDeleteBookingEntryMutation, MemberPortalDeleteBookingEntryMutationVariables>;

/**
 * __useMemberPortalDeleteBookingEntryMutation__
 *
 * To run a mutation, you first call `useMemberPortalDeleteBookingEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalDeleteBookingEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberPortalDeleteBookingEntryMutation, { data, loading, error }] = useMemberPortalDeleteBookingEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMemberPortalDeleteBookingEntryMutation(baseOptions?: Apollo.MutationHookOptions<MemberPortalDeleteBookingEntryMutation, MemberPortalDeleteBookingEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MemberPortalDeleteBookingEntryMutation, MemberPortalDeleteBookingEntryMutationVariables>(MemberPortalDeleteBookingEntryDocument, options);
      }
export type MemberPortalDeleteBookingEntryMutationHookResult = ReturnType<typeof useMemberPortalDeleteBookingEntryMutation>;
export type MemberPortalDeleteBookingEntryMutationResult = Apollo.MutationResult<MemberPortalDeleteBookingEntryMutation>;
export type MemberPortalDeleteBookingEntryMutationOptions = Apollo.BaseMutationOptions<MemberPortalDeleteBookingEntryMutation, MemberPortalDeleteBookingEntryMutationVariables>;
export const MemberPortalBookingCategorySlotsDocument = gql`
    query MemberPortalBookingCategorySlots($id: ID!, $from: Time!, $to: Time!) {
  bookingCategory(id: $id) {
    id
    name
    slots(from: $from, to: $to) {
      templateId
      start
      end
      state
      bookedByName
    }
  }
}
    `;

/**
 * __useMemberPortalBookingCategorySlotsQuery__
 *
 * To run a query within a React component, call `useMemberPortalBookingCategorySlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalBookingCategorySlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPortalBookingCategorySlotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMemberPortalBookingCategorySlotsQuery(baseOptions: Apollo.QueryHookOptions<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>(MemberPortalBookingCategorySlotsDocument, options);
      }
export function useMemberPortalBookingCategorySlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>(MemberPortalBookingCategorySlotsDocument, options);
        }
export function useMemberPortalBookingCategorySlotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>(MemberPortalBookingCategorySlotsDocument, options);
        }
export type MemberPortalBookingCategorySlotsQueryHookResult = ReturnType<typeof useMemberPortalBookingCategorySlotsQuery>;
export type MemberPortalBookingCategorySlotsLazyQueryHookResult = ReturnType<typeof useMemberPortalBookingCategorySlotsLazyQuery>;
export type MemberPortalBookingCategorySlotsSuspenseQueryHookResult = ReturnType<typeof useMemberPortalBookingCategorySlotsSuspenseQuery>;
export type MemberPortalBookingCategorySlotsQueryResult = Apollo.QueryResult<MemberPortalBookingCategorySlotsQuery, MemberPortalBookingCategorySlotsQueryVariables>;
export const MemberPortalInfoPageDocument = gql`
    query MemberPortalInfoPage($id: ID!) {
  infoPage(id: $id) {
    id
    title
    slug
    blocks {
      ...BlockFragment
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useMemberPortalInfoPageQuery__
 *
 * To run a query within a React component, call `useMemberPortalInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPortalInfoPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMemberPortalInfoPageQuery(baseOptions: Apollo.QueryHookOptions<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>(MemberPortalInfoPageDocument, options);
      }
export function useMemberPortalInfoPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>(MemberPortalInfoPageDocument, options);
        }
export function useMemberPortalInfoPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>(MemberPortalInfoPageDocument, options);
        }
export type MemberPortalInfoPageQueryHookResult = ReturnType<typeof useMemberPortalInfoPageQuery>;
export type MemberPortalInfoPageLazyQueryHookResult = ReturnType<typeof useMemberPortalInfoPageLazyQuery>;
export type MemberPortalInfoPageSuspenseQueryHookResult = ReturnType<typeof useMemberPortalInfoPageSuspenseQuery>;
export type MemberPortalInfoPageQueryResult = Apollo.QueryResult<MemberPortalInfoPageQuery, MemberPortalInfoPageQueryVariables>;
export const PortalMeDocument = gql`
    query PortalMe {
  me {
    user {
      id
      firstName
      lastName
      email
      phoneNumber
      role
      apartmentNumber
    }
  }
}
    `;

/**
 * __usePortalMeQuery__
 *
 * To run a query within a React component, call `usePortalMeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalMeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalMeQuery(baseOptions?: Apollo.QueryHookOptions<PortalMeQuery, PortalMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalMeQuery, PortalMeQueryVariables>(PortalMeDocument, options);
      }
export function usePortalMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalMeQuery, PortalMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalMeQuery, PortalMeQueryVariables>(PortalMeDocument, options);
        }
export function usePortalMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalMeQuery, PortalMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalMeQuery, PortalMeQueryVariables>(PortalMeDocument, options);
        }
export type PortalMeQueryHookResult = ReturnType<typeof usePortalMeQuery>;
export type PortalMeLazyQueryHookResult = ReturnType<typeof usePortalMeLazyQuery>;
export type PortalMeSuspenseQueryHookResult = ReturnType<typeof usePortalMeSuspenseQuery>;
export type PortalMeQueryResult = Apollo.QueryResult<PortalMeQuery, PortalMeQueryVariables>;
export const PortalInfoPagesDocument = gql`
    query PortalInfoPages {
  me {
    website {
      id
      infoPages {
        id
        createdAt
        updatedAt
        title
        slug
        sortOrder
      }
      memberInfoPages {
        id
        createdAt
        updatedAt
        title
        slug
        sortOrder
      }
    }
  }
}
    `;

/**
 * __usePortalInfoPagesQuery__
 *
 * To run a query within a React component, call `usePortalInfoPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalInfoPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalInfoPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalInfoPagesQuery(baseOptions?: Apollo.QueryHookOptions<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>(PortalInfoPagesDocument, options);
      }
export function usePortalInfoPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>(PortalInfoPagesDocument, options);
        }
export function usePortalInfoPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>(PortalInfoPagesDocument, options);
        }
export type PortalInfoPagesQueryHookResult = ReturnType<typeof usePortalInfoPagesQuery>;
export type PortalInfoPagesLazyQueryHookResult = ReturnType<typeof usePortalInfoPagesLazyQuery>;
export type PortalInfoPagesSuspenseQueryHookResult = ReturnType<typeof usePortalInfoPagesSuspenseQuery>;
export type PortalInfoPagesQueryResult = Apollo.QueryResult<PortalInfoPagesQuery, PortalInfoPagesQueryVariables>;
export const MemberPortalUserDocument = gql`
    query MemberPortalUser($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    user {
      id
      firstName
      lastName
      email
      phoneNumber
      role
      apartmentNumber
    }
  }
}
    `;

/**
 * __useMemberPortalUserQuery__
 *
 * To run a query within a React component, call `useMemberPortalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPortalUserQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useMemberPortalUserQuery(baseOptions: Apollo.QueryHookOptions<MemberPortalUserQuery, MemberPortalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPortalUserQuery, MemberPortalUserQueryVariables>(MemberPortalUserDocument, options);
      }
export function useMemberPortalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPortalUserQuery, MemberPortalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPortalUserQuery, MemberPortalUserQueryVariables>(MemberPortalUserDocument, options);
        }
export function useMemberPortalUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPortalUserQuery, MemberPortalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPortalUserQuery, MemberPortalUserQueryVariables>(MemberPortalUserDocument, options);
        }
export type MemberPortalUserQueryHookResult = ReturnType<typeof useMemberPortalUserQuery>;
export type MemberPortalUserLazyQueryHookResult = ReturnType<typeof useMemberPortalUserLazyQuery>;
export type MemberPortalUserSuspenseQueryHookResult = ReturnType<typeof useMemberPortalUserSuspenseQuery>;
export type MemberPortalUserQueryResult = Apollo.QueryResult<MemberPortalUserQuery, MemberPortalUserQueryVariables>;
export const PortalUserUpdateSelfDocument = gql`
    mutation PortalUserUpdateSelf($input: UserUpdateSelfInput!) {
  userUpdateSelf(input: $input) {
    id
    firstName
    lastName
    phoneNumber
    email
    apartmentNumber
  }
}
    `;
export type PortalUserUpdateSelfMutationFn = Apollo.MutationFunction<PortalUserUpdateSelfMutation, PortalUserUpdateSelfMutationVariables>;

/**
 * __usePortalUserUpdateSelfMutation__
 *
 * To run a mutation, you first call `usePortalUserUpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalUserUpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalUserUpdateSelfMutation, { data, loading, error }] = usePortalUserUpdateSelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalUserUpdateSelfMutation(baseOptions?: Apollo.MutationHookOptions<PortalUserUpdateSelfMutation, PortalUserUpdateSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalUserUpdateSelfMutation, PortalUserUpdateSelfMutationVariables>(PortalUserUpdateSelfDocument, options);
      }
export type PortalUserUpdateSelfMutationHookResult = ReturnType<typeof usePortalUserUpdateSelfMutation>;
export type PortalUserUpdateSelfMutationResult = Apollo.MutationResult<PortalUserUpdateSelfMutation>;
export type PortalUserUpdateSelfMutationOptions = Apollo.BaseMutationOptions<PortalUserUpdateSelfMutation, PortalUserUpdateSelfMutationVariables>;
export const StaticWebsiteInfoPageDocument = gql`
    query StaticWebsiteInfoPage($websiteSlug: String!, $slug: String!) {
  staticInfoPageBySlug(websiteSlug: $websiteSlug, slug: $slug) {
    id
    title
    body
    group
    restricted
    blocks {
      ...BlockFragment
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useStaticWebsiteInfoPageQuery__
 *
 * To run a query within a React component, call `useStaticWebsiteInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticWebsiteInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticWebsiteInfoPageQuery({
 *   variables: {
 *      websiteSlug: // value for 'websiteSlug'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticWebsiteInfoPageQuery(baseOptions: Apollo.QueryHookOptions<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>(StaticWebsiteInfoPageDocument, options);
      }
export function useStaticWebsiteInfoPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>(StaticWebsiteInfoPageDocument, options);
        }
export function useStaticWebsiteInfoPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>(StaticWebsiteInfoPageDocument, options);
        }
export type StaticWebsiteInfoPageQueryHookResult = ReturnType<typeof useStaticWebsiteInfoPageQuery>;
export type StaticWebsiteInfoPageLazyQueryHookResult = ReturnType<typeof useStaticWebsiteInfoPageLazyQuery>;
export type StaticWebsiteInfoPageSuspenseQueryHookResult = ReturnType<typeof useStaticWebsiteInfoPageSuspenseQuery>;
export type StaticWebsiteInfoPageQueryResult = Apollo.QueryResult<StaticWebsiteInfoPageQuery, StaticWebsiteInfoPageQueryVariables>;
export const StaticWebsiteStartPageDocument = gql`
    query StaticWebsiteStartPage($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    name
    orgNumber
    indexable
    address {
      street
      postalCode
      city
    }
    startPage {
      title
      body
      blocks {
        ...BlockFragment
      }
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useStaticWebsiteStartPageQuery__
 *
 * To run a query within a React component, call `useStaticWebsiteStartPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticWebsiteStartPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticWebsiteStartPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticWebsiteStartPageQuery(baseOptions: Apollo.QueryHookOptions<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>(StaticWebsiteStartPageDocument, options);
      }
export function useStaticWebsiteStartPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>(StaticWebsiteStartPageDocument, options);
        }
export function useStaticWebsiteStartPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>(StaticWebsiteStartPageDocument, options);
        }
export type StaticWebsiteStartPageQueryHookResult = ReturnType<typeof useStaticWebsiteStartPageQuery>;
export type StaticWebsiteStartPageLazyQueryHookResult = ReturnType<typeof useStaticWebsiteStartPageLazyQuery>;
export type StaticWebsiteStartPageSuspenseQueryHookResult = ReturnType<typeof useStaticWebsiteStartPageSuspenseQuery>;
export type StaticWebsiteStartPageQueryResult = Apollo.QueryResult<StaticWebsiteStartPageQuery, StaticWebsiteStartPageQueryVariables>;
export const CreateErrandDocument = gql`
    mutation CreateErrand($input: ErrandCreateInput!) {
  errandCreate(input: $input) {
    error
  }
}
    `;
export type CreateErrandMutationFn = Apollo.MutationFunction<CreateErrandMutation, CreateErrandMutationVariables>;

/**
 * __useCreateErrandMutation__
 *
 * To run a mutation, you first call `useCreateErrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandMutation, { data, loading, error }] = useCreateErrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateErrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandMutation, CreateErrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandMutation, CreateErrandMutationVariables>(CreateErrandDocument, options);
      }
export type CreateErrandMutationHookResult = ReturnType<typeof useCreateErrandMutation>;
export type CreateErrandMutationResult = Apollo.MutationResult<CreateErrandMutation>;
export type CreateErrandMutationOptions = Apollo.BaseMutationOptions<CreateErrandMutation, CreateErrandMutationVariables>;
export const ErrandFeatureDocument = gql`
    query ErrandFeature($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    errandTypes {
      id
      displayName
    }
    features {
      errands
    }
    errandInfo
  }
}
    `;

/**
 * __useErrandFeatureQuery__
 *
 * To run a query within a React component, call `useErrandFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandFeatureQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useErrandFeatureQuery(baseOptions: Apollo.QueryHookOptions<ErrandFeatureQuery, ErrandFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandFeatureQuery, ErrandFeatureQueryVariables>(ErrandFeatureDocument, options);
      }
export function useErrandFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandFeatureQuery, ErrandFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandFeatureQuery, ErrandFeatureQueryVariables>(ErrandFeatureDocument, options);
        }
export function useErrandFeatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandFeatureQuery, ErrandFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandFeatureQuery, ErrandFeatureQueryVariables>(ErrandFeatureDocument, options);
        }
export type ErrandFeatureQueryHookResult = ReturnType<typeof useErrandFeatureQuery>;
export type ErrandFeatureLazyQueryHookResult = ReturnType<typeof useErrandFeatureLazyQuery>;
export type ErrandFeatureSuspenseQueryHookResult = ReturnType<typeof useErrandFeatureSuspenseQuery>;
export type ErrandFeatureQueryResult = Apollo.QueryResult<ErrandFeatureQuery, ErrandFeatureQueryVariables>;
export const BookingCategoryInfoDocument = gql`
    query BookingCategoryInfo($id: ID!) {
  bookingCategory(id: $id) {
    id
    name
    info
  }
}
    `;

/**
 * __useBookingCategoryInfoQuery__
 *
 * To run a query within a React component, call `useBookingCategoryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCategoryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCategoryInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingCategoryInfoQuery(baseOptions: Apollo.QueryHookOptions<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>(BookingCategoryInfoDocument, options);
      }
export function useBookingCategoryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>(BookingCategoryInfoDocument, options);
        }
export function useBookingCategoryInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>(BookingCategoryInfoDocument, options);
        }
export type BookingCategoryInfoQueryHookResult = ReturnType<typeof useBookingCategoryInfoQuery>;
export type BookingCategoryInfoLazyQueryHookResult = ReturnType<typeof useBookingCategoryInfoLazyQuery>;
export type BookingCategoryInfoSuspenseQueryHookResult = ReturnType<typeof useBookingCategoryInfoSuspenseQuery>;
export type BookingCategoryInfoQueryResult = Apollo.QueryResult<BookingCategoryInfoQuery, BookingCategoryInfoQueryVariables>;
export const MemberPortalHomeDocument = gql`
    query MemberPortalHome {
  me {
    user {
      id
      firstName
      lastName
    }
    organization {
      id
      name
      features {
        bookings
      }
      bookingCategories {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMemberPortalHomeQuery__
 *
 * To run a query within a React component, call `useMemberPortalHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPortalHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPortalHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberPortalHomeQuery(baseOptions?: Apollo.QueryHookOptions<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>(MemberPortalHomeDocument, options);
      }
export function useMemberPortalHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>(MemberPortalHomeDocument, options);
        }
export function useMemberPortalHomeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>(MemberPortalHomeDocument, options);
        }
export type MemberPortalHomeQueryHookResult = ReturnType<typeof useMemberPortalHomeQuery>;
export type MemberPortalHomeLazyQueryHookResult = ReturnType<typeof useMemberPortalHomeLazyQuery>;
export type MemberPortalHomeSuspenseQueryHookResult = ReturnType<typeof useMemberPortalHomeSuspenseQuery>;
export type MemberPortalHomeQueryResult = Apollo.QueryResult<MemberPortalHomeQuery, MemberPortalHomeQueryVariables>;
export const StaticWebsiteLayoutDocument = gql`
    query StaticWebsiteLayout($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    name
    infoPages {
      id
      title
      slug
      group
    }
    memberInfoPages {
      id
      title
      slug
      group
    }
    features {
      errands
    }
    orgNumber
    address {
      street
      postalCode
      city
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useStaticWebsiteLayoutQuery__
 *
 * To run a query within a React component, call `useStaticWebsiteLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticWebsiteLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticWebsiteLayoutQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticWebsiteLayoutQuery(baseOptions: Apollo.QueryHookOptions<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>(StaticWebsiteLayoutDocument, options);
      }
export function useStaticWebsiteLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>(StaticWebsiteLayoutDocument, options);
        }
export function useStaticWebsiteLayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>(StaticWebsiteLayoutDocument, options);
        }
export type StaticWebsiteLayoutQueryHookResult = ReturnType<typeof useStaticWebsiteLayoutQuery>;
export type StaticWebsiteLayoutLazyQueryHookResult = ReturnType<typeof useStaticWebsiteLayoutLazyQuery>;
export type StaticWebsiteLayoutSuspenseQueryHookResult = ReturnType<typeof useStaticWebsiteLayoutSuspenseQuery>;
export type StaticWebsiteLayoutQueryResult = Apollo.QueryResult<StaticWebsiteLayoutQuery, StaticWebsiteLayoutQueryVariables>;
export const MeetingProposalPageDocument = gql`
    query MeetingProposalPage($participantId: ID!) {
  meetingProposalByParticipant(participantId: $participantId) {
    id
    title
    description
    completed
    finalMessage
    pickedTimeslot {
      id
      start
      end
    }
    participants {
      id
      name
      email
      noVote
      hasVoted
    }
    timeslots {
      id
      start
      end
      votes {
        id
        participant {
          id
          email
          name
          noVote
          hasVoted
        }
      }
    }
  }
}
    `;

/**
 * __useMeetingProposalPageQuery__
 *
 * To run a query within a React component, call `useMeetingProposalPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingProposalPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingProposalPageQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useMeetingProposalPageQuery(baseOptions: Apollo.QueryHookOptions<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>(MeetingProposalPageDocument, options);
      }
export function useMeetingProposalPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>(MeetingProposalPageDocument, options);
        }
export function useMeetingProposalPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>(MeetingProposalPageDocument, options);
        }
export type MeetingProposalPageQueryHookResult = ReturnType<typeof useMeetingProposalPageQuery>;
export type MeetingProposalPageLazyQueryHookResult = ReturnType<typeof useMeetingProposalPageLazyQuery>;
export type MeetingProposalPageSuspenseQueryHookResult = ReturnType<typeof useMeetingProposalPageSuspenseQuery>;
export type MeetingProposalPageQueryResult = Apollo.QueryResult<MeetingProposalPageQuery, MeetingProposalPageQueryVariables>;
export const VoteOnTimeslotDocument = gql`
    mutation VoteOnTimeslot($participantId: ID!, $timeslotId: ID!) {
  meetingProposalVote(participantId: $participantId, timeslotId: $timeslotId) {
    meetingProposal {
      id
      timeslots {
        id
        votes {
          id
          participant {
            id
            name
            email
            noVote
            hasVoted
          }
        }
      }
    }
  }
}
    `;
export type VoteOnTimeslotMutationFn = Apollo.MutationFunction<VoteOnTimeslotMutation, VoteOnTimeslotMutationVariables>;

/**
 * __useVoteOnTimeslotMutation__
 *
 * To run a mutation, you first call `useVoteOnTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteOnTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteOnTimeslotMutation, { data, loading, error }] = useVoteOnTimeslotMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      timeslotId: // value for 'timeslotId'
 *   },
 * });
 */
export function useVoteOnTimeslotMutation(baseOptions?: Apollo.MutationHookOptions<VoteOnTimeslotMutation, VoteOnTimeslotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteOnTimeslotMutation, VoteOnTimeslotMutationVariables>(VoteOnTimeslotDocument, options);
      }
export type VoteOnTimeslotMutationHookResult = ReturnType<typeof useVoteOnTimeslotMutation>;
export type VoteOnTimeslotMutationResult = Apollo.MutationResult<VoteOnTimeslotMutation>;
export type VoteOnTimeslotMutationOptions = Apollo.BaseMutationOptions<VoteOnTimeslotMutation, VoteOnTimeslotMutationVariables>;
export const UnVoteOnTimeslotDocument = gql`
    mutation UnVoteOnTimeslot($voteId: ID!) {
  meetingProposalUnVote(voteId: $voteId) {
    id
    participants {
      id
      name
      email
      noVote
      hasVoted
    }
    timeslots {
      id
      votes {
        id
        participant {
          id
          name
          email
          noVote
          hasVoted
        }
      }
    }
  }
}
    `;
export type UnVoteOnTimeslotMutationFn = Apollo.MutationFunction<UnVoteOnTimeslotMutation, UnVoteOnTimeslotMutationVariables>;

/**
 * __useUnVoteOnTimeslotMutation__
 *
 * To run a mutation, you first call `useUnVoteOnTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnVoteOnTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unVoteOnTimeslotMutation, { data, loading, error }] = useUnVoteOnTimeslotMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *   },
 * });
 */
export function useUnVoteOnTimeslotMutation(baseOptions?: Apollo.MutationHookOptions<UnVoteOnTimeslotMutation, UnVoteOnTimeslotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnVoteOnTimeslotMutation, UnVoteOnTimeslotMutationVariables>(UnVoteOnTimeslotDocument, options);
      }
export type UnVoteOnTimeslotMutationHookResult = ReturnType<typeof useUnVoteOnTimeslotMutation>;
export type UnVoteOnTimeslotMutationResult = Apollo.MutationResult<UnVoteOnTimeslotMutation>;
export type UnVoteOnTimeslotMutationOptions = Apollo.BaseMutationOptions<UnVoteOnTimeslotMutation, UnVoteOnTimeslotMutationVariables>;
export const ParticipantNoVoteDocument = gql`
    mutation ParticipantNoVote($participantId: ID!) {
  meetingProposalNoVote(participantId: $participantId) {
    id
    participants {
      id
      email
      name
      noVote
      hasVoted
    }
    timeslots {
      id
      votes {
        id
        participant {
          id
          name
          email
          noVote
          hasVoted
        }
      }
    }
  }
}
    `;
export type ParticipantNoVoteMutationFn = Apollo.MutationFunction<ParticipantNoVoteMutation, ParticipantNoVoteMutationVariables>;

/**
 * __useParticipantNoVoteMutation__
 *
 * To run a mutation, you first call `useParticipantNoVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipantNoVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participantNoVoteMutation, { data, loading, error }] = useParticipantNoVoteMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useParticipantNoVoteMutation(baseOptions?: Apollo.MutationHookOptions<ParticipantNoVoteMutation, ParticipantNoVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipantNoVoteMutation, ParticipantNoVoteMutationVariables>(ParticipantNoVoteDocument, options);
      }
export type ParticipantNoVoteMutationHookResult = ReturnType<typeof useParticipantNoVoteMutation>;
export type ParticipantNoVoteMutationResult = Apollo.MutationResult<ParticipantNoVoteMutation>;
export type ParticipantNoVoteMutationOptions = Apollo.BaseMutationOptions<ParticipantNoVoteMutation, ParticipantNoVoteMutationVariables>;
export const ParticipantUnNoVoteDocument = gql`
    mutation ParticipantUnNoVote($participantId: ID!) {
  meetingProposalUnNoVote(participantId: $participantId) {
    id
    participants {
      id
      email
      name
      noVote
      hasVoted
    }
    timeslots {
      id
      votes {
        id
        participant {
          id
          name
          email
          noVote
          hasVoted
        }
      }
    }
  }
}
    `;
export type ParticipantUnNoVoteMutationFn = Apollo.MutationFunction<ParticipantUnNoVoteMutation, ParticipantUnNoVoteMutationVariables>;

/**
 * __useParticipantUnNoVoteMutation__
 *
 * To run a mutation, you first call `useParticipantUnNoVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipantUnNoVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participantUnNoVoteMutation, { data, loading, error }] = useParticipantUnNoVoteMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useParticipantUnNoVoteMutation(baseOptions?: Apollo.MutationHookOptions<ParticipantUnNoVoteMutation, ParticipantUnNoVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipantUnNoVoteMutation, ParticipantUnNoVoteMutationVariables>(ParticipantUnNoVoteDocument, options);
      }
export type ParticipantUnNoVoteMutationHookResult = ReturnType<typeof useParticipantUnNoVoteMutation>;
export type ParticipantUnNoVoteMutationResult = Apollo.MutationResult<ParticipantUnNoVoteMutation>;
export type ParticipantUnNoVoteMutationOptions = Apollo.BaseMutationOptions<ParticipantUnNoVoteMutation, ParticipantUnNoVoteMutationVariables>;
export const ParticipantMarkOpenedDocument = gql`
    mutation ParticipantMarkOpened($participantId: ID!) {
  meetingProposalMarkOpened(participantId: $participantId) {
    id
    participants {
      id
      hasOpened
    }
  }
}
    `;
export type ParticipantMarkOpenedMutationFn = Apollo.MutationFunction<ParticipantMarkOpenedMutation, ParticipantMarkOpenedMutationVariables>;

/**
 * __useParticipantMarkOpenedMutation__
 *
 * To run a mutation, you first call `useParticipantMarkOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipantMarkOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participantMarkOpenedMutation, { data, loading, error }] = useParticipantMarkOpenedMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useParticipantMarkOpenedMutation(baseOptions?: Apollo.MutationHookOptions<ParticipantMarkOpenedMutation, ParticipantMarkOpenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipantMarkOpenedMutation, ParticipantMarkOpenedMutationVariables>(ParticipantMarkOpenedDocument, options);
      }
export type ParticipantMarkOpenedMutationHookResult = ReturnType<typeof useParticipantMarkOpenedMutation>;
export type ParticipantMarkOpenedMutationResult = Apollo.MutationResult<ParticipantMarkOpenedMutation>;
export type ParticipantMarkOpenedMutationOptions = Apollo.BaseMutationOptions<ParticipantMarkOpenedMutation, ParticipantMarkOpenedMutationVariables>;
export const RegisterUserVerifyDocument = gql`
    mutation RegisterUserVerify($input: UserRegisterVerifyInput!) {
  userRegisterVerify(input: $input) {
    error
  }
}
    `;
export type RegisterUserVerifyMutationFn = Apollo.MutationFunction<RegisterUserVerifyMutation, RegisterUserVerifyMutationVariables>;

/**
 * __useRegisterUserVerifyMutation__
 *
 * To run a mutation, you first call `useRegisterUserVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserVerifyMutation, { data, loading, error }] = useRegisterUserVerifyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserVerifyMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserVerifyMutation, RegisterUserVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserVerifyMutation, RegisterUserVerifyMutationVariables>(RegisterUserVerifyDocument, options);
      }
export type RegisterUserVerifyMutationHookResult = ReturnType<typeof useRegisterUserVerifyMutation>;
export type RegisterUserVerifyMutationResult = Apollo.MutationResult<RegisterUserVerifyMutation>;
export type RegisterUserVerifyMutationOptions = Apollo.BaseMutationOptions<RegisterUserVerifyMutation, RegisterUserVerifyMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: UserRegisterInput!) {
  userRegister(input: $input) {
    retryInSeconds
    error
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const ValidateInviteLinkDocument = gql`
    query ValidateInviteLink($slug: String!, $linkId: String!) {
  inviteLinkValidate(slug: $slug, linkId: $linkId)
}
    `;

/**
 * __useValidateInviteLinkQuery__
 *
 * To run a query within a React component, call `useValidateInviteLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateInviteLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateInviteLinkQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useValidateInviteLinkQuery(baseOptions: Apollo.QueryHookOptions<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>(ValidateInviteLinkDocument, options);
      }
export function useValidateInviteLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>(ValidateInviteLinkDocument, options);
        }
export function useValidateInviteLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>(ValidateInviteLinkDocument, options);
        }
export type ValidateInviteLinkQueryHookResult = ReturnType<typeof useValidateInviteLinkQuery>;
export type ValidateInviteLinkLazyQueryHookResult = ReturnType<typeof useValidateInviteLinkLazyQuery>;
export type ValidateInviteLinkSuspenseQueryHookResult = ReturnType<typeof useValidateInviteLinkSuspenseQuery>;
export type ValidateInviteLinkQueryResult = Apollo.QueryResult<ValidateInviteLinkQuery, ValidateInviteLinkQueryVariables>;
export const SlimStaticWebsiteDocument = gql`
    query SlimStaticWebsite($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    name
    orgNumber
    address {
      street
      city
      postalCode
    }
    startPage {
      title
      body
    }
    features {
      errands
    }
  }
}
    `;

/**
 * __useSlimStaticWebsiteQuery__
 *
 * To run a query within a React component, call `useSlimStaticWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlimStaticWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlimStaticWebsiteQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSlimStaticWebsiteQuery(baseOptions: Apollo.QueryHookOptions<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>(SlimStaticWebsiteDocument, options);
      }
export function useSlimStaticWebsiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>(SlimStaticWebsiteDocument, options);
        }
export function useSlimStaticWebsiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>(SlimStaticWebsiteDocument, options);
        }
export type SlimStaticWebsiteQueryHookResult = ReturnType<typeof useSlimStaticWebsiteQuery>;
export type SlimStaticWebsiteLazyQueryHookResult = ReturnType<typeof useSlimStaticWebsiteLazyQuery>;
export type SlimStaticWebsiteSuspenseQueryHookResult = ReturnType<typeof useSlimStaticWebsiteSuspenseQuery>;
export type SlimStaticWebsiteQueryResult = Apollo.QueryResult<SlimStaticWebsiteQuery, SlimStaticWebsiteQueryVariables>;
export const StaticInfoPageBySlugDocument = gql`
    query StaticInfoPageBySlug($websiteSlug: String!, $slug: String!) {
  staticInfoPageBySlug(websiteSlug: $websiteSlug, slug: $slug) {
    id
    title
    body
    group
    blocks {
      ...BlockFragment
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useStaticInfoPageBySlugQuery__
 *
 * To run a query within a React component, call `useStaticInfoPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticInfoPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticInfoPageBySlugQuery({
 *   variables: {
 *      websiteSlug: // value for 'websiteSlug'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticInfoPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>(StaticInfoPageBySlugDocument, options);
      }
export function useStaticInfoPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>(StaticInfoPageBySlugDocument, options);
        }
export function useStaticInfoPageBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>(StaticInfoPageBySlugDocument, options);
        }
export type StaticInfoPageBySlugQueryHookResult = ReturnType<typeof useStaticInfoPageBySlugQuery>;
export type StaticInfoPageBySlugLazyQueryHookResult = ReturnType<typeof useStaticInfoPageBySlugLazyQuery>;
export type StaticInfoPageBySlugSuspenseQueryHookResult = ReturnType<typeof useStaticInfoPageBySlugSuspenseQuery>;
export type StaticInfoPageBySlugQueryResult = Apollo.QueryResult<StaticInfoPageBySlugQuery, StaticInfoPageBySlugQueryVariables>;
export const StaticPagesDocument = gql`
    query StaticPages($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    infoPages {
      id
      title
      slug
      group
    }
    memberInfoPages {
      id
      title
      slug
      group
    }
  }
}
    `;

/**
 * __useStaticPagesQuery__
 *
 * To run a query within a React component, call `useStaticPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticPagesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticPagesQuery(baseOptions: Apollo.QueryHookOptions<StaticPagesQuery, StaticPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticPagesQuery, StaticPagesQueryVariables>(StaticPagesDocument, options);
      }
export function useStaticPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticPagesQuery, StaticPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticPagesQuery, StaticPagesQueryVariables>(StaticPagesDocument, options);
        }
export function useStaticPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticPagesQuery, StaticPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticPagesQuery, StaticPagesQueryVariables>(StaticPagesDocument, options);
        }
export type StaticPagesQueryHookResult = ReturnType<typeof useStaticPagesQuery>;
export type StaticPagesLazyQueryHookResult = ReturnType<typeof useStaticPagesLazyQuery>;
export type StaticPagesSuspenseQueryHookResult = ReturnType<typeof useStaticPagesSuspenseQuery>;
export type StaticPagesQueryResult = Apollo.QueryResult<StaticPagesQuery, StaticPagesQueryVariables>;
export const StaticStartPageBySlugDocument = gql`
    query StaticStartPageBySlug($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    startPage {
      blocks {
        ...BlockFragment
      }
    }
  }
}
    ${BlockFragmentFragmentDoc}`;

/**
 * __useStaticStartPageBySlugQuery__
 *
 * To run a query within a React component, call `useStaticStartPageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticStartPageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticStartPageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticStartPageBySlugQuery(baseOptions: Apollo.QueryHookOptions<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>(StaticStartPageBySlugDocument, options);
      }
export function useStaticStartPageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>(StaticStartPageBySlugDocument, options);
        }
export function useStaticStartPageBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>(StaticStartPageBySlugDocument, options);
        }
export type StaticStartPageBySlugQueryHookResult = ReturnType<typeof useStaticStartPageBySlugQuery>;
export type StaticStartPageBySlugLazyQueryHookResult = ReturnType<typeof useStaticStartPageBySlugLazyQuery>;
export type StaticStartPageBySlugSuspenseQueryHookResult = ReturnType<typeof useStaticStartPageBySlugSuspenseQuery>;
export type StaticStartPageBySlugQueryResult = Apollo.QueryResult<StaticStartPageBySlugQuery, StaticStartPageBySlugQueryVariables>;
export const StaticUserDocument = gql`
    query StaticUser($slug: String!) {
  staticWebsite(slug: $slug) {
    id
    user {
      id
      firstName
      lastName
      email
      phoneNumber
      role
      apartmentNumber
    }
  }
}
    `;

/**
 * __useStaticUserQuery__
 *
 * To run a query within a React component, call `useStaticUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticUserQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStaticUserQuery(baseOptions: Apollo.QueryHookOptions<StaticUserQuery, StaticUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticUserQuery, StaticUserQueryVariables>(StaticUserDocument, options);
      }
export function useStaticUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticUserQuery, StaticUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticUserQuery, StaticUserQueryVariables>(StaticUserDocument, options);
        }
export function useStaticUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticUserQuery, StaticUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticUserQuery, StaticUserQueryVariables>(StaticUserDocument, options);
        }
export type StaticUserQueryHookResult = ReturnType<typeof useStaticUserQuery>;
export type StaticUserLazyQueryHookResult = ReturnType<typeof useStaticUserLazyQuery>;
export type StaticUserSuspenseQueryHookResult = ReturnType<typeof useStaticUserSuspenseQuery>;
export type StaticUserQueryResult = Apollo.QueryResult<StaticUserQuery, StaticUserQueryVariables>;
export const UserUpdateSelfDocument = gql`
    mutation UserUpdateSelf($input: UserUpdateSelfInput!) {
  userUpdateSelf(input: $input) {
    id
    firstName
    lastName
    phoneNumber
    email
    apartmentNumber
  }
}
    `;
export type UserUpdateSelfMutationFn = Apollo.MutationFunction<UserUpdateSelfMutation, UserUpdateSelfMutationVariables>;

/**
 * __useUserUpdateSelfMutation__
 *
 * To run a mutation, you first call `useUserUpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateSelfMutation, { data, loading, error }] = useUserUpdateSelfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateSelfMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateSelfMutation, UserUpdateSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateSelfMutation, UserUpdateSelfMutationVariables>(UserUpdateSelfDocument, options);
      }
export type UserUpdateSelfMutationHookResult = ReturnType<typeof useUserUpdateSelfMutation>;
export type UserUpdateSelfMutationResult = Apollo.MutationResult<UserUpdateSelfMutation>;
export type UserUpdateSelfMutationOptions = Apollo.BaseMutationOptions<UserUpdateSelfMutation, UserUpdateSelfMutationVariables>;